import * as i0 from '@angular/core';
import { input, output, Component, Input, computed, effect, ViewChild, signal, Inject, viewChild, EventEmitter, Output, ViewEncapsulation, PLATFORM_ID, Pipe, inject, ChangeDetectorRef, forwardRef, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import * as i1$1 from '@angular/material/bottom-sheet';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import * as i4 from '@digipay/ngx-button';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i5 from '@ng-select/ng-select';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import * as i2$1 from '@digipay/layout';
import moment from 'jalali-moment';
import * as i3 from '@digipay/ng-lib-pipes';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxIcon } from '@digipay/ngx-icon';
const _c0 = ["input"];
const _c1 = ["focusButton"];
const _c2 = ["textarea"];
const _c3 = ["*"];
const _c4 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) => ({
  "input-type-single-line": a0,
  "input-type-multi-line": a1,
  "dg-not-empty": a2,
  "dg-focused": a3,
  "dg-error": a4,
  "dg-cleanable": a5,
  "dg-trailed": a6,
  "dg-searchable": a7,
  "dg-ltr-input": a8,
  "dg-ltr-placeholder": a9,
  "dg-readonly": a10,
  "dg-lock": a11,
  "dg-field-warning": a12,
  "dg-leading-icon": a13
});
const _c5 = (a0, a1) => ({
  "dg-invalidation-icon": a0,
  "dg-validation-icon": a1
});
const _c6 = (a0, a1, a2, a3) => ({
  "dg-info-message": a0,
  "dg-hint-message": a1,
  "dg-info-star-message": a2,
  "dg-hint-star-message": a3
});
const _c7 = (a0, a1) => ({
  "dg-error-star-message": a0,
  "dg-error-message": a1
});
function DgInputComponent_ng_container_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.leadingIcon());
  }
}
function DgInputComponent_ng_container_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function DgInputComponent_ng_container_0_ng_container_6_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
  }
}
function DgInputComponent_ng_container_0_ng_container_6_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const input_r4 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c5, ctx_r1.isShowError, input_r4.value.length && !ctx_r1.isShowError));
  }
}
function DgInputComponent_ng_container_0_ng_container_6_ng_container_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("click", function DgInputComponent_ng_container_0_ng_container_6_ng_container_6_div_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.clean($event));
    });
    i0.ɵɵelementEnd();
  }
}
function DgInputComponent_ng_container_0_ng_container_6_ng_container_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.trailingIcon());
  }
}
function DgInputComponent_ng_container_0_ng_container_6_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DgInputComponent_ng_container_0_ng_container_6_ng_container_6_div_1_Template, 1, 0, "div", 22)(2, DgInputComponent_ng_container_0_ng_container_6_ng_container_6_Conditional_2_Template, 2, 1, "div", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasCleaner);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r1.trailingIcon() && !ctx_r1.hasCleaner ? 2 : -1);
  }
}
function DgInputComponent_ng_container_0_ng_container_6_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function DgInputComponent_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 14);
    i0.ɵɵelementStart(1, "input", 15, 1);
    i0.ɵɵlistener("focusin", function DgInputComponent_ng_container_0_ng_container_6_Template_input_focusin_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFocusIn());
    })("focusout", function DgInputComponent_ng_container_0_ng_container_6_Template_input_focusout_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r1.readonly && (ctx_r1.isFocused = false));
    })("keydown", function DgInputComponent_ng_container_0_ng_container_6_Template_input_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeyDown($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtemplate(4, DgInputComponent_ng_container_0_ng_container_6_div_4_Template, 1, 0, "div", 17)(5, DgInputComponent_ng_container_0_ng_container_6_div_5_Template, 1, 4, "div", 11)(6, DgInputComponent_ng_container_0_ng_container_6_ng_container_6_Template, 3, 2, "ng-container", 3);
    i0.ɵɵelement(7, "div", 18);
    i0.ɵɵtemplate(8, DgInputComponent_ng_container_0_ng_container_6_div_8_Template, 2, 0, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id)("placeholder", ctx_r1.placeholder || "")("formControlName", ctx_r1.formControlName)("type", ctx_r1.inputType)("readonly", ctx_r1.readonly || ctx_r1.lock)("autocomplete", ctx_r1.autoComplete || (ctx_r1.inputType === "password" ? "new-password" : "off"))("maxLength", ctx_r1.maxSize)("pattern", ctx_r1.inputPattern());
    i0.ɵɵattribute("inputmode", ctx_r1.inputMode);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.lock);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasValidationMark);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.lock);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasButton);
  }
}
function DgInputComponent_ng_container_0_ng_container_7_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
  }
}
function DgInputComponent_ng_container_0_ng_container_7_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const textarea_r7 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c5, ctx_r1.isShowError, textarea_r7.value.length && !ctx_r1.isShowError));
  }
}
function DgInputComponent_ng_container_0_ng_container_7_ng_container_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("click", function DgInputComponent_ng_container_0_ng_container_7_ng_container_6_div_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.clean($event));
    });
    i0.ɵɵelementEnd();
  }
}
function DgInputComponent_ng_container_0_ng_container_7_ng_container_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.trailingIcon());
  }
}
function DgInputComponent_ng_container_0_ng_container_7_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DgInputComponent_ng_container_0_ng_container_7_ng_container_6_div_1_Template, 1, 0, "div", 22)(2, DgInputComponent_ng_container_0_ng_container_7_ng_container_6_Conditional_2_Template, 2, 1, "div", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasCleaner);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r1.trailingIcon() && !ctx_r1.hasCleaner ? 2 : -1);
  }
}
function DgInputComponent_ng_container_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 14);
    i0.ɵɵelementStart(1, "textarea", 26, 2);
    i0.ɵɵlistener("focusin", function DgInputComponent_ng_container_0_ng_container_7_Template_textarea_focusin_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r1.readonly && (ctx_r1.isFocused = true));
    })("focusout", function DgInputComponent_ng_container_0_ng_container_7_Template_textarea_focusout_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(!ctx_r1.readonly && (ctx_r1.isFocused = false));
    })("keydown", function DgInputComponent_ng_container_0_ng_container_7_Template_textarea_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeyDown($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtemplate(4, DgInputComponent_ng_container_0_ng_container_7_div_4_Template, 1, 0, "div", 17)(5, DgInputComponent_ng_container_0_ng_container_7_div_5_Template, 1, 4, "div", 11)(6, DgInputComponent_ng_container_0_ng_container_7_ng_container_6_Template, 3, 2, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id)("rows", 3)("placeholder", ctx_r1.placeholder || "")("formControlName", ctx_r1.formControlName)("readonly", ctx_r1.readonly)("maxLength", ctx_r1.maxSize)("pattern", ctx_r1.isNumericKeyboard ? "[0-9]*" : "");
    i0.ɵɵattribute("inputmode", ctx_r1.inputMode);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.lock);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasValidationMark);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.lock);
  }
}
function DgInputComponent_ng_container_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(2, _c6, ctx_r1.hintStatus === "info" && !ctx_r1.hasHintStar, ctx_r1.hintStatus === "warning" && !ctx_r1.hasHintStar, ctx_r1.hintStatus === "info" && ctx_r1.hasHintStar, ctx_r1.hintStatus === "warning" && ctx_r1.hasHintStar));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hint, " ");
  }
}
function DgInputComponent_ng_container_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c7, ctx_r1.hasHintStar, !ctx_r1.hasHintStar));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
  }
}
function DgInputComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, DgInputComponent_ng_container_0_Conditional_2_Template, 2, 1, "div", 6);
    i0.ɵɵelementStart(3, "label", 7);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, DgInputComponent_ng_container_0_span_5_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, DgInputComponent_ng_container_0_ng_container_6_Template, 9, 14, "ng-container", 9)(7, DgInputComponent_ng_container_0_ng_container_7_Template, 7, 12, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, DgInputComponent_ng_container_0_div_8_Template, 2, 7, "div", 10)(9, DgInputComponent_ng_container_0_div_9_Template, 2, 5, "div", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunctionV(9, _c4, [!ctx_r1.multiLine, ctx_r1.multiLine, !!ctx_r1.form.controls[ctx_r1.formControlName].value, !!ctx_r1.isFocused, ctx_r1.isShowError, ctx_r1.hasCleaner && ctx_r1.inputType !== "search", ctx_r1.trailingIcon(), ctx_r1.inputType === "search", ctx_r1.ltrInput, ctx_r1.ltrPlaceholder, ctx_r1.readonly, ctx_r1.lock, ctx_r1.warning, ctx_r1.leadingIcon()]));
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r1.leadingIcon() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("htmlFor", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.multiLine);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.multiLine);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isShowError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isShowError);
  }
}
function DgSelectOptionItem_Conditional_2_Template(rf, ctx) {}
function DgSelectOptionItem_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DgSelectOptionItem_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DgSelectOptionItem_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.item().iconStart);
  }
}
function DgSelectOptionItem_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
}
function DgSelectOptionItem_Conditional_9_Template(rf, ctx) {}
function DgSelectOptionItem_Conditional_10_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DgSelectOptionItem_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DgSelectOptionItem_Conditional_10_ng_container_0_Template, 1, 0, "ng-container", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.item().iconEnd);
  }
}
function DgSelectOptionItem_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.item().caption);
  }
}
const _c8 = a0 => ({
  maxHeight: a0
});
const _c9 = (a0, a1) => ({
  "active-item": a0,
  "disabled-item": a1
});
function DgSelectBottomSheetComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function DgSelectBottomSheetComponent_Conditional_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵelementEnd();
  }
}
function DgSelectBottomSheetComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 10);
    i0.ɵɵlistener("clickHandler", function DgSelectBottomSheetComponent_Conditional_6_Template_ngx_button_clickHandler_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.confirm());
    });
    i0.ɵɵtext(1, " \u062A\u0627\u06CC\u06CC\u062F ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵstyleMap("link");
    i0.ɵɵproperty("size", "small");
  }
}
function DgSelectBottomSheetComponent_Conditional_7_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function DgSelectBottomSheetComponent_Conditional_7_Conditional_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearSearchInput());
    });
    i0.ɵɵelementEnd();
  }
}
function DgSelectBottomSheetComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "div", 11)(2, "input", 12);
    i0.ɵɵtemplate(3, DgSelectBottomSheetComponent_Conditional_7_Conditional_3_Template, 1, 0, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.searchInput);
    i0.ɵɵadvance();
    i0.ɵɵconditional(3, ctx_r1.searchInput.value ? 3 : -1);
  }
}
function DgSelectBottomSheetComponent_Conditional_9_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
  }
}
function DgSelectBottomSheetComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function DgSelectBottomSheetComponent_Conditional_9_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const select_r6 = i0.ɵɵreference(2);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectAll(select_r6.checked = !select_r6.checked));
    });
    i0.ɵɵelement(1, "input", 16, 0)(3, "div", 17);
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵtext(5, "\u0647\u0645\u0647");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, DgSelectBottomSheetComponent_Conditional_9_Conditional_6_Template, 1, 0, "div", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.selectedAll());
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(6, ctx_r1.data.isDivider ? 6 : -1);
  }
}
function DgSelectBottomSheetComponent_For_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
  }
}
function DgSelectBottomSheetComponent_For_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dg-select-option-item", 20);
    i0.ɵɵlistener("click", function DgSelectBottomSheetComponent_For_11_Template_dg_select_option_item_click_0_listener() {
      const item_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelected(item_r8));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, DgSelectBottomSheetComponent_For_11_Conditional_1_Template, 1, 0, "div", 19);
  }
  if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const $index_r9 = ctx.$index;
    const ɵ$index_42_r10 = ctx.$index;
    const ɵ$count_42_r11 = ctx.$count;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("option", item_r8)("item", item_r8)("index", $index_r9)("type", ctx_r1.inputType())("showRadio", ctx_r1.data.showRadio)("ngClass", i0.ɵɵpureFunction2(7, _c9, item_r8.selected, item_r8.disabled));
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.data.isDivider && !(ɵ$index_42_r10 === ɵ$count_42_r11 - 1) ? 1 : -1);
  }
}
function DgSelectBottomSheetComponent_ForEmpty_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.data.notFoundText);
  }
}
function DgSelectMultiLabel_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "div", 2);
    i0.ɵɵlistener("click", function DgSelectMultiLabel_For_2_Template_div_click_2_listener() {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearItem.emit(item_r2));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2.title, " ");
  }
}
const _c10 = ["selectElm"];
const _c11 = a0 => ({
  "is-divider": a0
});
const _c12 = (a0, a1, a2, a3, a4, a5) => ({
  "dg-not-empty": a0,
  "dg-error": a1,
  "dg-ltr-input": a2,
  "dg-ltr-placeholder": a3,
  "dg-readonly": a4,
  "dg-required": a5
});
const _c13 = a0 => ({
  placeholder: a0
});
function DgSelectComponent_Conditional_0_Conditional_4_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
}
function DgSelectComponent_Conditional_0_Conditional_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dg-select-option-item", 10);
    i0.ɵɵtemplate(1, DgSelectComponent_Conditional_0_Conditional_4_ng_template_0_Conditional_1_Template, 1, 0, "div", 11);
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    const item$_r4 = ctx.item$;
    const index_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("option", item$_r4)("item", item_r3)("index", index_r5);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.isDivider() && item$_r4.index !== ctx_r1.options().length - 1 ? 1 : -1);
  }
}
function DgSelectComponent_Conditional_0_Conditional_4_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dg-select-multi-label", 12);
    i0.ɵɵlistener("clearItem", function DgSelectComponent_Conditional_0_Conditional_4_ng_template_1_Template_dg_select_multi_label_clearItem_0_listener($event) {
      const clear_r7 = i0.ɵɵrestoreView(_r6).clear;
      return i0.ɵɵresetView(clear_r7($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const items_r8 = ctx.items;
    i0.ɵɵproperty("items", items_r8);
  }
}
function DgSelectComponent_Conditional_0_Conditional_4_Conditional_2_ng_template_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
}
function DgSelectComponent_Conditional_0_Conditional_4_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function DgSelectComponent_Conditional_0_Conditional_4_Conditional_2_ng_template_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const select_r10 = i0.ɵɵreference(2);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.selectAll(select_r10.checked = !select_r10.checked));
    });
    i0.ɵɵelement(1, "input", 14, 1)(3, "div", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵtext(5, "\u0647\u0645\u0647");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, DgSelectComponent_Conditional_0_Conditional_4_Conditional_2_ng_template_0_Conditional_6_Template, 1, 0, "div", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.selectedAll());
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(6, ctx_r1.isDivider() ? 6 : -1);
  }
}
function DgSelectComponent_Conditional_0_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DgSelectComponent_Conditional_0_Conditional_4_Conditional_2_ng_template_0_Template, 7, 2, "ng-template", 9);
  }
}
function DgSelectComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DgSelectComponent_Conditional_0_Conditional_4_ng_template_0_Template, 2, 4, "ng-template", 7)(1, DgSelectComponent_Conditional_0_Conditional_4_ng_template_1_Template, 1, 1, "ng-template", 8)(2, DgSelectComponent_Conditional_0_Conditional_4_Conditional_2_Template, 1, 0, null, 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(2, ctx_r1.hasSelectAll() ? 2 : -1);
  }
}
function DgSelectComponent_Conditional_0_Conditional_5_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
}
function DgSelectComponent_Conditional_0_Conditional_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dg-select-option-item", 17);
    i0.ɵɵtemplate(1, DgSelectComponent_Conditional_0_Conditional_5_ng_template_0_Conditional_1_Template, 1, 0, "div", 11);
  }
  if (rf & 2) {
    const item_r11 = ctx.item;
    const item$_r12 = ctx.item$;
    const index_r13 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("option", item$_r12)("item", item_r11)("index", index_r13)("showRadio", ctx_r1.showRadio())("breakIfOutOfLine", ctx_r1.breakIfOutOfLine());
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.isDivider() && item$_r12.index !== ctx_r1.options().length - 1 ? 1 : -1);
  }
}
function DgSelectComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DgSelectComponent_Conditional_0_Conditional_5_ng_template_0_Template, 2, 6, "ng-template", 7);
  }
}
function DgSelectComponent_Conditional_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hint, "");
  }
}
function DgSelectComponent_Conditional_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, "");
  }
}
function DgSelectComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "ng-select", 4, 0);
    i0.ɵɵlistener("search", function DgSelectComponent_Conditional_0_Template_ng_select_search_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.emitSearch($event));
    })("clear", function DgSelectComponent_Conditional_0_Template_ng_select_clear_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearEvent());
    })("click", function DgSelectComponent_Conditional_0_Template_ng_select_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openBottomSheet());
    });
    i0.ɵɵtemplate(4, DgSelectComponent_Conditional_0_Conditional_4_Template, 3, 1)(5, DgSelectComponent_Conditional_0_Conditional_5_Template, 1, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, DgSelectComponent_Conditional_0_div_6_Template, 2, 1, "div", 5)(7, DgSelectComponent_Conditional_0_div_7_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id)("ngClass", i0.ɵɵpureFunction1(23, _c11, ctx_r1.isDivider()));
    i0.ɵɵadvance();
    i0.ɵɵproperty("appendTo", ctx_r1.overflowToContainer() ? "body" : "")("placeholder", ctx_r1.label)("readonly", ctx_r1.readonly)("multiple", ctx_r1.multiSelect())("formControlName", ctx_r1.formControlName)("dropdownPosition", ctx_r1.dropdownPosition())("clearable", ctx_r1.hasCleaner)("searchable", ctx_r1.searchable() && !ctx_r1.isBottomSheet())("ngClass", i0.ɵɵpureFunction6(25, _c12, !!ctx_r1.form.controls[ctx_r1.formControlName].value, ctx_r1.isShowError && ctx_r1.bottomSheetSelectError(), ctx_r1.ltrInput, ctx_r1.ltrPlaceholder, ctx_r1.readonly, ctx_r1.required))("items", ctx_r1.options())("isOpen", ctx_r1.isOpen())("notFoundText", ctx_r1.notFoundText())("closeOnSelect", !ctx_r1.multiSelect())("selectableGroup", true)("selectableGroupAsModel", false)("clearSearchOnAdd", true)("inputAttrs", i0.ɵɵpureFunction1(32, _c13, ctx_r1.placeholder));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(4, ctx_r1.multiSelect() ? 4 : 5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isShowError || !ctx_r1.bottomSheetSelectError());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isShowError && ctx_r1.bottomSheetSelectError());
  }
}
function DgSlideToggleComponent_ng_container_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function DgSlideToggleComponent_ng_container_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.hint, "");
  }
}
function DgSlideToggleComponent_ng_container_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage, "");
  }
}
function DgSlideToggleComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, DgSlideToggleComponent_ng_container_0_span_4_Template, 2, 0, "span", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label");
    i0.ɵɵelement(6, "input", 3)(7, "div", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, DgSlideToggleComponent_ng_container_0_div_8_Template, 2, 1, "div", 5)(9, DgSlideToggleComponent_ng_container_0_div_9_Template, 2, 1, "div", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id)("formGroup", ctx_r0.form);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", ctx_r0.formControlName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.isShowError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isShowError);
  }
}
const _c14 = ["wheelSelect"];
const _c15 = a0 => ({
  "selected": a0
});
function DgWheelSelectComponent_ng_container_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function DgWheelSelectComponent_ng_container_0_div_4_Template_div_click_0_listener() {
      const i_r4 = i0.ɵɵrestoreView(_r3).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectItem(i_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c15, i_r4 === ctx_r1.selectedIndex));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5.title, " ");
  }
}
function DgWheelSelectComponent_ng_container_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hint, "");
  }
}
function DgWheelSelectComponent_ng_container_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, "");
  }
}
function DgWheelSelectComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3, 0);
    i0.ɵɵlistener("scroll", function DgWheelSelectComponent_ng_container_0_Template_div_scroll_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onScroll($event));
    });
    i0.ɵɵtemplate(4, DgWheelSelectComponent_ng_container_0_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, DgWheelSelectComponent_ng_container_0_div_5_Template, 2, 1, "div", 5)(6, DgWheelSelectComponent_ng_container_0_div_6_Template, 2, 1, "div", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isShowError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isShowError);
  }
}
function DatePickerComponent_date_picker_number_picker_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "date-picker-number-picker", 6);
    i0.ɵɵtwoWayListener("valueChange", function DatePickerComponent_date_picker_number_picker_2_Template_date_picker_number_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value.year, $event) || (ctx_r1.value.year = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function DatePickerComponent_date_picker_number_picker_2_Template_date_picker_number_picker_valueChange_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChangedCallback());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("value", ctx_r1.value.year);
    i0.ɵɵproperty("list", ctx_r1.lists.year);
  }
}
function DatePickerComponent_date_picker_number_picker_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "date-picker-number-picker", 6);
    i0.ɵɵtwoWayListener("valueChange", function DatePickerComponent_date_picker_number_picker_3_Template_date_picker_number_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value.month, $event) || (ctx_r1.value.month = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function DatePickerComponent_date_picker_number_picker_3_Template_date_picker_number_picker_valueChange_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChangedCallback());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("value", ctx_r1.value.month);
    i0.ɵɵproperty("list", ctx_r1.lists.month);
  }
}
function DatePickerComponent_date_picker_number_picker_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "date-picker-number-picker", 6);
    i0.ɵɵtwoWayListener("valueChange", function DatePickerComponent_date_picker_number_picker_4_Template_date_picker_number_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value.day, $event) || (ctx_r1.value.day = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function DatePickerComponent_date_picker_number_picker_4_Template_date_picker_number_picker_valueChange_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChangedCallback());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("value", ctx_r1.value.day);
    i0.ɵɵproperty("list", ctx_r1.lists.day);
  }
}
function DatePickerBottomSheetComponent_date_picker_number_picker_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "date-picker-number-picker", 6);
    i0.ɵɵtwoWayListener("valueChange", function DatePickerBottomSheetComponent_date_picker_number_picker_2_Template_date_picker_number_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value.year, $event) || (ctx_r1.value.year = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function DatePickerBottomSheetComponent_date_picker_number_picker_2_Template_date_picker_number_picker_valueChange_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChangedCallback());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("value", ctx_r1.value.year);
    i0.ɵɵproperty("list", ctx_r1.lists.year);
  }
}
function DatePickerBottomSheetComponent_date_picker_number_picker_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "date-picker-number-picker", 6);
    i0.ɵɵtwoWayListener("valueChange", function DatePickerBottomSheetComponent_date_picker_number_picker_3_Template_date_picker_number_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value.month, $event) || (ctx_r1.value.month = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function DatePickerBottomSheetComponent_date_picker_number_picker_3_Template_date_picker_number_picker_valueChange_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChangedCallback());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("value", ctx_r1.value.month);
    i0.ɵɵproperty("list", ctx_r1.lists.month);
  }
}
function DatePickerBottomSheetComponent_date_picker_number_picker_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "date-picker-number-picker", 6);
    i0.ɵɵtwoWayListener("valueChange", function DatePickerBottomSheetComponent_date_picker_number_picker_4_Template_date_picker_number_picker_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value.day, $event) || (ctx_r1.value.day = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function DatePickerBottomSheetComponent_date_picker_number_picker_4_Template_date_picker_number_picker_valueChange_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.valueChangedCallback());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("value", ctx_r1.value.day);
    i0.ɵɵproperty("list", ctx_r1.lists.day);
  }
}
const _c16 = ":root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:root .inverted{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark .inverted{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.date-picker-bottom-sheet{padding:0!important}.date-picker{display:flex;flex-direction:column}.date-picker .body{display:flex;flex-direction:row;padding:0 20px;justify-content:space-between;position:relative}.date-picker .number-picker{flex:30% 1 0;padding:0 1%;margin:0 4px}.date-picker .actions{padding:16px 24px;display:flex;justify-content:space-between;border-bottom:1px solid rgba(0,0,0,.1);direction:rtl}.date-picker .actions button{display:inline-block;width:calc(60% - 8px);flex:0 0 calc(40% - 8px);padding:13px 25px;background:#0040ff;color:#fff;border-radius:12px;border:1px solid transparent;font-size:1rem;cursor:pointer;text-align:center}.date-picker .actions .reject{border:none;background:none;color:#424c5c}.date-picker .actions .resolve:disabled{background:#e5e5e5;color:#b2b2b2}.date-picker .overlay{position:absolute;width:100%;height:24%;content:\" \";left:0}.date-picker .overlay.top{top:0;background:linear-gradient(to bottom,#f2f2f2 50%,#f2f2f2a8 70%,#f2f2f200)}.date-picker .overlay.bottom{bottom:0;background:linear-gradient(to top,#f2f2f2 50%,#f2f2f2a8 70%,#f2f2f200)}\n";
const _c17 = ["datePickerUi"];
const _c18 = ["datePickerBackdrop"];
const _c19 = (a0, a1) => ({
  "is-default": a0,
  "is-month-picker": a1
});
const _c20 = (a0, a1, a2, a3, a4) => ({
  "is-today": a0,
  "is-selected": a1,
  "is-selectable": a2,
  "is-future": a3,
  "is-disabled": a4
});
const _c21 = a0 => ({
  "is-disabled": a0
});
const _c22 = (a0, a1) => ({
  year: a0,
  month: a1,
  day: "01"
});
const _c23 = () => ({
  month: "",
  year: "",
  day: ""
});
function CalendarDatePickerComponent_div_4_div_1_span_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "span", 18);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_1_span_3_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.monthView());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 19);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_1_span_3_Template_span_click_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.yearView());
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.currentDate.locale("fa").format("MMMM"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.currentDate.locale("fa").format("YYYY"));
  }
}
function CalendarDatePickerComponent_div_4_div_1_div_35_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_1_div_35_span_1_Template_span_click_0_listener() {
      const day_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.dayClick(day_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(2, _c20, ctx_r2.today && day_r6 && ctx_r2.today.locale("fa").format("YYYY/MM/DD") === day_r6.format("YYYY/MM/DD"), ctx_r2.isSelectedDay(day_r6), !!day_r6, ctx_r2.today && day_r6 && day_r6.isAfter(ctx_r2.today), ctx_r2.isDisabledDay(day_r6)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(day_r6 ? day_r6.locale("fa").format("D") : "");
  }
}
function CalendarDatePickerComponent_div_4_div_1_div_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, CalendarDatePickerComponent_div_4_div_1_div_35_span_1_Template, 2, 8, "span", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", week_r7);
  }
}
function CalendarDatePickerComponent_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 11)(2, "span", 12);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_1_Template_span_click_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.nextMonth());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CalendarDatePickerComponent_div_4_div_1_span_3_Template, 5, 2, "span", 8);
    i0.ɵɵelementStart(4, "span", 13);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_1_Template_span_click_4_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.prevMonth());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 14)(6, "span");
    i0.ɵɵtext(7, "\u0634\u0646\u0628\u0647");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 15);
    i0.ɵɵtext(9, "\u0634");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11, "\u06CC\u06A9\u0634\u0646\u0628\u0647");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 15);
    i0.ɵɵtext(13, "\u06CC");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15, "\u062F\u0648\u0634\u0646\u0628\u0647");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "span", 15);
    i0.ɵɵtext(17, "\u062F");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "span");
    i0.ɵɵtext(19, "\u0633\u0647\u200C\u0634\u0646\u0628\u0647");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "span", 15);
    i0.ɵɵtext(21, "\u0633");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "span");
    i0.ɵɵtext(23, "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "span", 15);
    i0.ɵɵtext(25, "\u062C");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "span");
    i0.ɵɵtext(27, "\u067E\u0646\u062C\u0634\u0646\u0628\u0647");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "span", 15);
    i0.ɵɵtext(29, "\u067E");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "span");
    i0.ɵɵtext(31, "\u062C\u0645\u0639\u0647");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "span", 15);
    i0.ɵɵtext(33, "\u062C");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 16);
    i0.ɵɵtemplate(35, CalendarDatePickerComponent_div_4_div_1_div_35_Template, 2, 1, "div", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.currentDate);
    i0.ɵɵadvance(32);
    i0.ɵɵproperty("ngForOf", ctx_r2.weeks);
  }
}
function CalendarDatePickerComponent_div_4_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_2_div_1_Template_div_click_0_listener() {
      const month_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.monthClick(month_r9));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_7_0;
    const month_r9 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c21, ctx_r2.isDisabledMonth(month_r9)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ((tmp_7_0 = ctx_r2.datePickerConfig()) == null ? null : tmp_7_0.monthNumber) ? month_r9.locale("fa").format("MM") : month_r9.locale("fa").format("MMMM"), " ");
  }
}
function CalendarDatePickerComponent_div_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, CalendarDatePickerComponent_div_4_div_2_div_1_Template, 3, 4, "div", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.monthList);
  }
}
function CalendarDatePickerComponent_div_4_div_3_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_3_div_7_Template_div_click_0_listener() {
      const year_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.yearClick(year_r12));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const year_r12 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c21, ctx_r2.isDisabledYear(year_r12)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(year_r12);
  }
}
function CalendarDatePickerComponent_div_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 11)(2, "span", 12);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_3_Template_span_click_2_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.prevYears());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 13);
    i0.ɵɵlistener("click", function CalendarDatePickerComponent_div_4_div_3_Template_span_click_5_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.nextYears());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 27);
    i0.ɵɵtemplate(7, CalendarDatePickerComponent_div_4_div_3_div_7_Template, 3, 4, "div", 28);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.years[ctx_r2.years.length - 1], " - ", ctx_r2.years[0], " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.years);
  }
}
function CalendarDatePickerComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, CalendarDatePickerComponent_div_4_div_1_Template, 36, 2, "div", 8)(2, CalendarDatePickerComponent_div_4_div_2_Template, 2, 1, "div", 9)(3, CalendarDatePickerComponent_div_4_div_3_Template, 8, 3, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.view === "days");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.view === "months");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.view === "years");
  }
}
function CalendarDatePickerComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "date-picker", 31);
    i0.ɵɵlistener("close", function CalendarDatePickerComponent_div_5_Template_date_picker_close_1_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.monthPickerClose($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2.selectedDate ? i0.ɵɵpureFunction2(2, _c22, ctx_r2.selectedDate.locale("fa").format("YYYY"), ctx_r2.selectedDate.locale("fa").format("MM")) : i0.ɵɵpureFunction0(5, _c23))("datePickerConfig", ctx_r2.datePickerConfig());
  }
}
function CalendarDatePickerComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32)(1, "input", 33);
    i0.ɵɵlistener("blur", function CalendarDatePickerComponent_div_6_Template_input_blur_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.setTime($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarDatePickerComponent_div_6_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.timeHour, $event) || (ctx_r2.timeHour = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 34);
    i0.ɵɵlistener("blur", function CalendarDatePickerComponent_div_6_Template_input_blur_4_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.setTime($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarDatePickerComponent_div_6_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.timeMinute, $event) || (ctx_r2.timeMinute = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6, ":");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "input", 35);
    i0.ɵɵlistener("blur", function CalendarDatePickerComponent_div_6_Template_input_blur_7_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.setTime($event));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function CalendarDatePickerComponent_div_6_Template_input_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.timeSecond, $event) || (ctx_r2.timeSecond = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timeHour);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timeMinute);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.timeSecond);
  }
}
const _c24 = ["dateInput"];
const _c25 = (a0, a1, a2, a3, a4, a5, a6) => ({
  "dg-not-empty": a0,
  "dg-focused": a1,
  "dg-error": a2,
  "dg-cleanable": a3,
  "dg-ltr-input": a4,
  "dg-ltr-placeholder": a5,
  "dg-readonly": a6
});
function DgDateComponent_ng_container_0_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function DgDateComponent_ng_container_0_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.hint, "");
  }
}
function DgDateComponent_ng_container_0_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.errorMessage, "");
  }
}
function DgDateComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 5)(3, "label", 6);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, DgDateComponent_ng_container_0_span_5_Template, 2, 0, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(6, 8);
    i0.ɵɵelementStart(7, "input", 9, 1);
    i0.ɵɵpipe(9, "persianDate");
    i0.ɵɵpipe(10, "persianDate");
    i0.ɵɵlistener("focusin", function DgDateComponent_ng_container_0_Template_input_focusin_7_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isFocused = true);
    })("focusout", function DgDateComponent_ng_container_0_Template_input_focusout_7_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isFocused = false);
    })("click", function DgDateComponent_ng_container_0_Template_input_click_7_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleDatePicker());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(11, "div", 10);
    i0.ɵɵlistener("click", function DgDateComponent_ng_container_0_Template_div_click_11_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clean($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, DgDateComponent_ng_container_0_div_12_Template, 2, 1, "div", 11)(13, DgDateComponent_ng_container_0_div_13_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 4)(15, "ui-calendar-date-picker", 13);
    i0.ɵɵlistener("pick", function DgDateComponent_ng_container_0_Template_ui_calendar_date_picker_pick_15_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.setDate($event));
    })("close", function DgDateComponent_ng_container_0_Template_ui_calendar_date_picker_close_15_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleDatePicker());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const dateInput_r4 = i0.ɵɵreference(8);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(26, _c25, !!ctx_r2.form.controls[ctx_r2.formControlName].value, !!ctx_r2.isFocused, ctx_r2.isShowError, ctx_r2.hasCleaner, ctx_r2.ltrInput, ctx_r2.ltrPlaceholder, ctx_r2.readonly));
    i0.ɵɵadvance();
    i0.ɵɵproperty("htmlFor", ctx_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id)("placeholder", ctx_r2.placeholder || "")("readonly", true)("value", ctx_r2.form.value[ctx_r2.formControlName] && (ctx_r2.showTime ? i0.ɵɵpipeBind2(9, 20, ctx_r2.form.value[ctx_r2.formControlName], "D_HMS") : i0.ɵɵpipeBind2(10, 23, ctx_r2.form.value[ctx_r2.formControlName], ctx_r2.pickersPipeArgs())));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r2.isShowError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isShowError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visible", ctx_r2.visibleDatePicker)("value", ctx_r2.form.value[ctx_r2.formControlName])("allowFuture", ctx_r2.dateRange !== "past")("justFuture", ctx_r2.dateRange === "future")("input", dateInput_r4)("initialView", ctx_r2.initialCalendarView)("checkCallback", ctx_r2.dateValidator.bind(ctx_r2))("showTime", ctx_r2.showTime)("datePickerConfig", ctx_r2.datePickerConfig());
  }
}
const _c26 = "[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dg-input-wrapper[_ngcontent-%COMP%]{width:100%;height:56px;border:1px solid #C9CBCF;background-color:#fff;border-radius:12px;position:relative;overflow:hidden;transition:all .3s}.dg-input-wrapper.input-type-single-line[_ngcontent-%COMP%]{height:56px}.dg-input-wrapper.input-type-multi-line[_ngcontent-%COMP%]{height:120px}.dg-input-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:absolute;top:22px;right:10px;margin:0;color:#000;font-size:14px;line-height:1;transition:all .3s;z-index:1}.dg-input-wrapper[_ngcontent-%COMP%]   label.float-top[_ngcontent-%COMP%], .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{top:11px;right:10px;font-size:10px;line-height:1}.dg-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{display:block;width:100%;background-color:transparent;border:1px solid transparent;padding:22px 10px 8px;height:100%;font-size:14px;line-height:20px;direction:rtl;text-align:right}.dg-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:rtl;text-align:right;transition:all .3s;opacity:0;font-size:14px;line-height:20px;color:#74777c}.dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{resize:none}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-leading-icon[_ngcontent-%COMP%]{position:absolute;top:10px;right:10px;width:36px;height:36px;padding:8px;background-color:#f2f3f6d9;border-radius:8px}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-validation-icon[_ngcontent-%COMP%]{width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M17.5 10C17.5 5.85757 14.1424 2.5 10 2.5C5.85757 2.5 2.5 5.85757 2.5 10C2.5 14.1416 5.85757 17.5 10 17.5C14.1424 17.5 17.5 14.1416 17.5 10Z\" stroke=\"%2300C958\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M7.11255 10.0002L9.03742 11.9242L12.8855 8.07617\" stroke=\"%2300C958\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-invalidation-icon[_ngcontent-%COMP%]{width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M17.5 10C17.5 5.85757 14.1424 2.5 10 2.5C5.85757 2.5 2.5 5.85757 2.5 10C2.5 14.1416 5.85757 17.5 10 17.5C14.1424 17.5 17.5 14.1416 17.5 10Z\" stroke=\"%23F9441F\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M9.99683 6.92218V10.5051M9.99999 13.1181V13.0784\" stroke=\"%23F9441F\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:none;width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<g clip-path=\"url(%23clip0_13718_450)\">%0D%0A<mask id=\"mask0_13718_450\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\">%0D%0A<path d=\"M5 5L15 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M15 5L5 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</mask>%0D%0A<g mask=\"url(%23mask0_13718_450)\">%0D%0A<rect width=\"20\" height=\"20\" fill=\"black\"/>%0D%0A</g>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_13718_450\">%0D%0A<rect width=\"20\" height=\"20\" fill=\"white\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-search-icon[_ngcontent-%COMP%]{display:none;width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.48999 14.71V15.5L5.1971 19.7843C4.80646 20.1742 4.17384 20.1738 3.78359 19.7836L3.70639 19.7064C3.31614 19.3162 3.31583 18.6835 3.70568 18.2929L7.98999 14H8.77999L9.05999 13.73C8.07999 12.59 7.48999 11.11 7.48999 9.5C7.48999 5.91 10.4 3 13.99 3C17.58 3 20.49 5.91 20.49 9.5C20.49 13.09 17.58 16 13.99 16C12.38 16 10.9 15.41 9.75999 14.43L9.48999 14.71ZM13.99 5C11.5 5 9.48999 7.01 9.48999 9.5C9.48999 11.99 11.5 14 13.99 14C16.48 14 18.49 11.99 18.49 9.5C18.49 7.01 16.48 5 13.99 5Z\" fill=\"%232C3544\"/>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-trailing-icon[_ngcontent-%COMP%]{display:none;width:36px;height:36px;padding:8px;background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-lock-icon[_ngcontent-%COMP%]{display:block;width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<g id=\"Lock\">%0D%0A<path id=\"Vector\" d=\"M10 12.0732V13.8068\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path id=\"Vector_2\" d=\"M13.7064 8.33358V6.65678C13.6813 4.69118 12.0003 3.11758 9.95342 3.14238C7.94807 3.16638 6.32632 4.71678 6.29224 6.64078V8.33358\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path id=\"Vector_3\" d=\"M7.75313 17.5775H12.2463C13.5758 17.5775 14.2405 17.5775 14.7536 17.3407C15.2658 17.1047 15.679 16.7079 15.925 16.2167C16.1713 15.7239 16.1713 15.0855 16.1713 13.8095V12.1039C16.1713 10.8279 16.1713 10.1895 15.925 9.69754C15.679 9.20554 15.2658 8.80874 14.7536 8.57274C14.2405 8.33594 13.5758 8.33594 12.2463 8.33594H7.75313C6.42371 8.33594 5.75896 8.33594 5.24596 8.57274C4.73362 8.80874 4.32046 9.20554 4.07446 9.69754C3.82812 10.1895 3.82812 10.8279 3.82812 12.1039V13.8095C3.82812 15.0855 3.82812 15.7239 4.07446 16.2167C4.32046 16.7079 4.73362 17.1047 5.24596 17.3407C5.75896 17.5775 6.42371 17.5775 7.75313 17.5775Z\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</g>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-input-button[_ngcontent-%COMP%]:empty{display:none}.dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:rtl;text-align:right}.dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:ltr;text-align:left}.dg-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:ltr;text-align:left}.dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#fff}.dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#000}.dg-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]{padding-left:36px}.dg-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:block}.dg-input-wrapper.dg-trailed[_ngcontent-%COMP%]{padding-left:36px}.dg-input-wrapper.dg-trailed[_ngcontent-%COMP%]   .dg-trailing-icon[_ngcontent-%COMP%]{display:block}.dg-input-wrapper.dg-focused[_ngcontent-%COMP%]{border-color:#1159fc;background-color:#deedff}.dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#74777c}.dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{opacity:1}.dg-input-wrapper.dg-error[_ngcontent-%COMP%]{border-color:#f9441f;background-color:#fff}.dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#f2f3f6}.dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{color:#b4b7bd;background-color:#f2f3f6}.dg-input-wrapper.dg-lock[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#f2f3f6}.dg-input-wrapper.dg-lock[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-lock[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-lock[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{color:#74777c;background-color:#f2f3f6}.dg-input-wrapper.dg-searchable[_ngcontent-%COMP%]{padding-left:36px}.dg-input-wrapper.dg-searchable[_ngcontent-%COMP%]   .dg-search-icon[_ngcontent-%COMP%]{display:block}.dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label.float-top[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   .dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{right:54px}.dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{padding-right:54px}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-input-actions-wrapper[_ngcontent-%COMP%]{display:flex;gap:8px;position:absolute;top:10px;left:10px}";
const _c27 = () => ({
  standalone: true
});
const _c28 = (a0, a1) => ({
  "rial": a0,
  "toman": a1
});
function DgAmountComponent_ng_container_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function DgAmountComponent_ng_container_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c28, ctx_r2.currencyUnit === "rial", ctx_r2.currencyUnit === "toman"));
  }
}
function DgAmountComponent_ng_container_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.hint, "");
  }
}
function DgAmountComponent_ng_container_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.errorMessage, "");
  }
}
function DgAmountComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, DgAmountComponent_ng_container_0_span_4_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(5, 7);
    i0.ɵɵelementStart(6, "input", 8, 1);
    i0.ɵɵlistener("focusin", function DgAmountComponent_ng_container_0_Template_input_focusin_6_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isFocused = true);
    })("focusout", function DgAmountComponent_ng_container_0_Template_input_focusout_6_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isFocused = false);
    })("ngModelChange", function DgAmountComponent_ng_container_0_Template_input_ngModelChange_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.inputChangeHandler($event));
    })("keydown", function DgAmountComponent_ng_container_0_Template_input_keydown_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.amountKeyDown($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(8, DgAmountComponent_ng_container_0_Conditional_8_Template, 1, 4, "div", 9);
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵlistener("click", function DgAmountComponent_ng_container_0_Template_div_click_9_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clean($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, DgAmountComponent_ng_container_0_div_10_Template, 2, 1, "div", 11)(11, DgAmountComponent_ng_container_0_div_11_Template, 2, 1, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(14, _c25, !!ctx_r2.form.controls[ctx_r2.formControlName].value, !!ctx_r2.isFocused, ctx_r2.isShowError, ctx_r2.hasCleaner, ctx_r2.ltrInput, ctx_r2.ltrPlaceholder, ctx_r2.readonly));
    i0.ɵɵadvance();
    i0.ɵɵproperty("htmlFor", ctx_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r2.id)("placeholder", ctx_r2.placeholder || "")("ngModel", ctx_r2.virtualValue)("maxLength", ctx_r2.maxSize)("ngModelOptions", i0.ɵɵpureFunction0(22, _c27))("readonly", ctx_r2.readonly);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(8, !ctx_r2.hasRialStickyText() ? 8 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isShowError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isShowError);
  }
}
const _c29 = (a0, a1, a2, a3, a4, a5, a6, a7) => ({
  "dg-not-empty": a0,
  "dg-focused": a1,
  "dg-error": a2,
  "dg-cleanable": a3,
  "dg-ltr-input": a4,
  "dg-ltr-placeholder": a5,
  "dg-readonly": a6,
  "dg-not-have-label": a7
});
function DgIbanComponent_ng_container_0_label_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function DgIbanComponent_ng_container_0_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, DgIbanComponent_ng_container_0_label_2_span_2_Template, 2, 0, "span", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("htmlFor", ctx_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.required);
  }
}
function DgIbanComponent_ng_container_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.hint, "");
  }
}
function DgIbanComponent_ng_container_0_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.errorMessage, "");
  }
}
function DgIbanComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtemplate(2, DgIbanComponent_ng_container_0_label_2_Template, 3, 3, "label", 5);
    i0.ɵɵelementContainerStart(3, 6);
    i0.ɵɵelementStart(4, "div")(5, "input", 7, 1);
    i0.ɵɵlistener("ngModelChange", function DgIbanComponent_ng_container_0_Template_input_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.inputChangeHandler($event));
    })("focusin", function DgIbanComponent_ng_container_0_Template_input_focusin_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onFocusIn());
    })("focusout", function DgIbanComponent_ng_container_0_Template_input_focusout_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onFocusOut());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵelement(8, "div", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DgIbanComponent_ng_container_0_div_9_Template, 2, 1, "div", 10)(10, DgIbanComponent_ng_container_0_div_10_Template, 2, 1, "div", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction8(11, _c29, !!ctx_r2.form.controls[ctx_r2.formControlName].value, !!ctx_r2.isFocused, ctx_r2.isShowError, ctx_r2.hasCleaner, ctx_r2.ltrInput, ctx_r2.ltrPlaceholder, ctx_r2.readonly, !ctx_r2.label));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r2.id)("placeholder", ctx_r2.placeholder || "")("maxLength", 33)("ngModel", ctx_r2.virtualValue)("ngModelOptions", i0.ɵɵpureFunction0(20, _c27))("readonly", ctx_r2.readonly);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.isShowError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isShowError);
  }
}
const _c30 = (a0, a1) => ({
  "dg-readonly": a0,
  "dg-focused": a1
});
const _c31 = a0 => ({
  "has-error": a0
});
function DgLargeAmountComponent_ng_container_0_ng_container_12_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "IRR");
    i0.ɵɵpipe(3, "IRR");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c31, ctx_r2.rangeError));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("\u0645\u0628\u0644\u063A \u0628\u0627\u06CC\u062F \u0628\u06CC\u0646 ", i0.ɵɵpipeBind2(2, 3, ctx_r2.minAmount, "hideRial"), " \u062A\u0627 ", i0.ɵɵpipeBind2(3, 6, ctx_r2.maxAmount, "hideRial"), " \u0631\u06CC\u0627\u0644 \u0628\u0627\u0634\u062F ");
  }
}
function DgLargeAmountComponent_ng_container_0_ng_container_12_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1, " \u0645\u0628\u0644\u063A \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F. ");
    i0.ɵɵelementEnd();
  }
}
function DgLargeAmountComponent_ng_container_0_ng_container_12_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.convertorValue, " ");
  }
}
function DgLargeAmountComponent_ng_container_0_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DgLargeAmountComponent_ng_container_0_ng_container_12_span_1_Template, 4, 11, "span", 12)(2, DgLargeAmountComponent_ng_container_0_ng_container_12_span_2_Template, 2, 0, "span", 13)(3, DgLargeAmountComponent_ng_container_0_ng_container_12_span_3_Template, 2, 1, "span", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.maxAmount !== 0 && (!ctx_r2.virtualValue || ctx_r2.virtualValue.length === 0 || ctx_r2.virtualValue === "0" || !ctx_r2.convertorValue));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.maxAmount === 0 && (!ctx_r2.virtualValue || ctx_r2.virtualValue.length === 0 || ctx_r2.virtualValue === "0"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.convertorValue);
  }
}
function DgLargeAmountComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 5);
    i0.ɵɵlistener("click", function DgLargeAmountComponent_ng_container_0_Template_label_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.wrapperClick());
    });
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3, "\u0631\u06CC\u0627\u0644");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(4, 7);
    i0.ɵɵelementStart(5, "input", 8, 1);
    i0.ɵɵlistener("paste", function DgLargeAmountComponent_ng_container_0_Template_input_paste_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputPaste($event));
    })("keydown", function DgLargeAmountComponent_ng_container_0_Template_input_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputKeyDown($event));
    })("focusin", function DgLargeAmountComponent_ng_container_0_Template_input_focusin_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isFocused = true);
    })("focusout", function DgLargeAmountComponent_ng_container_0_Template_input_focusout_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isFocused = false);
    })("ngModelChange", function DgLargeAmountComponent_ng_container_0_Template_input_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onValueChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 9)(8, "div", 10, 2);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 11);
    i0.ɵɵtemplate(12, DgLargeAmountComponent_ng_container_0_ng_container_12_Template, 4, 3, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const valuePlaceholder_r4 = i0.ɵɵreference(9);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c30, ctx_r2.readonly, !!ctx_r2.isFocused));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", valuePlaceholder_r4.scrollWidth + "px");
    i0.ɵɵproperty("ngModel", ctx_r2.virtualValue)("placeholder", ctx_r2.placeholder)("maxlength", ctx_r2.maxSize ? ctx_r2.maxSize : null)("ngModelOptions", i0.ɵɵpureFunction0(14, _c27))("readonly", ctx_r2.readonly);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.virtualValue, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.minAmount && ctx_r2.maxAmount);
  }
}
function DgCardNumberComponent_ng_container_0_label_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function DgCardNumberComponent_ng_container_0_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 11);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, DgCardNumberComponent_ng_container_0_label_2_span_2_Template, 2, 0, "span", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("htmlFor", ctx_r2.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.required);
  }
}
function DgCardNumberComponent_ng_container_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.hint, "");
  }
}
function DgCardNumberComponent_ng_container_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.errorMessage, "");
  }
}
function DgCardNumberComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtemplate(2, DgCardNumberComponent_ng_container_0_label_2_Template, 3, 3, "label", 5);
    i0.ɵɵelementContainerStart(3, 6);
    i0.ɵɵelementStart(4, "div")(5, "input", 7, 1);
    i0.ɵɵlistener("ngModelChange", function DgCardNumberComponent_ng_container_0_Template_input_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.inputChangeHandler($event));
    })("focusin", function DgCardNumberComponent_ng_container_0_Template_input_focusin_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(!ctx_r2.readonly && (ctx_r2.isFocused = true));
    })("focusout", function DgCardNumberComponent_ng_container_0_Template_input_focusout_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(!ctx_r2.readonly && (ctx_r2.isFocused = false));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵlistener("click", function DgCardNumberComponent_ng_container_0_Template_div_click_7_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clean($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, DgCardNumberComponent_ng_container_0_div_8_Template, 2, 1, "div", 9)(9, DgCardNumberComponent_ng_container_0_div_9_Template, 2, 1, "div", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction8(11, _c29, !!ctx_r2.form.controls[ctx_r2.formControlName].value, !!ctx_r2.isFocused, ctx_r2.isShowError, ctx_r2.hasCleaner, ctx_r2.ltrInput, ctx_r2.ltrPlaceholder, ctx_r2.readonly, !ctx_r2.label));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r2.id)("placeholder", ctx_r2.placeholder || "")("maxLength", 19)("ngModel", ctx_r2.virtualValue)("ngModelOptions", i0.ɵɵpureFunction0(20, _c27))("readonly", ctx_r2.readonly);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.isShowError);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isShowError);
  }
}
function FormFieldComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "app-dg-input", 2);
    i0.ɵɵlistener("cleanEvent", function FormFieldComponent_ng_container_1_Template_app_dg_input_cleanEvent_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearEvent());
    });
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("hasHintStar", ctx_r1.hasHintStar)("hintStatus", ctx_r1.hintStatus)("hasValidationMark", ctx_r1.hasValidationMark)("hasButton", ctx_r1.hasButton)("placeholder", ctx_r1.placeholder)("errorMessage", ctx_r1.finalErrorMessage)("lock", ctx_r1.lock)("leadingIcon", ctx_r1.leadingIcon())("trailingIcon", ctx_r1.trailingIcon())("readonly", ctx_r1.readonly || ctx_r1.lock)("multiLine", ctx_r1.multiLine)("inputType", ctx_r1.inputType)("hasCleaner", ctx_r1.hasCleaner)("ltrInput", ctx_r1.ltrInput)("ltrPlaceholder", ctx_r1.ltrPlaceholder)("maxSize", ctx_r1.maxSize)("autoComplete", ctx_r1.autoComplete)("isNumericKeyboard", !!ctx_r1.isNumericKeyboard)("required", ctx_r1.required)("convertNonEnglishDigits", !!ctx_r1.convertNonEnglishDigits)("showError", ctx_r1.showError)("allowedKeyDown", ctx_r1.allowedKeyDown)("autoFocus", ctx_r1.autoFocus())("pattern", ctx_r1.pattern());
  }
}
function FormFieldComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-dg-amount", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("placeholder", ctx_r1.placeholder)("errorMessage", ctx_r1.finalErrorMessage)("readonly", ctx_r1.readonly)("hasCleaner", ctx_r1.hasCleaner)("ltrInput", ctx_r1.ltrInput)("ltrPlaceholder", ctx_r1.ltrPlaceholder)("maxSize", ctx_r1.maxSize)("required", ctx_r1.required)("showError", ctx_r1.showError)("autoFocus", ctx_r1.autoFocus())("currencyUnit", ctx_r1.unitCurrency)("hasRialStickyText", ctx_r1.hasRialStickyText());
  }
}
function FormFieldComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-dg-large-amount", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("minAmount", ctx_r1.minAmount)("maxAmount", ctx_r1.maxAmount)("maxSize", ctx_r1.maxSize)("readonly", ctx_r1.readonly)("showError", ctx_r1.showError)("autoFocus", ctx_r1.autoFocus());
  }
}
function FormFieldComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-dg-iban", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("placeholder", ctx_r1.placeholder)("errorMessage", ctx_r1.finalErrorMessage)("readonly", ctx_r1.readonly)("hasCleaner", ctx_r1.hasCleaner)("ltrInput", ctx_r1.ltrInput)("ltrPlaceholder", ctx_r1.ltrPlaceholder)("required", ctx_r1.required)("showError", ctx_r1.showError)("autoFocus", ctx_r1.autoFocus());
  }
}
function FormFieldComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-dg-card-number", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("placeholder", ctx_r1.placeholder)("errorMessage", ctx_r1.finalErrorMessage)("readonly", ctx_r1.readonly)("hasCleaner", ctx_r1.hasCleaner)("ltrInput", ctx_r1.ltrInput)("ltrPlaceholder", ctx_r1.ltrPlaceholder)("required", ctx_r1.required)("showError", ctx_r1.showError)("autoFocus", ctx_r1.autoFocus());
  }
}
function FormFieldComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "app-dg-select", 6);
    i0.ɵɵlistener("searchOptionsSelect", function FormFieldComponent_ng_container_6_Template_app_dg_select_searchOptionsSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.emitSearch($event));
    })("cleanEvent", function FormFieldComponent_ng_container_6_Template_app_dg_select_cleanEvent_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearEvent());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("placeholder", ctx_r1.placeholder)("errorMessage", ctx_r1.finalErrorMessage)("readonly", ctx_r1.readonly)("multiSelect", ctx_r1.multiSelect)("options", ctx_r1.options)("hasCleaner", ctx_r1.hasCleaner)("ltrInput", ctx_r1.ltrInput)("ltrPlaceholder", ctx_r1.ltrPlaceholder)("required", ctx_r1.required)("searchable", ctx_r1.searchable)("showError", ctx_r1.showError)("notFoundText", ctx_r1.notFoundText)("selectOpenType", ctx_r1.selectOpenType())("isDivider", ctx_r1.isDividerOptions())("showRadio", ctx_r1.showRadioOptions())("dropdownPosition", ctx_r1.dropdownPosition())("hasSelectAll", ctx_r1.hasSelectAll())("bottomSheetCloseBtn", ctx_r1.selectBottomSheetCloseBtn())("bottomSheetMaxHeight", ctx_r1.selectBottomSheetMaxHeight())("overflowToContainer", ctx_r1.overflowToContainer)("autoFocus", ctx_r1.autoFocus())("breakIfOutOfLine", ctx_r1.selectBreakIfOutOfLine());
  }
}
function FormFieldComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-dg-wheel-select", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("placeholder", ctx_r1.placeholder)("errorMessage", ctx_r1.finalErrorMessage)("readonly", ctx_r1.readonly)("options", ctx_r1.options)("hasCleaner", ctx_r1.hasCleaner)("ltrInput", ctx_r1.ltrInput)("ltrPlaceholder", ctx_r1.ltrPlaceholder)("required", ctx_r1.required)("showError", ctx_r1.showError);
  }
}
function FormFieldComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-dg-slide-toggle", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("required", ctx_r1.required)("showError", ctx_r1.showError);
  }
}
function FormFieldComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-dg-date", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r1.form)("label", ctx_r1.label)("hint", ctx_r1.hint)("placeholder", ctx_r1.placeholder)("errorMessage", ctx_r1.finalErrorMessage)("readonly", ctx_r1.readonly)("hasCleaner", ctx_r1.hasCleaner)("ltrInput", ctx_r1.ltrInput)("ltrPlaceholder", ctx_r1.ltrPlaceholder)("showTime", ctx_r1.type === "date-time")("endPicker", ctx_r1.type === "date-end")("datePickerMode", ctx_r1.datePickerMode)("dateRange", ctx_r1.dateRange)("customDateRange", ctx_r1.customDateRange || undefined)("required", ctx_r1.required)("showError", ctx_r1.showError)("autoFocus", ctx_r1.autoFocus())("initialCalendarView", ctx_r1.initialCalendarView)("datePickerConfig", ctx_r1.datePickerConfig());
  }
}
let BaseFieldType = /*#__PURE__*/(() => {
  class BaseFieldType {
    constructor() {
      this.formControlName = 'input';
      this.label = '';
      this.leadingIcon = input();
      this.hasRialStickyText = input(false);
      this.hint = '';
      this.hintStatus = 'warning';
      this.hasHintStar = false;
      this.hasValidationMark = false;
      this.hasButton = false;
      this.placeholder = '';
      this.readonly = false;
      this.lock = false;
      this.hasCleaner = false;
      this.trailingIcon = input();
      this.ltrInput = false;
      this.ltrPlaceholder = false;
      this.required = false;
      this.autoFocus = input();
      this.pattern = input();
      this.cleanEvent = output();
    }
    get isShowError() {
      return this.form.touched && this.form.invalid && this.showError === 'auto' || this.form.invalid && this.showError === 'show';
    }
    clean($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.stopImmediatePropagation();
      if (this.form) {
        this.form.controls[this.formControlName].setValue(null);
        this.cleanEvent.emit();
      }
    }
    static {
      this.ɵfac = function BaseFieldType_Factory(t) {
        return new (t || BaseFieldType)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseFieldType,
        selectors: [["base-uploader"]],
        inputs: {
          form: "form",
          formControlName: "formControlName",
          label: "label",
          leadingIcon: [i0.ɵɵInputFlags.SignalBased, "leadingIcon"],
          hasRialStickyText: [i0.ɵɵInputFlags.SignalBased, "hasRialStickyText"],
          hint: "hint",
          hintStatus: "hintStatus",
          hasHintStar: "hasHintStar",
          hasValidationMark: "hasValidationMark",
          hasButton: "hasButton",
          placeholder: "placeholder",
          errorMessage: "errorMessage",
          readonly: "readonly",
          lock: "lock",
          hasCleaner: "hasCleaner",
          trailingIcon: [i0.ɵɵInputFlags.SignalBased, "trailingIcon"],
          ltrInput: "ltrInput",
          ltrPlaceholder: "ltrPlaceholder",
          required: "required",
          showError: "showError",
          autoFocus: [i0.ɵɵInputFlags.SignalBased, "autoFocus"],
          pattern: [i0.ɵɵInputFlags.SignalBased, "pattern"]
        },
        outputs: {
          cleanEvent: "cleanEvent"
        },
        decls: 0,
        vars: 0,
        template: function BaseFieldType_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return BaseFieldType;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const convertNonEnglishDigits = input => {
  const map = {
    // arabic
    1632: '0',
    1633: '1',
    1634: '2',
    1635: '3',
    1636: '4',
    1637: '5',
    1638: '6',
    1639: '7',
    1640: '8',
    1641: '9',
    // persian
    1776: '0',
    1777: '1',
    1778: '2',
    1779: '3',
    1780: '4',
    1781: '5',
    1782: '6',
    1783: '7',
    1784: '8',
    1785: '9'
  };
  const numbers = ('' + input).split('');
  for (let i = 0; i < numbers.length; i++) {
    if (map.hasOwnProperty(numbers[i].charCodeAt(0))) {
      numbers[i] = map[numbers[i].charCodeAt(0)];
    }
  }
  return numbers.join('');
};
const priceFormat = (input, separator = '٬') => {
  if (!input) {
    return '';
  }
  const num = typeof input === 'string' ? parseInt(input, 10) : input;
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
function removeAllNonNumericCharacters(val) {
  const reg = new RegExp(/([^0-9]+)/g);
  if (!val) {
    return '';
  }
  return ('' + val).replace(reg, '');
}
const powToStr = [{
  pow: 9,
  label: ' میلیارد'
}, {
  pow: 6,
  label: ' میلیون'
}, {
  pow: 3,
  label: ' هزار'
}];
const tenPow = pow => {
  return Math.pow(10, +pow);
};
const separator = ' و ';
const specialNumbers = {
  1: 'یک'
};
const tinyNumbers = input => {
  if (input <= 0 || input >= 1000) {
    return '';
  }
  if (specialNumbers[input]) {
    return specialNumbers[input];
  }
  return input > 0 ? priceFormat(input) : '';
};
const numberAmountToWords = input => {
  let output = '';
  powToStr.some(item => {
    if (input >= tenPow(item.pow)) {
      output = numberAmountToWords(Math.floor(input / tenPow(item.pow)));
      output += item.label;
      output += input % tenPow(item.pow) ? separator + numberAmountToWords(Math.floor(input % tenPow(item.pow))) : '';
      return true;
    }
    return false;
  });
  if (output) {
    return output;
  }
  return tinyNumbers(input);
};
const splitString = (input, sizes) => {
  let parts = [];
  let startIndex = 0;
  for (let size of sizes) {
    if (startIndex >= input.length) break;
    let part = input.substring(startIndex, startIndex + size);
    parts.push(part);
    startIndex += size;
  }
  return parts;
};
let DgInputComponent = /*#__PURE__*/(() => {
  class DgInputComponent extends BaseFieldType {
    get inputMode() {
      if (this.isNumericKeyboard) {
        return 'numeric';
      }
      if (this.inputType === 'email') {
        return 'email';
      }
      if (this.inputType === 'tel') {
        return 'tel';
      }
      return 'text';
    }
    constructor() {
      super();
      this.allowedKeyDown = input => true;
      this.id = 'dg-input-' + Math.floor(Math.random() * 10000);
      this.warning = false;
      this.inputPattern = computed(() => this.isNumericKeyboard ? '[0-9]*' : this.pattern());
      effect(() => {
        if (this.autoFocus()) {
          this.focusButton.nativeElement.click();
        }
      });
    }
    ngOnInit() {
      this.form?.controls[this.formControlName].valueChanges.subscribe(originalVal => {
        if (!this.isNumericKeyboard && !this.convertNonEnglishDigits) {
          return;
        }
        let val = convertNonEnglishDigits(originalVal);
        if (this.isNumericKeyboard) {
          val = val.replace(/[^\d]/g, '');
        }
        if (originalVal !== val && this.form) {
          this.form.controls[this.formControlName].setValue(val, {
            emitEvent: true
          });
        }
      });
    }
    onFocusClicked() {
      (this.multiLine ? this.textarea : this.input)?.nativeElement.focus();
    }
    notAllowedCharWarning() {
      this.warning = true;
      setTimeout(() => {
        this.warning = false;
      }, 300);
    }
    onKeyDown($event) {
      const key = $event.key;
      if (this.allowedKeyDown(key)) {
        return true;
      }
      this.notAllowedCharWarning();
      return false;
    }
    onFocusIn() {
      if (this.readonly) return;
      this.isFocused = true;
      if (this.isNumericKeyboard) {
        setTimeout(() => {
          (this.multiLine ? this.textarea : this.input)?.nativeElement.setSelectionRange(this.input.nativeElement.value.length, this.input.nativeElement.value.length);
        }, 0);
      }
    }
    static {
      this.ɵfac = function DgInputComponent_Factory(t) {
        return new (t || DgInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgInputComponent,
        selectors: [["app-dg-input"]],
        viewQuery: function DgInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusButton = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
          }
        },
        inputs: {
          multiLine: "multiLine",
          inputType: "inputType",
          maxSize: "maxSize",
          autoComplete: "autoComplete",
          isNumericKeyboard: "isNumericKeyboard",
          convertNonEnglishDigits: "convertNonEnglishDigits",
          allowedKeyDown: "allowedKeyDown"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c3,
        decls: 3,
        vars: 1,
        consts: [["focusButton", ""], ["input", ""], ["textarea", ""], [4, "ngIf"], [2, "display", "none", 3, "click"], [1, "dg-input-wrapper", 3, "ngClass"], [1, "dg-leading-icon"], [3, "htmlFor"], ["class", "dg-required-star", 4, "ngIf"], [3, "formGroup", 4, "ngIf"], ["class", "dg-hint-message", 3, "ngClass", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngTemplateOutlet"], [1, "dg-required-star"], [3, "formGroup"], [3, "focusin", "focusout", "keydown", "id", "placeholder", "formControlName", "type", "readonly", "autocomplete", "maxLength", "pattern"], [1, "dg-input-actions-wrapper"], ["class", "dg-lock-icon", 4, "ngIf"], [1, "dg-search-icon"], ["class", "dg-input-button", 4, "ngIf"], [1, "dg-lock-icon"], [3, "ngClass"], ["class", "dg-clean-icon", 3, "click", 4, "ngIf"], [1, "dg-trailing-icon"], [1, "dg-clean-icon", 3, "click"], [1, "dg-input-button"], [3, "focusin", "focusout", "keydown", "id", "rows", "placeholder", "formControlName", "readonly", "maxLength", "pattern"], [1, "dg-hint-message", 3, "ngClass"]],
        template: function DgInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, DgInputComponent_ng_container_0_Template, 10, 24, "ng-container", 3);
            i0.ɵɵelementStart(1, "button", 4, 0);
            i0.ɵɵlistener("click", function DgInputComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusClicked());
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.PatternValidator, i2.FormGroupDirective, i2.FormControlName],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dg-input-wrapper[_ngcontent-%COMP%]{width:100%;height:56px;border:1px solid #C9CBCF;background-color:#fff;border-radius:12px;position:relative;overflow:hidden;transition:all .3s}.dg-input-wrapper.input-type-single-line[_ngcontent-%COMP%]{height:56px}.dg-input-wrapper.input-type-multi-line[_ngcontent-%COMP%]{height:120px}.dg-input-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:absolute;top:22px;right:10px;margin:0;color:#000;font-size:14px;line-height:1;transition:all .3s;z-index:1}.dg-input-wrapper[_ngcontent-%COMP%]   label.float-top[_ngcontent-%COMP%], .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{top:11px;right:10px;font-size:10px;line-height:1}.dg-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{display:block;width:100%;background-color:transparent;border:1px solid transparent;padding:22px 10px 8px;height:100%;font-size:14px;line-height:20px;direction:rtl;text-align:right}.dg-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:rtl;text-align:right;transition:all .3s;opacity:0;font-size:14px;line-height:20px;color:#74777c}.dg-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{resize:none}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-leading-icon[_ngcontent-%COMP%]{position:absolute;top:10px;right:10px;width:36px;height:36px;padding:8px;background-color:#f2f3f6d9;border-radius:8px}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-validation-icon[_ngcontent-%COMP%]{width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M17.5 10C17.5 5.85757 14.1424 2.5 10 2.5C5.85757 2.5 2.5 5.85757 2.5 10C2.5 14.1416 5.85757 17.5 10 17.5C14.1424 17.5 17.5 14.1416 17.5 10Z\" stroke=\"%2300C958\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M7.11255 10.0002L9.03742 11.9242L12.8855 8.07617\" stroke=\"%2300C958\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-invalidation-icon[_ngcontent-%COMP%]{width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M17.5 10C17.5 5.85757 14.1424 2.5 10 2.5C5.85757 2.5 2.5 5.85757 2.5 10C2.5 14.1416 5.85757 17.5 10 17.5C14.1424 17.5 17.5 14.1416 17.5 10Z\" stroke=\"%23F9441F\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M9.99683 6.92218V10.5051M9.99999 13.1181V13.0784\" stroke=\"%23F9441F\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:none;width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<g clip-path=\"url(%23clip0_13718_450)\">%0D%0A<mask id=\"mask0_13718_450\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\">%0D%0A<path d=\"M5 5L15 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M15 5L5 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</mask>%0D%0A<g mask=\"url(%23mask0_13718_450)\">%0D%0A<rect width=\"20\" height=\"20\" fill=\"black\"/>%0D%0A</g>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_13718_450\">%0D%0A<rect width=\"20\" height=\"20\" fill=\"white\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-search-icon[_ngcontent-%COMP%]{display:none;width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.48999 14.71V15.5L5.1971 19.7843C4.80646 20.1742 4.17384 20.1738 3.78359 19.7836L3.70639 19.7064C3.31614 19.3162 3.31583 18.6835 3.70568 18.2929L7.98999 14H8.77999L9.05999 13.73C8.07999 12.59 7.48999 11.11 7.48999 9.5C7.48999 5.91 10.4 3 13.99 3C17.58 3 20.49 5.91 20.49 9.5C20.49 13.09 17.58 16 13.99 16C12.38 16 10.9 15.41 9.75999 14.43L9.48999 14.71ZM13.99 5C11.5 5 9.48999 7.01 9.48999 9.5C9.48999 11.99 11.5 14 13.99 14C16.48 14 18.49 11.99 18.49 9.5C18.49 7.01 16.48 5 13.99 5Z\" fill=\"%232C3544\"/>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-trailing-icon[_ngcontent-%COMP%]{display:none;width:36px;height:36px;padding:8px;background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-lock-icon[_ngcontent-%COMP%]{display:block;width:36px;height:36px;padding:8px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<g id=\"Lock\">%0D%0A<path id=\"Vector\" d=\"M10 12.0732V13.8068\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path id=\"Vector_2\" d=\"M13.7064 8.33358V6.65678C13.6813 4.69118 12.0003 3.11758 9.95342 3.14238C7.94807 3.16638 6.32632 4.71678 6.29224 6.64078V8.33358\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path id=\"Vector_3\" d=\"M7.75313 17.5775H12.2463C13.5758 17.5775 14.2405 17.5775 14.7536 17.3407C15.2658 17.1047 15.679 16.7079 15.925 16.2167C16.1713 15.7239 16.1713 15.0855 16.1713 13.8095V12.1039C16.1713 10.8279 16.1713 10.1895 15.925 9.69754C15.679 9.20554 15.2658 8.80874 14.7536 8.57274C14.2405 8.33594 13.5758 8.33594 12.2463 8.33594H7.75313C6.42371 8.33594 5.75896 8.33594 5.24596 8.57274C4.73362 8.80874 4.32046 9.20554 4.07446 9.69754C3.82812 10.1895 3.82812 10.8279 3.82812 12.1039V13.8095C3.82812 15.0855 3.82812 15.7239 4.07446 16.2167C4.32046 16.7079 4.73362 17.1047 5.24596 17.3407C5.75896 17.5775 6.42371 17.5775 7.75313 17.5775Z\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</g>%0D%0A</svg>%0D%0A');background-size:20px 20px;background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-input-button[_ngcontent-%COMP%]:empty{display:none}.dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:rtl;text-align:right}.dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:ltr;text-align:left}.dg-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:ltr;text-align:left}.dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#fff}.dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#000}.dg-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]{padding-left:36px}.dg-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:block}.dg-input-wrapper.dg-trailed[_ngcontent-%COMP%]{padding-left:36px}.dg-input-wrapper.dg-trailed[_ngcontent-%COMP%]   .dg-trailing-icon[_ngcontent-%COMP%]{display:block}.dg-input-wrapper.dg-focused[_ngcontent-%COMP%]{border-color:#1159fc;background-color:#deedff}.dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#74777c}.dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{opacity:1}.dg-input-wrapper.dg-error[_ngcontent-%COMP%]{border-color:#f9441f;background-color:#fff}.dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#f2f3f6}.dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-readonly[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{color:#b4b7bd;background-color:#f2f3f6}.dg-input-wrapper.dg-lock[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#f2f3f6}.dg-input-wrapper.dg-lock[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-lock[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-lock[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{color:#74777c;background-color:#f2f3f6}.dg-input-wrapper.dg-searchable[_ngcontent-%COMP%]{padding-left:36px}.dg-input-wrapper.dg-searchable[_ngcontent-%COMP%]   .dg-search-icon[_ngcontent-%COMP%]{display:block}.dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label.float-top[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   .dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-input-wrapper.dg-focused[_ngcontent-%COMP%]   .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{right:54px}.dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-input-wrapper.dg-leading-icon[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{padding-right:54px}.dg-input-wrapper[_ngcontent-%COMP%]   .dg-input-actions-wrapper[_ngcontent-%COMP%]{display:flex;gap:8px;position:absolute;top:10px;left:10px}"]
      });
    }
  }
  return DgInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgSelectOptionItem = /*#__PURE__*/(() => {
  class DgSelectOptionItem {
    constructor() {
      this.item = input.required();
      this.option = input.required();
      this.index = input.required();
      this.type = input.required();
      this.showRadio = input();
      this.multiple = computed(() => this.type() === 'checkbox');
      this.breakIfOutOfLine = input();
    }
    static {
      this.ɵfac = function DgSelectOptionItem_Factory(t) {
        return new (t || DgSelectOptionItem)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgSelectOptionItem,
        selectors: [["dg-select-option-item"]],
        inputs: {
          item: [i0.ɵɵInputFlags.SignalBased, "item"],
          option: [i0.ɵɵInputFlags.SignalBased, "option"],
          index: [i0.ɵɵInputFlags.SignalBased, "index"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          showRadio: [i0.ɵɵInputFlags.SignalBased, "showRadio"],
          breakIfOutOfLine: [i0.ɵɵInputFlags.SignalBased, "breakIfOutOfLine"]
        },
        decls: 12,
        vars: 15,
        consts: [[1, "d-flex", "align-items-center", "justify-content-space-between", "w-100"], [1, "checkbox-style"], [3, "id", "type", "checked"], [1, "checkbox__checkmark"], [1, "checkbox__body"], [1, "d-flex", "gap-small"], [1, "caption-option"], [4, "ngTemplateOutlet"]],
        template: function DgSelectOptionItem_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, DgSelectOptionItem_Conditional_2_Template, 0, 0)(3, DgSelectOptionItem_Conditional_3_Template, 1, 1, "ng-container");
            i0.ɵɵelement(4, "input", 2);
            i0.ɵɵtemplate(5, DgSelectOptionItem_Conditional_5_Template, 1, 0, "div", 3);
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5);
            i0.ɵɵtemplate(9, DgSelectOptionItem_Conditional_9_Template, 0, 0)(10, DgSelectOptionItem_Conditional_10_Template, 1, 1, "ng-container")(11, DgSelectOptionItem_Conditional_11_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("dg-select-option-multiple", ctx.multiple())("break-out-of-box", ctx.breakIfOutOfLine());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(2, ctx.item().leadingIconStart ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(3, ctx.item().iconStart ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "item-", ctx.index(), "");
            i0.ɵɵproperty("type", ctx.type())("checked", ctx.option().selected);
            i0.ɵɵadvance();
            i0.ɵɵconditional(5, ctx.multiple() || ctx.showRadio() ? 5 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.item().title);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(9, ctx.item().leadingIconEnd ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(10, ctx.item().iconEnd ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(11, ctx.item().caption ? 11 : -1);
          }
        },
        dependencies: [i1.NgTemplateOutlet],
        styles: [".checkbox-style[_ngcontent-%COMP%]{position:relative;cursor:pointer;display:flex;gap:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox-style[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.checkbox-style[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkbox__checkmark[_ngcontent-%COMP%]{background-color:var(--surface-brand);border-color:transparent}.checkbox-style[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkbox__checkmark[_ngcontent-%COMP%]:after{opacity:1}.checkbox-style[_ngcontent-%COMP%]   .checkbox__checkmark[_ngcontent-%COMP%]{position:relative;height:20px;width:20px;background-color:#fff;border:1px solid var(--border-light);transition:border .25s ease;border-radius:50%}.checkbox-style[_ngcontent-%COMP%]   .checkbox__checkmark[_ngcontent-%COMP%]:after{content:\"\";position:absolute;background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\">%0D%0A  <path d=\"M10.8886 4.32666L5.5414 9.67388L3.11084 7.24333\" stroke=\"white\" stroke-width=\"0.833333\"%0D%0A        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;cursor:pointer;left:50%;top:50%;transform:translate(-50%,-50%);width:14px;height:14px}.checkbox-style[_ngcontent-%COMP%]   .checkbox__body[_ngcontent-%COMP%]{line-height:24px;font-size:14px}.break-out-of-box[_ngcontent-%COMP%]{white-space:break-spaces}.caption-option[_ngcontent-%COMP%]{font-size:12px;line-height:24px;color:var(--onback-shade-50)}.dg-select-option-multiple[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]   .checkbox__checkmark[_ngcontent-%COMP%]{border-radius:6px}.dg-select-option-multiple[_ngcontent-%COMP%]   .caption-option[_ngcontent-%COMP%]{font-size:12px;line-height:24px;color:var(--onback-shade-50)}"]
      });
    }
  }
  return DgSelectOptionItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgSelectBottomSheetComponent = /*#__PURE__*/(() => {
  class DgSelectBottomSheetComponent {
    constructor(_ref, data) {
      this._ref = _ref;
      this.data = data;
      this.inputType = computed(() => this.data.multiple ? 'checkbox' : 'radio');
      this.selectedAll = signal(null);
      this.searchInput = new FormControl();
      this.options = signal(null);
      this.options.set(data.options);
      this.initOptionSelection();
      this.selectedAllProcess();
    }
    confirm() {
      if (this.data.multiple) {
        const selectedOptions = this.options().filter(option => option.selected === true);
        this._ref.dismiss(selectedOptions.map(option => option.value));
      } else {
        const selectedOption = this.options().find(option => option.selected);
        this._ref.dismiss(selectedOption?.value);
      }
    }
    onSelected(item) {
      if (this.data.multiple) {
        item.selected = !item.selected;
        this.selectedAllProcess();
      } else {
        this.options().forEach(option => option.selected = false);
        item.selected = true;
        this.confirm();
      }
    }
    selectedAllProcess() {
      const selectedAll = this.options().every(i => i.selected === true);
      this.selectedAll.set(selectedAll);
    }
    selectAll(val) {
      this.options().forEach(option => option.selected = val);
    }
    initOptionSelection() {
      if (this.options()) {
        if (this.data.multiple && Array.isArray(this.data.value)) {
          this.options().forEach(option => {
            option.selected = this.data.value.includes(option.value);
          });
        } else if (!this.data.multiple && this.data.value) {
          this.options().forEach(option => option.selected = option.value === this.data.value);
        } else {
          this.options().forEach(option => option.selected = false);
        }
      }
    }
    clearSearchInput() {
      this.searchInput.patchValue('');
    }
    close() {
      this._ref.dismiss();
    }
    static {
      this.ɵfac = function DgSelectBottomSheetComponent_Factory(t) {
        return new (t || DgSelectBottomSheetComponent)(i0.ɵɵdirectiveInject(i1$1.MatBottomSheetRef), i0.ɵɵdirectiveInject(MAT_BOTTOM_SHEET_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgSelectBottomSheetComponent,
        selectors: [["dg-select-bottom-sheet"]],
        decls: 13,
        vars: 9,
        consts: [["select", ""], [1, "dg-select-bottom-sheet", 3, "ngStyle"], [1, "dg-select__title"], [1, "d-flex", "align-items-center"], [1, "clear-items"], [3, "style", "size"], [1, "dg-select__search"], [1, "dg-select__options"], [1, "d-flex", "justify-content-center"], [1, "clear-items", 3, "click"], [3, "clickHandler", "size"], [1, "search-icon"], ["type", "text", "placeholder", "\u062C\u0633\u062A\u200C\u0648\u062C\u0648", 1, "search-input", 3, "formControl"], [1, "clear-icon"], [1, "clear-icon", 3, "click"], [1, "checkbox-style", 3, "click"], ["type", "checkbox", 3, "checked"], [1, "checkbox__checkmark"], [1, "checkbox__body"], [1, "divider-options"], [1, "options-item", 3, "click", "option", "item", "index", "type", "showRadio", "ngClass"]],
        template: function DgSelectBottomSheetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
            i0.ɵɵtemplate(3, DgSelectBottomSheetComponent_Conditional_3_Template, 1, 0, "div", 4);
            i0.ɵɵelementStart(4, "span");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, DgSelectBottomSheetComponent_Conditional_6_Template, 2, 3, "ngx-button", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, DgSelectBottomSheetComponent_Conditional_7_Template, 4, 2, "div", 6);
            i0.ɵɵelementStart(8, "div", 7);
            i0.ɵɵtemplate(9, DgSelectBottomSheetComponent_Conditional_9_Template, 7, 2);
            i0.ɵɵrepeaterCreate(10, DgSelectBottomSheetComponent_For_11_Template, 2, 10, null, null, i0.ɵɵrepeaterTrackByIndex, false, DgSelectBottomSheetComponent_ForEmpty_12_Template, 2, 1, "div", 8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c8, ctx.data.maxHeight));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(3, ctx.data.hasCloseBtn ? 3 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.data.title);
            i0.ɵɵadvance();
            i0.ɵɵconditional(6, ctx.data.multiple ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(7, ctx.data.searchable ? 7 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(9, ctx.data.hasSelectAll && ctx.data.multiple ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.options());
          }
        },
        dependencies: [i1.NgClass, i1.NgStyle, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective, i4.NgxButtonComponent, DgSelectOptionItem],
        styles: [".mat-dialog-container{padding:0}  .mat-bottom-sheet-container{padding:0}.dg-select-bottom-sheet[_ngcontent-%COMP%]{display:flex;flex-direction:column;direction:rtl;padding:8px 16px;box-sizing:border-box;height:50vh}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__title[_ngcontent-%COMP%]{color:var(--onelevated-shade-0);font-size:16px;line-height:28px;border-bottom:1px solid var(--border-light);padding:8px 0;width:100%;display:flex;justify-content:space-between;align-items:center}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .clear-items[_ngcontent-%COMP%]{width:36px;height:36px;background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\">%0D%0A  <path d=\"M5 5L15 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\"%0D%0A        stroke-linejoin=\"round\"/>%0D%0A  <path d=\"M15 5L5 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\"%0D%0A        stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;cursor:pointer}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]{padding:8px 0;flex:1;overflow:auto}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]{position:relative;cursor:pointer;display:flex;gap:8px;padding:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:8px}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style.active-item[_ngcontent-%COMP%]{background-color:var(--surface-brand-tint);color:var(--surface-brand)}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkbox__checkmark[_ngcontent-%COMP%]{background-color:var(--surface-brand);border-color:transparent}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkbox__checkmark[_ngcontent-%COMP%]:after{opacity:1}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]   .checkbox__checkmark[_ngcontent-%COMP%]{position:relative;height:20px;width:20px;border-radius:6px;background-color:#fff;border:1px solid var(--border-light);transition:border .25s ease}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]   .checkbox__checkmark[_ngcontent-%COMP%]:after{content:\"\";position:absolute;background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\">%0D%0A  <path d=\"M10.8886 4.32666L5.5414 9.67388L3.11084 7.24333\" stroke=\"white\" stroke-width=\"0.833333\"%0D%0A        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;cursor:pointer;left:50%;top:50%;transform:translate(-50%,-50%);width:14px;height:14px}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__options[_ngcontent-%COMP%]   .checkbox-style[_ngcontent-%COMP%]   .checkbox__body[_ngcontent-%COMP%]{line-height:24px;font-size:14px}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .divider-options[_ngcontent-%COMP%]{height:1px;width:100%;background:var(--border-tint)}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .options-item[_ngcontent-%COMP%]{padding:12px;margin:8px 0;border-radius:8px;position:relative;display:flex;align-items:center;justify-content:space-between;cursor:pointer}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .options-item.active-item[_ngcontent-%COMP%]{background-color:var(--surface-brand-tint);color:var(--surface-brand)}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .options-item.disabled-item[_ngcontent-%COMP%]{background-color:var(--surface-back);color:var(--text-onback-disabled);pointer-events:none;cursor:none}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__search[_ngcontent-%COMP%]{border-radius:48px;background:var(--onback-shade-95);display:flex;margin:8px 0;padding:0 16px 0 12px;align-items:center;gap:8px}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__search[_ngcontent-%COMP%]   .search-icon[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\">%0D%0A  <path%0D%0A    d=\"M9.80547 17.296C13.9423 17.296 17.2959 13.9424 17.2959 9.80549C17.2959 5.66862 13.9423 2.31503 9.80547 2.31503C5.6686 2.31503 2.315 5.66862 2.315 9.80549C2.315 13.9424 5.6686 17.296 9.80547 17.296Z\"%0D%0A    stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A  <path d=\"M15.0153 15.4043L17.9519 18.3333\" stroke=\"black\" stroke-width=\"1.25\"%0D%0A        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;width:20px;height:20px}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__search[_ngcontent-%COMP%]   .search-input[_ngcontent-%COMP%]{height:40px;background:none;outline:none;border:none;flex:1}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__search[_ngcontent-%COMP%]   .search-input[_ngcontent-%COMP%]::placeholder{color:var(--onback-shade-50)}.dg-select-bottom-sheet[_ngcontent-%COMP%]   .dg-select__search[_ngcontent-%COMP%]   .clear-icon[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\">%0D%0A  <path d=\"M5 5L15 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\"%0D%0A        stroke-linejoin=\"round\"/>%0D%0A  <path d=\"M15 5L5 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\"%0D%0A        stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;width:20px;height:20px;cursor:pointer}"]
      });
    }
  }
  return DgSelectBottomSheetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgSelectMultiLabel = /*#__PURE__*/(() => {
  class DgSelectMultiLabel {
    constructor() {
      this.items = input();
      this.clearItem = output();
    }
    static {
      this.ɵfac = function DgSelectMultiLabel_Factory(t) {
        return new (t || DgSelectMultiLabel)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgSelectMultiLabel,
        selectors: [["dg-select-multi-label"]],
        inputs: {
          items: [i0.ɵɵInputFlags.SignalBased, "items"]
        },
        outputs: {
          clearItem: "clearItem"
        },
        decls: 3,
        vars: 0,
        consts: [[1, "d-flex", "align-items-center", "gap-micro", "flex-wrap"], [1, "dg-select__chips"], ["aria-hidden", "true", 1, "ng-value-icon", "chips-clear", 3, "click"]],
        template: function DgSelectMultiLabel_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵrepeaterCreate(1, DgSelectMultiLabel_For_2_Template, 3, 1, "div", 1, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.items());
          }
        },
        styles: [".dg-select__chips[_ngcontent-%COMP%]{border-radius:48px;border:1px solid var(--onback-shade-90);background:var(--onelevated-shade-100);display:flex;gap:4px;padding:2px 6px;font-size:10px}.dg-select__chips[_ngcontent-%COMP%]   .chips-clear[_ngcontent-%COMP%]{width:16px;height:16px;background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">%0D%0A  <path d=\"M4 4L12 12\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A  <path d=\"M12 4L4 12\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;cursor:pointer}"]
      });
    }
  }
  return DgSelectMultiLabel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgSelectComponent = /*#__PURE__*/(() => {
  class DgSelectComponent extends BaseFieldType {
    constructor(bottomSheet, deviceDetector, destroyRef) {
      super();
      this.bottomSheet = bottomSheet;
      this.deviceDetector = deviceDetector;
      this.destroyRef = destroyRef;
      this.selectElm = viewChild('selectElm', {
        read: NgSelectComponent
      });
      this.multiSelect = input(false);
      this.options = input([], {
        transform: option => {
          if (option && option.length > 0) {
            return option.map(value => ({
              ...value,
              title: convertNonEnglishDigits(value.title)
            }));
          }
          return [];
        }
      });
      this.searchable = input(true);
      this.placeholder = '';
      this.selectOpenType = input('auto');
      this.isBottomSheet = computed(() => this.selectOpenType() === 'bottomSheet' || this.selectOpenType() === 'auto' && this.deviceDetector.isMobile);
      this.isOpen = computed(() => this.isBottomSheet() ? false : undefined);
      this.isDivider = input(false);
      this.showRadio = input(false);
      this.breakIfOutOfLine = input(true);
      this.dropdownPosition = input('auto');
      this.hasSelectAll = input(false);
      this.selectedAll = computed(() => this.form.controls[this.formControlName].value?.length === this.options().length);
      this.notFoundText = input('موردی یافت نشد');
      this.searchOptionsSelect = new EventEmitter();
      this.overflowToContainer = input(false);
      this.id = 'dg-select-' + Math.floor(Math.random() * 10000);
      this.bottomSheetCloseBtn = input(false);
      this.bottomSheetSelectError = signal(true);
      this.bottomSheetMaxHeight = input(null);
      this.translatedBottomSheetMaxHeight = computed(() => {
        if (!this.bottomSheetMaxHeight()) {
          return null;
        }
        let translated = '' + this.bottomSheetMaxHeight();
        let lastChar = translated.slice(-1);
        if (/^\d+$/.test(lastChar)) {
          translated += 'px';
        }
        return translated;
      });
      effect(() => {
        const autoFocus = this.autoFocus();
        if (autoFocus) {
          this.selectElm().open();
        } else if (autoFocus === false && this.selectElm().isOpen) {
          this.selectElm().close();
        }
      });
    }
    selectAll(val) {
      if (val) {
        this.form.controls[this.formControlName].setValue(this.options().map(m => m.value));
      } else {
        this.form.controls[this.formControlName].setValue(null);
      }
    }
    emitSearch(event) {
      this.searchOptionsSelect.emit(event);
    }
    subscribeSearchInputBottomSheet(searchInput) {
      searchInput.valueChanges.pipe(debounceTime(800), distinctUntilChanged((val1, val2) => val1.trim() === val2.trim()), takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        const convertValue = convertNonEnglishDigits(value);
        const matchedItems = [];
        for (const option of this.options()) {
          if (this.searchOptions(convertValue, option)) {
            matchedItems.push(option);
          }
        }
        this.bottomSheetInstance.componentRef.instance.options.set(matchedItems);
        this.emitSearch({
          items: this.bottomSheetInstance.componentRef.instance.options(),
          term: convertValue
        });
      });
    }
    searchOptions(search, opt) {
      const label = opt.title;
      return label.indexOf(search) > -1;
    }
    clearEvent() {
      this.cleanEvent.emit();
      this.bottomSheetSelectError.set(true);
    }
    openBottomSheet() {
      if (this.readonly) {
        return;
      }
      if (this.isBottomSheet()) {
        this.bottomSheetSelectError.set(false);
        this.bottomSheetInstance = this.bottomSheet.open(DgSelectBottomSheetComponent, {
          panelClass: 'dg-select-bottom-sheet',
          data: {
            options: this.options(),
            title: this.label,
            multiple: this.multiSelect(),
            value: this.form.controls[this.formControlName].value,
            isDivider: this.isDivider(),
            showRadio: this.showRadio(),
            hasSelectAll: this.hasSelectAll(),
            searchable: this.searchable(),
            hasCloseBtn: this.bottomSheetCloseBtn(),
            maxHeight: this.translatedBottomSheetMaxHeight(),
            notFoundText: this.notFoundText()
          }
        });
        this.bottomSheetInstance.afterDismissed().subscribe(data => {
          this.bottomSheetSelectError.set(this.isShowError);
          if (!data) {
            return;
          }
          if (this.form) {
            this.form.controls[this.formControlName].setValue(data || null);
            this.form.controls[this.formControlName].markAsTouched();
          }
        });
        if (this.searchable()) {
          this.subscribeSearchInputBottomSheet(this.bottomSheetInstance.instance.searchInput);
        }
      }
    }
    static {
      this.ɵfac = function DgSelectComponent_Factory(t) {
        return new (t || DgSelectComponent)(i0.ɵɵdirectiveInject(i1$1.MatBottomSheet), i0.ɵɵdirectiveInject(i2$1.DeviceDetector), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgSelectComponent,
        selectors: [["app-dg-select"]],
        viewQuery: function DgSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.selectElm, _c10, 5, NgSelectComponent);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          multiSelect: [i0.ɵɵInputFlags.SignalBased, "multiSelect"],
          options: [i0.ɵɵInputFlags.SignalBased, "options"],
          searchable: [i0.ɵɵInputFlags.SignalBased, "searchable"],
          placeholder: [i0.ɵɵInputFlags.HasDecoratorInputTransform, "placeholder", "placeholder", value => value === '' ? 'انتخاب کنید...' : value],
          selectOpenType: [i0.ɵɵInputFlags.SignalBased, "selectOpenType"],
          isDivider: [i0.ɵɵInputFlags.SignalBased, "isDivider"],
          showRadio: [i0.ɵɵInputFlags.SignalBased, "showRadio"],
          breakIfOutOfLine: [i0.ɵɵInputFlags.SignalBased, "breakIfOutOfLine"],
          dropdownPosition: [i0.ɵɵInputFlags.SignalBased, "dropdownPosition"],
          hasSelectAll: [i0.ɵɵInputFlags.SignalBased, "hasSelectAll"],
          notFoundText: [i0.ɵɵInputFlags.SignalBased, "notFoundText"],
          overflowToContainer: [i0.ɵɵInputFlags.SignalBased, "overflowToContainer"],
          bottomSheetCloseBtn: [i0.ɵɵInputFlags.SignalBased, "bottomSheetCloseBtn"],
          bottomSheetMaxHeight: [i0.ɵɵInputFlags.SignalBased, "bottomSheetMaxHeight"]
        },
        outputs: {
          searchOptionsSelect: "searchOptionsSelect"
        },
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["selectElm", ""], ["select", ""], [3, "formGroup"], [3, "id", "ngClass"], ["size", "sm", "bindLabel", "title", "bindValue", "value", "groupBy", "selectedAllGroup", 1, "dg-select", 3, "search", "clear", "click", "appendTo", "placeholder", "readonly", "multiple", "formControlName", "dropdownPosition", "clearable", "searchable", "ngClass", "items", "isOpen", "notFoundText", "closeOnSelect", "selectableGroup", "selectableGroupAsModel", "clearSearchOnAdd", "inputAttrs"], ["class", "dg-hint-message", 4, "ngIf"], ["class", "dg-error-message", 4, "ngIf"], ["ng-option-tmp", ""], ["ng-multi-label-tmp", ""], ["ng-header-tmp", ""], ["type", "checkbox", 3, "option", "item", "index"], [1, "divider-options"], [3, "clearItem", "items"], [1, "checkbox-style", 3, "click"], ["type", "checkbox", 3, "checked"], [1, "checkbox__checkmark"], [1, "checkbox__body"], ["type", "radio", 3, "option", "item", "index", "showRadio", "breakIfOutOfLine"], [1, "dg-hint-message"], [1, "dg-error-message"]],
        template: function DgSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DgSelectComponent_Conditional_0_Template, 8, 34, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(0, ctx.form ? 0 : -1);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i5.NgSelectComponent, i5.NgOptionTemplateDirective, i5.NgMultiLabelTemplateDirective, i5.NgHeaderTemplateDirective, DgSelectOptionItem, DgSelectMultiLabel],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}  .dg-select.ng-dropdown-panel{background-color:#fff;direction:rtl;border-radius:12px;border:1px solid var(--border-light);box-shadow:0 8px 10px 1px #45474a14;overflow:hidden}  .dg-select.ng-dropdown-panel .scroll-host{margin:8px 8px 8px 4px;padding-left:3px;scroll-behavior:smooth}  .dg-select.ng-dropdown-panel .scroll-host::-webkit-scrollbar{width:2px;padding-right:5px}  .dg-select.ng-dropdown-panel .scroll-host::-webkit-scrollbar-track{background:var(--onback-shade-100);box-shadow:none}  .dg-select.ng-dropdown-panel .scroll-host::-webkit-scrollbar-thumb{border-radius:24px;background:var(--onback-shade-80)}  .dg-select.ng-dropdown-panel .divider-options{height:1px;position:absolute;background:var(--border-tint);bottom:0;left:0;right:0}  .dg-select.ng-dropdown-panel .ng-option-disabled{line-height:unset;min-height:unset}  .dg-select.ng-dropdown-panel.ng-select-bottom{top:100%;margin-top:8px}  .dg-select.ng-dropdown-panel.ng-select-top{margin-bottom:18px}  .dg-select.ng-dropdown-panel .ng-dropdown-panel-items .ng-option{text-align:right;padding:12px;border-radius:8px}  .dg-select.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:var(--surface-brand-tint)}  .dg-select.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected{background-color:var(--surface-brand-tint);color:#74777c}  .dg-select.ng-dropdown-panel .ng-dropdown-header{border-bottom:none;padding:0;cursor:pointer;position:relative}  .dg-select.ng-dropdown-panel .ng-dropdown-header:hover{background-color:var(--surface-brand-tint)}  .dg-select.ng-dropdown-panel .ng-dropdown-header .checkbox-style{position:relative;cursor:pointer;display:flex;gap:8px;padding:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}  .dg-select.ng-dropdown-panel .ng-dropdown-header .checkbox-style input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}  .dg-select.ng-dropdown-panel .ng-dropdown-header .checkbox-style input:checked~.checkbox__checkmark{background-color:var(--surface-brand);border-color:transparent}  .dg-select.ng-dropdown-panel .ng-dropdown-header .checkbox-style input:checked~.checkbox__checkmark:after{opacity:1}  .dg-select.ng-dropdown-panel .ng-dropdown-header .checkbox-style .checkbox__checkmark{position:relative;height:20px;width:20px;border-radius:6px;background-color:#fff;border:1px solid var(--border-light);transition:border .25s ease}  .dg-select.ng-dropdown-panel .ng-dropdown-header .checkbox-style .checkbox__checkmark:after{content:\"\";position:absolute;background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\">%0D%0A  <path d=\"M10.8886 4.32666L5.5414 9.67388L3.11084 7.24333\" stroke=\"white\" stroke-width=\"0.833333\"%0D%0A        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;cursor:pointer;left:50%;top:50%;transform:translate(-50%,-50%);width:14px;height:14px}  .dg-select.ng-dropdown-panel .ng-dropdown-header .checkbox-style .checkbox__body{line-height:24px;font-size:14px}.ng-select.dg-select[_ngcontent-%COMP%]    {padding-bottom:0}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-input{margin-right:2px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-input input::placeholder{opacity:0;color:#8d99a8}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-input ::-webkit-input-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-input :-moz-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-input ::-moz-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-input :-ms-input-placeholder{opacity:0;color:#8d99a8}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel{direction:rtl;border-radius:12px;border:1px solid var(--border-light);box-shadow:0 8px 10px 1px #45474a14;overflow:hidden}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .scroll-host{margin:8px 8px 8px 4px;padding-left:3px;scroll-behavior:smooth}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .scroll-host::-webkit-scrollbar{width:2px;padding-right:5px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .scroll-host::-webkit-scrollbar-track{background:var(--onback-shade-100);box-shadow:none}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .scroll-host::-webkit-scrollbar-thumb{border-radius:24px;background:var(--onback-shade-80)}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .divider-options{height:1px;position:absolute;background:var(--border-tint);bottom:0;left:0;right:0}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-option-disabled{line-height:unset;min-height:unset}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel.ng-select-bottom{top:100%;margin-top:8px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel.ng-select-top{margin-bottom:18px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{text-align:right;padding:12px;border-radius:8px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:var(--surface-brand-tint)}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected{background-color:var(--surface-brand-tint);color:#74777c}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header{border-bottom:none;padding:0;cursor:pointer;position:relative}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header:hover{background-color:var(--surface-brand-tint)}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header .checkbox-style{position:relative;cursor:pointer;display:flex;gap:8px;padding:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header .checkbox-style input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header .checkbox-style input:checked~.checkbox__checkmark{background-color:var(--surface-brand);border-color:transparent}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header .checkbox-style input:checked~.checkbox__checkmark:after{opacity:1}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header .checkbox-style .checkbox__checkmark{position:relative;height:20px;width:20px;border-radius:6px;background-color:#fff;border:1px solid var(--border-light);transition:border .25s ease}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header .checkbox-style .checkbox__checkmark:after{content:\"\";position:absolute;background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\">%0D%0A  <path d=\"M10.8886 4.32666L5.5414 9.67388L3.11084 7.24333\" stroke=\"white\" stroke-width=\"0.833333\"%0D%0A        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-position:center;background-repeat:no-repeat;cursor:pointer;left:50%;top:50%;transform:translate(-50%,-50%);width:14px;height:14px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-dropdown-panel .ng-dropdown-header .checkbox-style .checkbox__body{line-height:24px;font-size:14px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container{width:100%;min-height:56px;border:1px solid #C9CBCF;background-color:#fff;border-radius:12px;position:relative;align-items:center;overflow:hidden;transition:all .3s;padding:18px 8px 8px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container:after{display:none}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-arrow-wrapper, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-clear-wrapper{width:20px;height:20px;display:inline-block;background-size:100% 100%;background-repeat:no-repeat;inset:auto}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-arrow-wrapper{background-image:url('data:image/svg+xml,<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">%0D%0A  <defs>%0D%0A    <path id=\"a\" d=\"M0 0h24v24H0z\"/>%0D%0A    <path id=\"b\" d=\"M0 0h24v24H0z\"/>%0D%0A    <path d=\"M17.295 9.295c.39.39.39 1.02 0 1.41L12 16l-5.295-5.295a.997.997 0 0 1 1.41-1.41L12 13.17l3.884-3.876a.998.998 0 0 1 1.411.001z\" id=\"c\"/>%0D%0A  </defs>%0D%0A  <g fill=\"none\" fill-rule=\"evenodd\">%0D%0A    <mask id=\"d\" fill=\"%23fff\">%0D%0A      <use xlink:href=\"%23c\"/>%0D%0A    </mask>%0D%0A    <g mask=\"url(%23d)\" fill=\"%232C3544\">%0D%0A      <path d=\"M0 0h24v24H0z\"/>%0D%0A    </g>%0D%0A  </g>%0D%0A</svg>%0D%0A');top:-6px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-arrow-wrapper .ng-arrow{display:none}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-clear-wrapper{background-image:url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M8 8L16 16\" stroke=\"%23424C5C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M16 8L8 16\" stroke=\"%23424C5C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');align-self:center}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-clear-wrapper .ng-clear{display:none}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container{padding:0;border:none!important}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input{width:auto;height:20px;line-height:20px;inset:19px 9px 9px;padding-top:5px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input>input{padding:0}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input input::placeholder{opacity:0;color:#8d99a8}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input ::-webkit-input-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input :-moz-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input ::-moz-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input :-ms-input-placeholder{opacity:0;color:#8d99a8}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-value{font-size:14px;line-height:20px;padding-top:5px}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder{top:22px;right:10px;font-size:14px;line-height:1;color:#000;background-color:#fff;transition:all .3s}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder.float-top, .ng-select.dg-select.ng-select-opened[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder, .ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value .ng-value-container .ng-placeholder{transform:none;top:11px;right:10px;font-size:10px;line-height:1}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value{border-color:#c9cbcf;background-color:#fff}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value .ng-value-container .ng-placeholder{color:#000;background-color:#fff}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value .ng-input input::placeholder{opacity:0!important}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value .ng-input ::-webkit-input-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value .ng-input :-moz-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value .ng-input ::-moz-placeholder, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-select-container.ng-has-value .ng-input :-ms-input-placeholder{opacity:0!important}.ng-select.dg-select[_ngcontent-%COMP%]     .ng-clear-wrapper, .ng-select.dg-select[_ngcontent-%COMP%]     .ng-arrow-wrapper{border-top:none!important}.ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container{border-color:#1159fc;background-color:var(--surface-brand-tint)}.ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder{color:#74777c;background-color:var(--surface-brand-tint)}.ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input{opacity:1}.ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input>input[readonly]{width:100%}.ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input input::placeholder{opacity:1}.ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input ::-webkit-input-placeholder, .ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input :-moz-placeholder, .ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input ::-moz-placeholder, .ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input :-ms-input-placeholder{opacity:1}.ng-select.dg-select.ng-select-opened[_ngcontent-%COMP%]     .ng-select-container{border-color:#1159fc;background-color:var(--surface-brand-tint)}.ng-select.dg-select.ng-select-opened[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder{color:#74777c;background-color:var(--surface-brand-tint)}.ng-select.dg-select.ng-select-multiple[_ngcontent-%COMP%]     .ng-select-container{padding:26px 8px 6px}.ng-select.dg-select.ng-select-multiple[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-input{padding-top:0}.ng-select.dg-select.ng-select-multiple[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-value{padding:0 5px 0 0;margin:0 0 2px;line-height:18px;background-color:transparent;color:#424c5c}.ng-select.dg-select.ng-select-multiple[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-value .ng-value-label, .ng-select.dg-select.ng-select-multiple[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block}.ng-select.dg-select.ng-select-multiple[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-value .ng-value-icon{color:#6e798d}.ng-select.dg-select.dg-required[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder:after{content:\" *\";color:#d82137}.ng-select.dg-select.ng-select-focused[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder:after{color:#d82137}.ng-select.dg-select.ng-select-opened[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder:after{color:#d82137}.ng-select.dg-select.dg-error[_ngcontent-%COMP%]     .ng-select-container{border-color:#f9441f;background-color:#fff}.ng-select.dg-select.dg-error[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder{background-color:#fff}.ng-select.dg-select.dg-readonly[_ngcontent-%COMP%]     .ng-select-container{border-color:#c9cbcf;background-color:#f2f3f6}.ng-select.dg-select.dg-readonly[_ngcontent-%COMP%]     .ng-select-container .ng-value-container .ng-placeholder{color:#b4b7bd;background-color:#f2f3f6}.ng-select-opened[_ngcontent-%COMP%]  .ng-input input::placeholder{opacity:1!important}.ng-select-opened[_ngcontent-%COMP%]  .ng-input ::-webkit-input-placeholder, .ng-select-opened[_ngcontent-%COMP%]  .ng-input :-moz-placeholder, .ng-select-opened[_ngcontent-%COMP%]  .ng-input ::-moz-placeholder, .ng-select-opened[_ngcontent-%COMP%]  .ng-input :-ms-input-placeholder{opacity:1!important}.is-divider[_ngcontent-%COMP%]   .ng-select.dg-select[_ngcontent-%COMP%]   .ng-option[_ngcontent-%COMP%]{border-bottom:1px solid var(--border-tint)}"]
      });
    }
  }
  return DgSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgSlideToggleComponent = /*#__PURE__*/(() => {
  class DgSlideToggleComponent extends BaseFieldType {
    constructor() {
      super(...arguments);
      this.id = 'dg-slide-toggle-' + Math.floor(Math.random() * 10000);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵDgSlideToggleComponent_BaseFactory;
        return function DgSlideToggleComponent_Factory(t) {
          return (ɵDgSlideToggleComponent_BaseFactory || (ɵDgSlideToggleComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DgSlideToggleComponent)))(t || DgSlideToggleComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgSlideToggleComponent,
        selectors: [["app-dg-slide-toggle"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [1, "dg-slide-toggle-wrapper", 3, "id", "formGroup"], ["class", "dg-required-star", 4, "ngIf"], ["type", "checkbox", 1, "dg-slide-toggle-checkbox", 3, "formControlName"], [1, "dg-slide-toggle"], ["class", "dg-hint-message", 4, "ngIf"], ["class", "dg-error-message", 4, "ngIf"], [1, "dg-required-star"], [1, "dg-hint-message"], [1, "dg-error-message"]],
        template: function DgSlideToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DgSlideToggleComponent_ng_container_0_Template, 10, 7, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgIf, i2.CheckboxControlValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dg-slide-toggle-wrapper[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;align-items:center}.dg-slide-toggle-wrapper[_ngcontent-%COMP%]   .dg-slide-toggle-checkbox[_ngcontent-%COMP%]{display:none}.dg-slide-toggle-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin:0}.dg-slide-toggle-wrapper[_ngcontent-%COMP%]   .dg-slide-toggle[_ngcontent-%COMP%]{height:24px;width:40px;position:relative;border-radius:12px;background-color:#dee3e7}.dg-slide-toggle-wrapper[_ngcontent-%COMP%]   .dg-slide-toggle[_ngcontent-%COMP%]:after{content:\"\";display:block;width:20px;height:20px;border-radius:50%;background-color:#fff;position:absolute;top:2px;right:2px;transition:all .3s}.dg-slide-toggle-wrapper[_ngcontent-%COMP%]   .dg-slide-toggle-checkbox[_ngcontent-%COMP%]:checked ~ .dg-slide-toggle[_ngcontent-%COMP%]{background-color:#0040ff}.dg-slide-toggle-wrapper[_ngcontent-%COMP%]   .dg-slide-toggle-checkbox[_ngcontent-%COMP%]:checked ~ .dg-slide-toggle[_ngcontent-%COMP%]:after{right:18px}"]
      });
    }
  }
  return DgSlideToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgWheelSelectComponent = /*#__PURE__*/(() => {
  class DgWheelSelectComponent extends BaseFieldType {
    constructor() {
      super(...arguments);
      this.selectedIndex = 0;
      this.elementHeight = 40;
      this.id = 'dg-wheel-select-' + Math.floor(Math.random() * 10000);
      this.options = [];
    }
    ngOnInit() {
      this.setIndexByValue(false);
      if (this.form) {
        this.form.controls[this.formControlName].valueChanges.subscribe(() => {
          this.setIndexByValue();
        });
      }
    }
    ngAfterViewInit() {
      this.setManualScroll();
    }
    ngOnChanges(changes) {
      if (changes['options'] && !changes['options'].firstChange) {
        this.setIndexByValue();
      }
    }
    setIndexByValue(scrollAfterSetIndex = true) {
      const selectedIndex = this.options.findIndex(item => this.form && item.value === this.form.controls[this.formControlName].value);
      if (selectedIndex && selectedIndex > 0 && selectedIndex !== this.selectedIndex) {
        this.selectedIndex = selectedIndex;
        if (scrollAfterSetIndex) {
          this.setManualScroll();
        }
      }
    }
    setManualScroll() {
      setTimeout(() => {
        if (this.wheelSelect && this.wheelSelect.nativeElement) {
          this.wheelSelect.nativeElement.scrollTop = this.selectedIndex * this.elementHeight;
        }
      }, 0);
    }
    onScroll($event) {
      this.selectedIndex = Math.round($event.target.scrollTop / this.elementHeight);
      if (this.changeValueTimer) {
        clearTimeout(this.changeValueTimer);
      }
      this.changeValueTimer = setTimeout(() => {
        if (this.form) {
          this.form.controls[this.formControlName].setValue(this.options ? this.options[this.selectedIndex].value : null);
        }
      }, 200);
    }
    selectItem(index) {
      if (this.wheelSelect) {
        this.wheelSelect.nativeElement.scrollTop = index * this.elementHeight;
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵDgWheelSelectComponent_BaseFactory;
        return function DgWheelSelectComponent_Factory(t) {
          return (ɵDgWheelSelectComponent_BaseFactory || (ɵDgWheelSelectComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DgWheelSelectComponent)))(t || DgWheelSelectComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgWheelSelectComponent,
        selectors: [["app-dg-wheel-select"]],
        viewQuery: function DgWheelSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c14, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wheelSelect = _t.first);
          }
        },
        inputs: {
          options: "options"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 1,
        consts: [["wheelSelect", ""], [4, "ngIf"], [1, "dd-wheel-select-wrapper", 3, "id"], [1, "dg-wheel-select", 3, "scroll"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "dg-hint-message", 4, "ngIf"], ["class", "dg-error-message", 4, "ngIf"], [3, "click", "ngClass"], [1, "dg-hint-message"], [1, "dg-error-message"]],
        template: function DgWheelSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, DgWheelSelectComponent_ng_container_0_Template, 7, 4, "ng-container", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dd-wheel-select-wrapper[_ngcontent-%COMP%]{position:relative}.dd-wheel-select-wrapper[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;box-shadow:inset 0 -40px 60px #fff,inset 0 40px 60px #fff}.dd-wheel-select-wrapper[_ngcontent-%COMP%]   .dg-wheel-select[_ngcontent-%COMP%]{scroll-snap-type:y mandatory;height:180px;overflow:auto;padding:70px 0;box-sizing:border-box;scroll-behavior:smooth;-ms-overflow-style:none;scrollbar-width:none}.dd-wheel-select-wrapper[_ngcontent-%COMP%]   .dg-wheel-select[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.dd-wheel-select-wrapper[_ngcontent-%COMP%]   .dg-wheel-select[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{scroll-snap-align:center;height:40px;display:flex;justify-content:center;align-items:center;font-size:14px;transition:all .1s}.dd-wheel-select-wrapper[_ngcontent-%COMP%]   .dg-wheel-select[_ngcontent-%COMP%] > div.selected[_ngcontent-%COMP%]{color:#0040ff;font-size:16px}"]
      });
    }
  }
  return DgWheelSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NumberPickerComponent = /*#__PURE__*/(() => {
  class NumberPickerComponent {
    constructor(formBuilder) {
      this.formBuilder = formBuilder;
      this.list = [];
      this.value = '';
      this.valueChange = new EventEmitter();
      this.form = this.formBuilder.group({
        input: [this.value]
      });
      this.form.controls['input'].valueChanges.subscribe(value => {
        this.valueChange.emit(value);
      });
    }
    ngOnChanges(changes) {
      if (changes['value'] && this.value !== this.form.value.input) {
        this.form.controls['input'].setValue(this.value);
      }
    }
    static {
      this.ɵfac = function NumberPickerComponent_Factory(t) {
        return new (t || NumberPickerComponent)(i0.ɵɵdirectiveInject(i2.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NumberPickerComponent,
        selectors: [["date-picker-number-picker"]],
        inputs: {
          list: "list",
          value: "value"
        },
        outputs: {
          valueChange: "valueChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 2,
        consts: [[1, "wrapper"], [3, "form", "options"]],
        template: function NumberPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "app-dg-wheel-select", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("form", ctx.form)("options", ctx.list);
          }
        },
        dependencies: [DgWheelSelectComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:20px 0}.select[_ngcontent-%COMP%]{border:1px solid #e1e1e1;background:#fff;width:100%;font-size:16px;text-align:center;padding:2px 8px}.select[_ngcontent-%COMP%]:focus{outline:none;border-color:#0040ff}.date-picker-numbers-list[_ngcontent-%COMP%]{position:relative}.date-picker-numbers-list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]{text-align:center;height:100%}.date-picker-numbers-list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{height:40px;line-height:40px}"]
      });
    }
  }
  return NumberPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DatePickerComponent = /*#__PURE__*/(() => {
  class DatePickerComponent {
    constructor() {
      this.value = {
        year: '',
        month: '',
        day: ''
      };
      this.datePickerConfig = {
        year: true,
        month: true,
        day: true,
        monthNumber: false
      };
      this.dateRange = 'all';
      this.close = new EventEmitter();
      this.futureYearsOffset = 10;
      this.pastYearsOffset = 120;
      this.emptyInitialize = false;
      this.lists = {
        year: [],
        month: [],
        day: []
      };
      this.monthTitle = {
        1: 'فروردین',
        2: 'اردیبهشت',
        3: 'خرداد',
        4: 'تیر',
        5: 'مرداد',
        6: 'شهریور',
        7: 'مهر',
        8: 'آبان',
        9: 'آذر',
        10: 'دی',
        11: 'بهمن',
        12: 'اسفند'
      };
    }
    ngOnInit() {
      if (this.value.year === '' && !this.emptyInitialize) {
        this.value.year = moment().locale('fa').format('YYYY');
        this.value.month = moment().locale('fa').format('MM');
        this.value.day = moment().locale('fa').format('DD');
      }
      this.makeLists();
    }
    ngOnChanges(changes) {
      if (changes['futureYearsOffset'] && changes['futureYearsOffset'].currentValue !== changes['futureYearsOffset'].previousValue) {
        this.makeLists();
      }
      if (changes['pickers'] && changes['pickers'].currentValue !== changes['pickers'].previousValue) {
        this.makeLists();
      }
    }
    valueChangedCallback() {
      this.makeMonthsList();
      this.makeDaysList();
    }
    makeLists() {
      this.makeYearsList();
      this.makeMonthsList();
      this.makeDaysList();
    }
    makeYearsList() {
      const years = [{
        value: '',
        title: 'سال'
      }];
      const currentYear = parseInt(moment().locale('fa').format('YYYY'), 10);
      let fromYear = currentYear - this.pastYearsOffset;
      let toYear = currentYear + this.futureYearsOffset;
      if (this.dateRange === 'past') {
        toYear = currentYear;
      }
      if (this.dateRange === 'future') {
        fromYear = currentYear;
      }
      for (let y = fromYear; y <= toYear; y++) {
        const beginningOfYear = moment(y, 'jYYYY');
        const endOfYear = moment(y + 1, 'jYYYY').subtract(1, 'day');
        if (this.checkWithCallback(beginningOfYear) || this.checkWithCallback(endOfYear)) {
          years.push({
            value: String(y),
            title: String(y)
          });
        }
      }
      this.lists.year = years;
    }
    makeMonthsList() {
      const months = [{
        value: '',
        title: 'ماه'
      }];
      const currentYear = parseInt(moment().locale('fa').format('YYYY'), 10);
      let minMonth = 1;
      let maxMonth = 12;
      if (this.dateRange === 'past' && parseInt(this.value.year, 10) === currentYear) {
        maxMonth = parseInt(moment().locale('fa').format('MM'), 10);
      }
      if (this.dateRange === 'future' && parseInt(this.value.year, 10) === currentYear) {
        minMonth = parseInt(moment().locale('fa').format('MM'), 10);
      }
      for (let m = minMonth; m <= maxMonth; m++) {
        /*if (!this.value.year) {
          break;
        }*/
        const beginningOfMonth = moment(this.value.year + '/' + m, 'jYYYY/jMM');
        const endOfMonth = moment(this.value.year + '/' + (m + 1), 'jYYYY/jMM').subtract(1, 'days');
        if (this.checkWithCallback(beginningOfMonth) || this.checkWithCallback(endOfMonth)) {
          months.push({
            value: String(m).padStart(2, '0'),
            title: this.datePickerConfig.monthNumber ? String(m).padStart(2, '0') : this.monthTitle[m]
          });
        }
      }
      this.lists.month = months;
    }
    makeDaysList() {
      const days = [{
        value: '',
        title: 'روز'
      }];
      let minDay = 1;
      let maxDay = parseInt(this.value.month, 10) <= 6 ? 31 : 30;
      const today = moment();
      if (this.dateRange === 'past' && parseInt(today.format('jYYYY'), 10) === parseInt(this.value.year, 10) && parseInt(today.format('jMM'), 10) === parseInt(this.value.month, 10)) {
        maxDay = parseInt(today.format('jDD'), 10);
      }
      if (this.dateRange === 'future' && parseInt(today.format('jYYYY'), 10) === parseInt(this.value.year, 10) && parseInt(today.format('jMM'), 10) === parseInt(this.value.month, 10)) {
        minDay = parseInt(today.format('jDD'), 10);
      }
      for (let m = minDay; m <= maxDay; m++) {
        if (!this.value.year || !this.value.month) {
          break;
        }
        const day = moment(this.value.year + '/' + this.value.month + '/' + m, 'jYYYY/jMM/jDD');
        if (this.checkWithCallback(day)) {
          const d = String(m).padStart(2, '0');
          days.push({
            value: d,
            title: d
          });
        }
      }
      this.lists.day = days;
    }
    isFilled() {
      return this.value.year && this.value.month && (this.datePickerConfig.day && this.value.day || !this.datePickerConfig.day);
    }
    getDismissData() {
      let formatted = '';
      let milliseconds = null;
      let unix = null;
      if (this.isFilled()) {
        formatted = this.value.year + '/' + this.value.month + '/' + (this.datePickerConfig.day ? this.value.day : '01');
        milliseconds = moment(formatted, 'jYYYY/jMM/jDD').valueOf();
        unix = moment(formatted, 'jYYYY/jMM/jDD').format('X');
      }
      return {
        formatted,
        milliseconds,
        unix
      };
    }
    clearButtonClick() {
      this.value = {
        year: '',
        month: '',
        day: ''
      };
      this.close.emit(this.getDismissData());
    }
    confirmClick() {
      this.close.emit(this.getDismissData());
    }
    /**
     *
     */
    checkWithCallback(moment) {
      if (!this.checkerFunction) {
        return true;
      }
      return this.checkerFunction(moment);
    }
    static {
      this.ɵfac = function DatePickerComponent_Factory(t) {
        return new (t || DatePickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DatePickerComponent,
        selectors: [["date-picker"]],
        inputs: {
          value: "value",
          datePickerConfig: "datePickerConfig",
          futureYearsOffset: "futureYearsOffset",
          pastYearsOffset: "pastYearsOffset"
        },
        outputs: {
          close: "close"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 10,
        vars: 4,
        consts: [[1, "date-picker"], [1, "body"], ["class", "number-picker", 3, "value", "list", "valueChange", 4, "ngIf"], [1, "actions"], [1, "reject", 3, "click"], [1, "resolve", 3, "click", "disabled"], [1, "number-picker", 3, "valueChange", "value", "list"]],
        template: function DatePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, DatePickerComponent_date_picker_number_picker_2_Template, 1, 2, "date-picker-number-picker", 2)(3, DatePickerComponent_date_picker_number_picker_3_Template, 1, 2, "date-picker-number-picker", 2)(4, DatePickerComponent_date_picker_number_picker_4_Template, 1, 2, "date-picker-number-picker", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3)(6, "button", 4);
            i0.ɵɵlistener("click", function DatePickerComponent_Template_button_click_6_listener() {
              return ctx.clearButtonClick();
            });
            i0.ɵɵtext(7, "\u062D\u0630\u0641");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 5);
            i0.ɵɵlistener("click", function DatePickerComponent_Template_button_click_8_listener() {
              return ctx.confirmClick();
            });
            i0.ɵɵtext(9, "\u062A\u0627\u06CC\u06CC\u062F");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.datePickerConfig.year);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.datePickerConfig.month);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.datePickerConfig.day);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", !ctx.value.day || !ctx.value.month || !ctx.value.year);
          }
        },
        dependencies: [i1.NgIf, NumberPickerComponent],
        styles: [":root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:root .inverted{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark .inverted{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.date-picker-bottom-sheet{padding:0!important}.date-picker{display:flex;flex-direction:column}.date-picker .body{display:flex;flex-direction:row;padding:0 20px;justify-content:space-between;position:relative}.date-picker .number-picker{flex:30% 1 0;padding:0 1%;margin:0 4px}.date-picker .actions{padding:16px 24px;display:flex;justify-content:space-between;border-bottom:1px solid rgba(0,0,0,.1);direction:rtl}.date-picker .actions button{display:inline-block;width:calc(60% - 8px);flex:0 0 calc(40% - 8px);padding:13px 25px;background:#0040ff;color:#fff;border-radius:12px;border:1px solid transparent;font-size:1rem;cursor:pointer;text-align:center}.date-picker .actions .reject{border:none;background:none;color:#424c5c}.date-picker .actions .resolve:disabled{background:#e5e5e5;color:#b2b2b2}.date-picker .overlay{position:absolute;width:100%;height:24%;content:\" \";left:0}.date-picker .overlay.top{top:0;background:linear-gradient(to bottom,#f2f2f2 50%,#f2f2f2a8 70%,#f2f2f200)}.date-picker .overlay.bottom{bottom:0;background:linear-gradient(to top,#f2f2f2 50%,#f2f2f2a8 70%,#f2f2f200)}\n"],
        encapsulation: 2
      });
    }
  }
  return DatePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DatePickerBottomSheetComponent = /*#__PURE__*/(() => {
  class DatePickerBottomSheetComponent extends DatePickerComponent {
    constructor(_ref, data) {
      super();
      this._ref = _ref;
      this.data = data;
      this.futureYearsOffset = 20;
      this.emptyInitialize = true;
      let date = data.value ? moment(data.value) : moment();
      if (this.data.checker && this.data.checker(date)) {
        this.value = {
          year: date.format('jYYYY'),
          month: date.format('jMM'),
          day: date.format('jDD')
        };
      } else {
        this.value = {
          year: '',
          month: '',
          day: ''
        };
      }
      if (data.datePickerConfig) {
        this.datePickerConfig = data.datePickerConfig;
      }
      if (data.hasOwnProperty('dateRange')) {
        this.dateRange = data.dateRange;
      }
      if (data.checker) {
        this.checkerFunction = data.checker;
      }
    }
    clearButtonClick() {
      this.value = {
        year: '',
        month: '',
        day: ''
      };
      this._ref.dismiss(this.getDismissData());
    }
    confirmClick() {
      this._ref.dismiss(this.getDismissData());
    }
    static {
      this.ɵfac = function DatePickerBottomSheetComponent_Factory(t) {
        return new (t || DatePickerBottomSheetComponent)(i0.ɵɵdirectiveInject(i1$1.MatBottomSheetRef), i0.ɵɵdirectiveInject(MAT_BOTTOM_SHEET_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DatePickerBottomSheetComponent,
        selectors: [["date-picker-bottom-sheet"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 10,
        vars: 4,
        consts: [[1, "date-picker"], [1, "body"], ["class", "number-picker", 3, "value", "list", "valueChange", 4, "ngIf"], [1, "actions"], [1, "reject", 3, "click"], [1, "resolve", 3, "click", "disabled"], [1, "number-picker", 3, "valueChange", "value", "list"]],
        template: function DatePickerBottomSheetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, DatePickerBottomSheetComponent_date_picker_number_picker_2_Template, 1, 2, "date-picker-number-picker", 2)(3, DatePickerBottomSheetComponent_date_picker_number_picker_3_Template, 1, 2, "date-picker-number-picker", 2)(4, DatePickerBottomSheetComponent_date_picker_number_picker_4_Template, 1, 2, "date-picker-number-picker", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3)(6, "button", 4);
            i0.ɵɵlistener("click", function DatePickerBottomSheetComponent_Template_button_click_6_listener() {
              return ctx.clearButtonClick();
            });
            i0.ɵɵtext(7, "\u062D\u0630\u0641");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 5);
            i0.ɵɵlistener("click", function DatePickerBottomSheetComponent_Template_button_click_8_listener() {
              return ctx.confirmClick();
            });
            i0.ɵɵtext(9, "\u062A\u0627\u06CC\u06CC\u062F");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.datePickerConfig.year);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.datePickerConfig.month);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.datePickerConfig.day);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", !ctx.value.day || !ctx.value.month || !ctx.value.year);
          }
        },
        dependencies: [i1.NgIf, NumberPickerComponent],
        styles: [_c16],
        encapsulation: 2
      });
    }
  }
  return DatePickerBottomSheetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isIOsDevice() {
  const w = window;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !w.MSStream;
}
function isAndroidDevice() {
  return /(android)/i.test(navigator.userAgent);
}
function isMobileOrTablet() {
  let check = false;
  const w = window;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || w.opera);
  return check;
}
function supportsTouch() {
  return isIOsDevice() || isAndroidDevice() || isMobileOrTablet();
}
let CalendarDatePickerComponent = /*#__PURE__*/(() => {
  class CalendarDatePickerComponent {
    constructor(platformId) {
      this.platformId = platformId;
      this.label = 'انتخاب تاریخ';
      this.visible = false;
      this.pick = new EventEmitter();
      this.close = new EventEmitter();
      this.allowFuture = true;
      this.justFuture = false;
      this.initialView = 'days';
      this.showTime = false;
      this.datePickerConfig = input({
        year: true,
        month: true,
        day: true,
        monthNumber: false
      });
      this.view = 'days';
      this.years = [];
      this.yearsOffset = 0;
      this.weeks = [];
      this.pickType = 'default';
      this.position = {
        top: '',
        left: ''
      };
      this.noSpaceToCenter = false;
      this.monthPickerWidth = 220;
      this.monthPickerHeight = 200;
      this.calendarWidth = 360;
      this.calendarHeight = 320;
      this.monthList = [];
      this.timeHour = '00';
      this.timeMinute = '00';
      this.timeSecond = '00';
      this.timeMiliSecond = '000';
      this.today = moment();
      if (this.value) {
        this.selectedDate = moment(this.value);
        this.currentDate = this.selectedDate.clone();
        this.currentDateChanged();
      }
      if (this.platformId.toUpperCase() !== 'SERVER') {
        this.reposition = this.reposition.bind(this);
      }
    }
    ngOnChanges(changes) {
      if (changes['value'] && changes['value'].currentValue && changes['value'].currentValue !== changes['value'].previousValue) {
        this.selectedDate = moment(this.value);
        this.currentDate = this.selectedDate.clone();
        this.currentDateChanged();
      }
      if (this.input && changes['visible'] && changes['visible'].currentValue) {
        if (this.platformId.toUpperCase() !== 'SERVER') {
          this.reposition();
        }
      }
    }
    ngOnInit() {
      this.currentDate = this.selectedDate ? this.selectedDate : moment();
      this.currentDateChanged();
      this.makeMonths();
      if (this.pickType === 'month-picker') {
        this.makeYears();
      }
      this.checkInitialView();
      if (this.platformId.toUpperCase() !== 'SERVER') {
        window.addEventListener('resize', this.reposition);
      }
      document.body.appendChild(this.datePickerBackdrop.nativeElement);
    }
    ngAfterViewInit() {
      if (this.platformId.toUpperCase() !== 'SERVER') {
        this.reposition();
        setTimeout(() => {
          this.initClock();
        }, 200);
      }
    }
    ngOnDestroy() {
      if (this.platformId.toUpperCase() !== 'SERVER') {
        window.removeEventListener('resize', this.reposition);
      }
      document.body.removeChild(this.datePickerBackdrop.nativeElement);
    }
    checkInitialView() {
      this.view = this.initialView;
      switch (this.initialView) {
        case 'days':
          break;
        case 'months':
          break;
        case 'years':
          this.yearView();
          break;
      }
    }
    currentDateChanged() {
      this.setDaysOfMonth();
    }
    setDaysOfMonth() {
      let weeks = [];
      if (!this.currentDate) {
        return;
      }
      const days = this.currentDate.locale('fa').jDaysInMonth();
      const startOfMonth = this.currentDate.clone().locale('fa').startOf('month');
      let week = [null, null, null, null, null, null, null];
      for (let day = 0; day < days; day++) {
        let thatDay = startOfMonth.clone().add(day, 'days');
        let dn = 0;
        if (thatDay.day() <= 5) {
          dn = thatDay.day() + 1;
        } else {
          dn = 0;
        }
        week[dn] = thatDay;
        if (dn === 6) {
          weeks.push(week);
          week = [null, null, null, null, null, null, null];
        }
        if (day + 1 >= days) {
          // last week
          weeks.push(week);
        }
      }
      this.weeks = weeks;
    }
    nextMonth() {
      if (!this.currentDate) {
        return;
      }
      this.currentDate.add(1, 'months');
      this.currentDateChanged();
    }
    prevMonth() {
      if (!this.currentDate) {
        return;
      }
      this.currentDate.subtract(1, 'months');
      this.currentDateChanged();
    }
    monthView() {
      this.makeMonths();
      this.view = 'months';
    }
    makeMonths(simple = false) {
      if (!this.currentDate) {
        return;
      }
      let months = [];
      const startOfYear = this.currentDate.clone().locale('fa').startOf('year');
      for (let i = 0; i < 12; i++) {
        if (simple) {
          months.push(startOfYear.clone().add(i, 'months').format('MM'));
        } else {
          months.push(startOfYear.clone().add(i, 'months'));
        }
      }
      this.monthList = months;
    }
    yearView() {
      this.view = 'years';
      this.yearsOffset = 0;
      this.makeYears();
    }
    makeYears() {
      let years = [];
      let base = moment();
      if (this.selectedDate) {
        base = this.selectedDate.clone();
      }
      const currentYear = parseInt(base.locale('fa').format('YYYY')) - this.yearsOffset * 20;
      const page = Math.floor((currentYear - 1) / 20);
      for (let year = page * 20 + 1; year <= (page + 1) * 20; year++) {
        years.push(year);
      }
      this.years = years;
    }
    nextYears() {
      this.yearsOffset += 1;
      this.makeYears();
    }
    prevYears() {
      this.yearsOffset -= 1;
      this.makeYears();
    }
    /*
    |--------------------------------------------------------------------------
    | Check
    |--------------------------------------------------------------------------
    |
    */
    isSelectedDay(day) {
      if (!day) {
        return false;
      }
      return this.selectedDate && day && this.selectedDate.locale('fa').format('YYYY/MM/DD') === day.locale('fa').format('YYYY/MM/DD');
    }
    isDisabledDay(day) {
      if (!day) {
        return false;
      }
      const isAllowed = this.checkWithCallbackFunction(day);
      if (!isAllowed) {
        return true;
      }
      if (this.justFuture) {
        return +day.format('jYYYYjMMjDD') < +this.today.format('jYYYYjMMjDD');
      }
      return day.isAfter(this.today) && !this.allowFuture;
    }
    isDisabledYear(year) {
      const beginningOfYear = moment(year, 'jYYYY');
      const endOfYear = moment(year + 1, 'jYYYY').subtract(1, 'day');
      if (!this.checkWithCallbackFunction(beginningOfYear) && !this.checkWithCallbackFunction(endOfYear)) {
        return true;
      }
      if (this.justFuture) {
        return parseInt(this.today.locale('fa').format('YYYY'), 0) > year;
      }
      if (this.allowFuture) {
        return false;
      }
      return parseInt(this.today.locale('fa').format('YYYY')) < year;
    }
    checkWithCallbackFunction(moment) {
      if (!this.checkCallback) {
        // no callback function is defined
        return true;
      }
      // console.log(moment.locale('fa').format('YYYY'));
      // console.log(this.checkCallback(moment));
      return this.checkCallback(moment);
    }
    isDisabledMonth(month) {
      if (!this.checkWithCallbackFunction(month) && !this.checkWithCallbackFunction(month.clone().add(1, 'month').subtract(1, 'day'))) {
        return true;
      }
      if (this.justFuture) {
        return +month.format('jYYYYjMM') < +this.today.format('jYYYYjMM');
      }
      return !this.allowFuture && month.isAfter(this.today);
    }
    /*
    |--------------------------------------------------------------------------
    | CLick Handlers
    |--------------------------------------------------------------------------
    */
    yearClick(year) {
      if (!this.isDisabledYear(year)) {
        this.currentDate = moment.from(year + '/01+/01', 'fa', 'YYYY/MM/DD');
        this.monthView();
      }
    }
    monthClick(moment) {
      if (!this.checkWithCallbackFunction(moment)) {
        return;
      }
      if (!this.allowFuture && moment.isAfter(this.today)) {
        return;
      }
      if (this.justFuture && +moment.format('jYYYYjMM') < +this.today.format('jYYYYjMM')) {
        return;
      }
      this.currentDate = moment.clone();
      this.currentDateChanged();
      if (this.datePickerConfig() && !this.datePickerConfig().day) {
        this.selectedDate = moment;
        this.view = 'years';
        this.onPick();
      } else {
        this.view = 'days';
      }
    }
    dayClick(moment) {
      if (moment) {
        const isAllowed = this.checkWithCallbackFunction(moment);
        if (!isAllowed) {
          return;
        }
        if (!this.allowFuture && moment.isAfter(this.today)) {
          return;
        }
        if (this.justFuture && +moment.format('jYYYYjMMjDD') < +this.today.format('jYYYYjMMjDD')) {
          return;
        }
        this.selectedDate = moment;
        this.setTime();
      }
    }
    backdropClick($event) {
      const el = $event.target;
      if (!el.classList.contains('digipay-date-picker-backdrop')) {
        $event.preventDefault();
        $event.stopPropagation();
        $event.stopImmediatePropagation();
        return;
      }
      this.visible = false;
      this.onClose();
    }
    /*
    |--------------------------------------------------------------------------
    | Events
    |--------------------------------------------------------------------------
    */
    onClose() {
      this.close.emit(this.selectedDate);
    }
    onPick() {
      this.pick.emit(this.selectedDate);
    }
    monthPickerClose(data) {
      if (data.milliseconds) {
        this.selectedDate = moment(data.milliseconds);
        this.onPick();
      } else {
        this.selectedDate = undefined;
        this.onPick();
      }
    }
    /*
    |--------------------------------------------------------------------------
    | Positioning
    |--------------------------------------------------------------------------
    |
    */
    calcTopPosition() {
      if (!this.datePickerUi || !this.input) {
        return 0;
      }
      const datePickerUiRect = this.datePickerUi.nativeElement.getBoundingClientRect();
      const rect = this.input.getBoundingClientRect();
      let calculatedTop = rect.top + rect.height + 15;
      const defaultHeight = this.pickType === 'default' ? this.calendarHeight : this.monthPickerHeight;
      const datePickerHeight = datePickerUiRect.height ? datePickerUiRect.height : defaultHeight;
      if (calculatedTop + datePickerHeight > window.innerHeight) {
        let howMuchVerticalSpaceIsNeeded = calculatedTop + datePickerHeight - window.innerHeight;
        calculatedTop = calculatedTop - howMuchVerticalSpaceIsNeeded;
      }
      return calculatedTop;
    }
    calcLeftPosition() {
      if (!this.input) {
        return 0;
      }
      const componentWidth = this.pickType === 'default' ? this.calendarWidth : this.monthPickerWidth;
      const rect = this.input.getBoundingClientRect();
      let calculatedLeft = rect.width / 2 + rect.left - componentWidth / 2;
      const willOverflowX = calculatedLeft + componentWidth > window.innerWidth;
      if (willOverflowX) {
        // the calculated left position will cause to
        // item to move outside the page.
        calculatedLeft = window.innerWidth - componentWidth - 20;
      }
      return calculatedLeft > 10 ? calculatedLeft : 10;
    }
    reposition() {
      let left = '0px';
      let top = '0px';
      if (this.input) {
        left = this.calcLeftPosition() + 'px';
        top = this.calcTopPosition() + 'px';
      } else {
        this.noSpaceToCenter = false;
      }
      this.position = {
        left,
        top
      };
    }
    initClock() {
      if (this.selectedDate) {
        this.timeHour = this.convertToClockType(this.selectedDate.hour());
        this.timeMinute = this.convertToClockType(this.selectedDate.minute());
        this.timeSecond = this.convertToClockType(this.selectedDate.second());
        this.timeMiliSecond = this.convertToClockType(this.selectedDate.millisecond());
      }
    }
    setTime(event = null) {
      if (event) {
        const target = event.target;
        target.value = this.convertToClockType(target.value);
      }
      this.selectedDate.hour(parseInt(this.timeHour, 10)).minute(parseInt(this.timeMinute, 10)).second(parseInt(this.timeSecond, 10)).millisecond(parseInt(this.timeMiliSecond, 10));
      this.onPick();
    }
    convertToClockType(val) {
      const integerVal = Number.parseInt(val, 10);
      if (val.length === 0 || val === '0') {
        return '00';
      } else if (integerVal < 10 && val !== '00') {
        return '0' + integerVal;
      } else {
        return val;
      }
    }
    static {
      this.ɵfac = function CalendarDatePickerComponent_Factory(t) {
        return new (t || CalendarDatePickerComponent)(i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CalendarDatePickerComponent,
        selectors: [["ui-calendar-date-picker"]],
        viewQuery: function CalendarDatePickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c17, 5);
            i0.ɵɵviewQuery(_c18, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerUi = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerBackdrop = _t.first);
          }
        },
        inputs: {
          label: "label",
          input: "input",
          visible: "visible",
          value: "value",
          allowFuture: "allowFuture",
          justFuture: "justFuture",
          checkCallback: "checkCallback",
          initialView: "initialView",
          showTime: "showTime",
          datePickerConfig: [i0.ɵɵInputFlags.SignalBased, "datePickerConfig"],
          pickType: "pickType"
        },
        outputs: {
          pick: "pick",
          close: "close"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 7,
        vars: 9,
        consts: [["datePickerBackdrop", ""], ["datePickerUi", ""], [1, "digipay-date-picker-backdrop", 3, "click", "hidden"], [1, "digipay-date-picker-ui", 3, "ngStyle", "ngClass"], ["class", "date-picker-body", 4, "ngIf"], ["class", "date-picker-body month-picker", 4, "ngIf"], ["class", "time-picker-body", 4, "ngIf"], [1, "date-picker-body"], [4, "ngIf"], ["class", "month-view", 4, "ngIf"], ["class", "year-view", 4, "ngIf"], [1, "date-picker-header"], [1, "arrow-right", 3, "click"], [1, "arrow-left", 3, "click"], [1, "week-days"], [1, "is-short"], [1, "month-days"], ["class", "week", 4, "ngFor", "ngForOf"], [1, "go-to-month-view", 3, "click"], [1, "go-to-year-view", 3, "click"], [1, "week"], ["class", "day", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "day", 3, "click", "ngClass"], [1, "month-view"], ["class", "month", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "month", 3, "click", "ngClass"], [1, "year-view"], [1, "years"], ["class", "year", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "year", 3, "click", "ngClass"], [1, "date-picker-body", "month-picker"], [3, "close", "value", "datePickerConfig"], [1, "time-picker-body"], ["data-max-number", "23", "maxlength", "2", "pattern", "[0-9]*", "placeholder", "HH", "type", "text", 3, "blur", "ngModelChange", "ngModel"], ["data-max-number", "59", "maxlength", "2", "pattern", "[0-9]*", "placeholder", "MM", "type", "text", 3, "blur", "ngModelChange", "ngModel"], ["data-max-number", "59", "maxlength", "2", "pattern", "[0-9]*", "placeholder", "SS", "type", "text", 3, "blur", "ngModelChange", "ngModel"]],
        template: function CalendarDatePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2, 0);
            i0.ɵɵlistener("click", function CalendarDatePickerComponent_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.backdropClick($event));
            });
            i0.ɵɵelementStart(2, "div", 3, 1);
            i0.ɵɵtemplate(4, CalendarDatePickerComponent_div_4_Template, 4, 3, "div", 4)(5, CalendarDatePickerComponent_div_5_Template, 2, 6, "div", 5)(6, CalendarDatePickerComponent_div_6_Template, 8, 3, "div", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", !ctx.visible);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngStyle", ctx.position)("ngClass", i0.ɵɵpureFunction2(6, _c19, ctx.pickType === "default", ctx.pickType === "month-picker"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.pickType === "default");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pickType === "month-picker");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showTime);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgStyle, i2.DefaultValueAccessor, i2.NgControlStatus, i2.MaxLengthValidator, i2.PatternValidator, i2.NgModel, DatePickerComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.digipay-date-picker-backdrop[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:10000}.digipay-date-picker-ui[_ngcontent-%COMP%]{position:fixed;width:360px;border:1px solid #e0e0e0;border-radius:8px;color:#4c4c4c;z-index:6;box-sizing:border-box;background:#fff;-webkit-user-select:none;user-select:none}.digipay-date-picker-ui[_ngcontent-%COMP%]:after{content:\" \";position:absolute;top:-8px;left:50%;transform:translate(-50%);width:40px;height:10px;background:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"16\" viewBox=\"0 0 48 16\">%0D%0A    <g fill=\"none\" fill-rule=\"evenodd\">%0D%0A        <path fill=\"%23FFF\" d=\"M36.038 6.771l-8.116-4.565a8 8 0 0 0-7.844 0l-8.425 4.74A16 16 0 0 1 3.809 9H0l8 7h32c5.333-4.392 8-6.725 8-7 0-.186-1.228-.246-3.684-.18a16 16 0 0 1-8.278-2.049z\"/>%0D%0A        <path stroke=\"%23CCC\" d=\"M48 9h-5.003c-3.164 0-6.255-.952-8.87-2.733L28.173 2.29a8 8 0 0 0-8.501-.245l-8.918 5.246C8.297 8.737 2.853 9 0 9\"/>%0D%0A    </g>%0D%0A</svg>%0D%0A') no-repeat top center/40px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .date-picker-body[_ngcontent-%COMP%]{direction:rtl;padding:16px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .date-picker-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:24px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .date-picker-header[_ngcontent-%COMP%]   .arrow-left[_ngcontent-%COMP%], .digipay-date-picker-ui[_ngcontent-%COMP%]   .date-picker-header[_ngcontent-%COMP%]   .arrow-right[_ngcontent-%COMP%]{width:32px;height:24px;display:inline-block;cursor:pointer}.digipay-date-picker-ui[_ngcontent-%COMP%]   .date-picker-header[_ngcontent-%COMP%]   .arrow-left[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">%0D%0A    <defs>%0D%0A        <path id=\"a\" d=\"M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z\"/>%0D%0A    </defs>%0D%0A    <g fill=\"none\" fill-rule=\"evenodd\">%0D%0A        <path d=\"M0 0h24v24H0z\"/>%0D%0A        <mask id=\"b\" fill=\"%23fff\">%0D%0A            <use xlink:href=\"%23a\"/>%0D%0A        </mask>%0D%0A        <g fill=\"%23000\" fill-opacity=\".7\" mask=\"url(%23b)\">%0D%0A            <path d=\"M0 0h24v24H0z\"/>%0D%0A        </g>%0D%0A    </g>%0D%0A</svg>%0D%0A')}.digipay-date-picker-ui[_ngcontent-%COMP%]   .date-picker-header[_ngcontent-%COMP%]   .arrow-right[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">%0D%0A    <defs>%0D%0A        <path id=\"a\" d=\"M8.59 7.41L10 6l6 6-6 6-1.41-1.41L13.17 12z\"/>%0D%0A    </defs>%0D%0A    <g fill=\"none\" fill-rule=\"evenodd\">%0D%0A        <path d=\"M0 0h24v24H0z\"/>%0D%0A        <mask id=\"b\" fill=\"%23fff\">%0D%0A            <use xlink:href=\"%23a\"/>%0D%0A        </mask>%0D%0A        <g fill=\"%234D4D4D\" mask=\"url(%23b)\">%0D%0A            <path d=\"M0 0h24v24H0z\"/>%0D%0A        </g>%0D%0A    </g>%0D%0A</svg>%0D%0A')}.digipay-date-picker-ui[_ngcontent-%COMP%]   .week-days[_ngcontent-%COMP%]{color:#7f7f7f;display:flex;flex-direction:row;font-size:10px;margin-bottom:12px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .week-days[_ngcontent-%COMP%]   .is-short[_ngcontent-%COMP%]{display:none}.digipay-date-picker-ui[_ngcontent-%COMP%]   .week-days[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{flex-basis:14.2857142857%;text-align:center}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]   .week[_ngcontent-%COMP%]{display:flex;flex-direction:row}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]   .week[_ngcontent-%COMP%]   .day[_ngcontent-%COMP%]{text-align:center;flex-basis:14.2857142857%;display:inline-block;padding:9px 0;border-radius:10px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]   .week[_ngcontent-%COMP%]   .day.is-selectable[_ngcontent-%COMP%]{cursor:pointer}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]   .week[_ngcontent-%COMP%]   .day.is-selectable[_ngcontent-%COMP%]:hover{background:#fafafa}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]   .week[_ngcontent-%COMP%]   .day.is-today[_ngcontent-%COMP%]{background:#e4e4e4!important}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]   .week[_ngcontent-%COMP%]   .day.is-selected[_ngcontent-%COMP%]{background:#39bf7c!important;color:#fff!important}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-days[_ngcontent-%COMP%]   .week[_ngcontent-%COMP%]   .day.is-disabled[_ngcontent-%COMP%]{opacity:.25!important;cursor:not-allowed}.digipay-date-picker-ui[_ngcontent-%COMP%]   .go-to-month-view[_ngcontent-%COMP%], .digipay-date-picker-ui[_ngcontent-%COMP%]   .go-to-year-view[_ngcontent-%COMP%]{cursor:pointer;border-bottom:1px dotted #868686}.digipay-date-picker-ui[_ngcontent-%COMP%]   .go-to-month-view[_ngcontent-%COMP%]:hover, .digipay-date-picker-ui[_ngcontent-%COMP%]   .go-to-year-view[_ngcontent-%COMP%]:hover{border-bottom-style:solid}.digipay-date-picker-ui[_ngcontent-%COMP%]   .go-to-month-view[_ngcontent-%COMP%]{margin-left:10px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;direction:rtl}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-view[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%]{text-align:center;flex-basis:25%;cursor:pointer;padding:10px 0;font-size:12px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-view[_ngcontent-%COMP%]   .month.is-disabled[_ngcontent-%COMP%]{opacity:.25}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-view[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;border-radius:10px;padding:20px 10px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-view[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%]:hover   span[_ngcontent-%COMP%]{background:#fafafa}.digipay-date-picker-ui[_ngcontent-%COMP%]   .year-view[_ngcontent-%COMP%]   .years[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;direction:ltr}.digipay-date-picker-ui[_ngcontent-%COMP%]   .year-view[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%]{cursor:pointer;text-align:center;flex-basis:20%;font-size:14px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .year-view[_ngcontent-%COMP%]   .year.is-disabled[_ngcontent-%COMP%]{opacity:.25}.digipay-date-picker-ui[_ngcontent-%COMP%]   .year-view[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;border-radius:10px;padding:15px 10px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .year-view[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%]:hover   span[_ngcontent-%COMP%]{background:#fafafa}.digipay-date-picker-ui[_ngcontent-%COMP%]   .month-picker[_ngcontent-%COMP%]{padding:0;direction:ltr;position:relative;border-radius:8px;overflow:hidden}.digipay-date-picker-ui.is-month-picker[_ngcontent-%COMP%]{width:220px;-webkit-user-select:auto;user-select:auto}.digipay-date-picker-ui.is-month-picker[_ngcontent-%COMP%]     .date-picker .actions{background:#fff}.time-picker-body[_ngcontent-%COMP%]{display:flex;align-items:center;margin-bottom:20px;justify-content:center;flex-direction:row-reverse;direction:rtl}.time-picker-body[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:35px;height:35px;display:flex;font-size:14px;border-radius:6px;text-align:center;align-items:center;letter-spacing:3px;border:none!important;justify-content:center;outline:none!important;background-color:#f8f8f8}.time-picker-body[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:15px;margin-left:5px;margin-right:5px}@media screen and (max-width: 370px){.digipay-date-picker-ui[_ngcontent-%COMP%]{width:280px}.digipay-date-picker-ui[_ngcontent-%COMP%]   .week-days[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:none}.digipay-date-picker-ui[_ngcontent-%COMP%]   .week-days[_ngcontent-%COMP%]   .is-short[_ngcontent-%COMP%]{display:inline}}"]
      });
    }
  }
  return CalendarDatePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DH_FORMAT = 'YYYY/MM/DD  HH:mm';
const D_FORMAT = 'YYYY/MM/DD';
const DHMS_FORMAT = 'YYYY/MM/DD  HH:mm:ss';
const YM_FORMAT = 'YYYY/MM';
let PersianDatePipe = /*#__PURE__*/(() => {
  class PersianDatePipe {
    transform(value, args) {
      if (value != null) {
        if (args && args === 'D_H') {
          return moment(value).locale('fa').format(DH_FORMAT);
        }
        if (args && args === 'D_HMS') {
          return moment(value).locale('fa').format(DHMS_FORMAT);
        }
        if (args && args === 'YM_FORMAT') {
          return moment(value).locale('fa').format(YM_FORMAT);
        }
        return moment(value).locale('fa').format(D_FORMAT);
      }
    }
    static {
      this.ɵfac = function PersianDatePipe_Factory(t) {
        return new (t || PersianDatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "persianDate",
        type: PersianDatePipe,
        pure: true
      });
    }
  }
  return PersianDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgDateComponent = /*#__PURE__*/(() => {
  class DgDateComponent extends BaseFieldType {
    constructor(bottomSheet) {
      super();
      this.bottomSheet = bottomSheet;
      this.visibleDatePicker = false;
      this.initialCalendarView = 'years';
      this.showTime = false;
      this.endPicker = true;
      this.datePickerMode = 'auto';
      this.dateRange = 'all';
      this.datePickerConfig = input({
        year: true,
        month: true,
        day: true,
        monthNumber: false
      });
      this.pickersPipeArgs = computed(() => {
        if (this.datePickerConfig() && !this.datePickerConfig().day) {
          return 'YM_FORMAT';
        }
        return '';
      });
      this.isFocused = false;
      this.id = 'dg-date-' + Math.floor(Math.random() * 10000);
      effect(() => {
        if (this.autoFocus()) {
          this.focusButton.nativeElement.click();
        }
      });
    }
    onFocusClicked() {
      this.input?.nativeElement.focus();
    }
    setDate(evt) {
      this.visibleDatePicker = false;
      const value = moment(evt).valueOf();
      if (this.form) {
        this.form.controls[this.formControlName].setValue(value);
        this.form.controls[this.formControlName].markAsTouched();
      }
    }
    toggleDatePicker() {
      if (this.readonly) {
        return;
      }
      if (supportsTouch() && this.datePickerMode === 'auto' || this.datePickerMode === 'bottomSheet') {
        this.bottomSheet.open(DatePickerBottomSheetComponent, {
          panelClass: 'date-picker-bottom-sheet',
          data: {
            dateRange: this.dateRange,
            checker: this.dateValidator.bind(this),
            value: this.form && this.form.controls[this.formControlName].value ? this.form.controls[this.formControlName].value : '',
            datePickerConfig: this.datePickerConfig()
          }
        }).afterDismissed().subscribe(data => {
          const result = data;
          if (!result) {
            return;
          }
          if (this.form) {
            this.form.controls[this.formControlName].setValue(result.milliseconds || null);
            this.form.controls[this.formControlName].markAsTouched();
          }
        });
      } else {
        this.visibleDatePicker = !this.visibleDatePicker;
      }
    }
    dateValidator(date) {
      const timestamp = +date.format('x');
      if (!this.customDateRange || this.customDateRange.length !== 2) {
        return true;
      }
      return this.customDateRange[0] <= timestamp && this.customDateRange[1] >= timestamp;
    }
    static {
      this.ɵfac = function DgDateComponent_Factory(t) {
        return new (t || DgDateComponent)(i0.ɵɵdirectiveInject(i1$1.MatBottomSheet));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgDateComponent,
        selectors: [["app-dg-date"]],
        viewQuery: function DgDateComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c24, 5);
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusButton = _t.first);
          }
        },
        inputs: {
          initialCalendarView: "initialCalendarView",
          showTime: "showTime",
          endPicker: "endPicker",
          datePickerMode: "datePickerMode",
          dateRange: "dateRange",
          customDateRange: "customDateRange",
          datePickerConfig: [i0.ɵɵInputFlags.SignalBased, "datePickerConfig"]
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 1,
        consts: [["focusButton", ""], ["dateInput", ""], [4, "ngIf"], [2, "display", "none", 3, "click"], [1, "date-picker-wrapper"], [1, "dg-input-wrapper", 3, "ngClass"], [3, "htmlFor"], ["class", "dg-required-star", 4, "ngIf"], [3, "formGroup"], [3, "focusin", "focusout", "click", "id", "placeholder", "readonly", "value"], [1, "dg-clean-icon", 3, "click"], ["class", "dg-hint-message", 4, "ngIf"], ["class", "dg-error-message", 4, "ngIf"], ["label", "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E", 1, "dg-date-picker", 3, "pick", "close", "visible", "value", "allowFuture", "justFuture", "input", "initialView", "checkCallback", "showTime", "datePickerConfig"], [1, "dg-required-star"], [1, "dg-hint-message"], [1, "dg-error-message"]],
        template: function DgDateComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, DgDateComponent_ng_container_0_Template, 16, 34, "ng-container", 2);
            i0.ɵɵelementStart(1, "button", 3, 0);
            i0.ɵɵlistener("click", function DgDateComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusClicked());
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.NgControlStatusGroup, i2.FormGroupDirective, CalendarDatePickerComponent, PersianDatePipe],
        styles: [".dg-date-picker[_ngcontent-%COMP%]{display:block}", _c26]
      });
    }
  }
  return DgDateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgAmountComponent = /*#__PURE__*/(() => {
  class DgAmountComponent extends BaseFieldType {
    get virtualValue() {
      if (this.hasRialStickyText()) {
        return this._virtualValue ? `${this.formatAmount(this._virtualValue)} ریال` : '';
      } else {
        return this._virtualValue;
      }
    }
    set virtualValue(val) {
      if (this.hasRialStickyText()) {
        this._virtualValue = val.replace(/\D/g, '');
      } else {
        this._virtualValue = val;
      }
    }
    constructor() {
      super();
      this.maxSize = 20;
      this._virtualValue = '';
      this.id = 'dg-amount-' + Math.floor(Math.random() * 10000);
      effect(() => {
        if (this.autoFocus()) {
          this.focusButton.nativeElement.click();
        }
      });
    }
    ngOnInit() {
      this.virtualValue = this.form?.controls[this.formControlName].value ? this.formatAmount(this.form?.controls[this.formControlName].value) : '';
      this.form?.controls[this.formControlName].valueChanges.subscribe(value => {
        this.virtualValue = this.formatAmount(value);
        if (this.input && this.input.nativeElement) {
          this.input.nativeElement.value = this.virtualValue;
        }
      });
    }
    onFocusClicked() {
      this.input?.nativeElement.focus();
    }
    clean($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.stopImmediatePropagation();
      if (this.form) {
        this.form.controls[this.formControlName].setValue(null);
        this.virtualValue = '';
      }
    }
    amountKeyDown($event) {
      if (this.hasRialStickyText()) {
        const keyCode = $event.keyCode || $event.which;
        const valueWithoutRial = $event.target.value.replace(' ریال', '');
        if (/(digit|numpad)/.test($event.code) || keyCode === 8) {
          this.virtualValue = valueWithoutRial.slice(0, -1);
          $event.target.value = this.virtualValue ? `${this.virtualValue} ریال` : '';
          return;
        }
        this.virtualValue = valueWithoutRial;
      }
      const code = $event.key.charCodeAt(0);
      const isZero = [48, 1632, 1776].indexOf(code) >= 0;
      if (isZero && $event.target.value.length === 0) {
        $event.preventDefault();
        return;
      }
    }
    formatAmount(val) {
      val = convertNonEnglishDigits(val);
      val = removeAllNonNumericCharacters(val);
      return priceFormat(val);
    }
    inputChangeHandler(val) {
      if (!this.form) {
        return;
      }
      val = convertNonEnglishDigits(val);
      val = removeAllNonNumericCharacters(val);
      this.form.controls[this.formControlName].setValue(val, {
        emitEvent: true
      });
      this.form.controls[this.formControlName].markAsTouched();
    }
    static {
      this.ɵfac = function DgAmountComponent_Factory(t) {
        return new (t || DgAmountComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgAmountComponent,
        selectors: [["app-dg-amount"]],
        viewQuery: function DgAmountComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusButton = _t.first);
          }
        },
        inputs: {
          maxSize: "maxSize",
          currencyUnit: "currencyUnit"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 1,
        consts: [["focusButton", ""], ["input", ""], [4, "ngIf"], [2, "display", "none", 3, "click"], [1, "dg-amount-input-wrapper", 3, "ngClass"], [3, "htmlFor"], ["class", "dg-required-star", 4, "ngIf"], [3, "formGroup"], ["inputMode", "numeric", "pattern", "\\d*", 3, "focusin", "focusout", "ngModelChange", "keydown", "id", "placeholder", "ngModel", "maxLength", "ngModelOptions", "readonly"], [1, "dg-currency-icon", 3, "ngClass"], [1, "dg-clean-icon", 3, "click"], ["class", "dg-hint-message", 4, "ngIf"], ["class", "dg-error-message", 4, "ngIf"], [1, "dg-required-star"], [1, "dg-hint-message"], [1, "dg-error-message"]],
        template: function DgAmountComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, DgAmountComponent_ng_container_0_Template, 12, 23, "ng-container", 2);
            i0.ɵɵelementStart(1, "button", 3, 0);
            i0.ɵɵlistener("click", function DgAmountComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusClicked());
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.PatternValidator, i2.FormGroupDirective, i2.NgModel],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dg-amount-input-wrapper[_ngcontent-%COMP%]{width:100%;border:1px solid #C9CBCF;background-color:#fff;border-radius:12px;position:relative;overflow:hidden;transition:all .3s}.dg-amount-input-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:absolute;color:#000;margin:0;background-color:#fff;top:22px;right:10px;font-size:14px;line-height:1;transition:all .3s;z-index:1}.dg-amount-input-wrapper[_ngcontent-%COMP%]   label.float-top[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{top:11px;right:10px;font-size:10px;line-height:1}.dg-amount-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{display:block;width:100%;background-color:transparent;border:1px solid transparent;padding:18px 8px 8px;font-size:14px;line-height:20px;direction:rtl;text-align:right}.dg-amount-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:rtl;text-align:right;transition:all .3s;opacity:0;font-size:14px;line-height:20px}.dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{resize:none}.dg-amount-input-wrapper[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:none;width:20px;height:20px;margin:0;padding:0;position:absolute;left:36px;top:18px;background-image:url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M8 8L16 16\" stroke=\"%23424C5C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M16 8L8 16\" stroke=\"%23424C5C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-size:100% 100%;background-repeat:no-repeat;cursor:pointer}.dg-amount-input-wrapper[_ngcontent-%COMP%]   .dg-currency-icon[_ngcontent-%COMP%]{width:20px;height:20px;margin:0;padding:0;position:absolute;left:8px;top:18px;background-size:100% 100%;background-repeat:no-repeat;cursor:pointer}.dg-amount-input-wrapper[_ngcontent-%COMP%]   .dg-currency-icon.rial[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">%0D%0A    <defs>%0D%0A        <path id=\"a\" d=\"M9.5 5h-1a.5.5 0 0 0-.5.5V17H4v-6.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5m12 5h-1a.5.5 0 0 0-.5.5V17h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5m-10 6h7a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V14h-4V5.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5m5 1h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5\"/>%0D%0A    </defs>%0D%0A    <g fill=\"none\" fill-rule=\"evenodd\">%0D%0A        <path d=\"M0 0h24v24H0z\"/>%0D%0A        <mask id=\"b\" fill=\"%23fff\">%0D%0A            <use xlink:href=\"%23a\"/>%0D%0A        </mask>%0D%0A        <g fill=\"%23000\" fill-opacity=\".7\" mask=\"url(%23b)\">%0D%0A            <path d=\"M0 0h24v24H0z\"/>%0D%0A        </g>%0D%0A    </g>%0D%0A</svg>%0D%0A')}.dg-amount-input-wrapper[_ngcontent-%COMP%]   .dg-currency-icon.toman[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"UTF-8\"?>%0D%0A<svg width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">%0D%0A    <title>toman</title>%0D%0A    <defs>%0D%0A        <rect id=\"path-1\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>%0D%0A        <rect id=\"path-3\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>%0D%0A        <path d=\"M4.58823529,11.6470588 C4.39341176,11.6470588 4.23529412,11.8051765 4.23529412,12 L4.23529412,16.5882353 L1.41176471,16.5882353 L1.41176471,12 C1.41176471,11.8051765 1.25364706,11.6470588 1.05882353,11.6470588 L0.352941176,11.6470588 C0.158117647,11.6470588 0,11.8051765 0,12 L0,17.6470588 C0,17.8418824 0.158117647,18 0.352941176,18 L5.29411765,18 C5.48894118,18 5.64705882,17.8418824 5.64705882,17.6470588 L5.64705882,12 C5.64705882,11.8051765 5.48894118,11.6470588 5.29411765,11.6470588 L4.58823529,11.6470588 Z M19.1647059,11.6470588 C19.4960767,11.6470588 19.7647059,11.915688 19.7647059,12.2470588 L19.764,14.47 L22.5882353,14.4705882 L22.5882353,12 C22.5882353,11.8051765 22.7463529,11.6470588 22.9411765,11.6470588 L22.9411765,11.6470588 L23.6470588,11.6470588 C23.8418824,11.6470588 24,11.8051765 24,12 L24,12 L24,15.5294118 C24,15.7242353 23.8418824,15.8823529 23.6470588,15.8823529 L23.6470588,15.8823529 L19.764,15.882 L19.7647059,17.4 C19.7647059,17.7313708 19.4960767,18 19.1647059,18 L18.9529412,18 C18.6215703,18 18.3529412,17.7313708 18.3529412,17.4 L18.352,15.882 L15.8823529,15.8823529 C15.7118824,15.8823529 15.5695147,15.7612941 15.5365864,15.6005129 L15.5294118,15.5294118 L15.5294118,12 C15.5294118,11.8051765 15.6875294,11.6470588 15.8823529,11.6470588 L15.8823529,11.6470588 L19.1647059,11.6470588 Z M18.3529412,13.0588235 L16.941,13.058 L16.9411765,14.4705882 L18.352,14.47 L18.3529412,13.0588235 Z M14.4705882,11.6470588 C14.6654118,11.6470588 14.8235294,11.8051765 14.8235294,12 L14.8235294,15.5294118 C14.8235294,15.7242353 14.6654118,15.8823529 14.4705882,15.8823529 L7.41176471,15.8823529 C7.21694118,15.8823529 7.05882353,15.7242353 7.05882353,15.5294118 L7.05882353,6.35294118 C7.05882353,6.15811765 7.21694118,6 7.41176471,6 L8.11764706,6 C8.31247059,6 8.47058824,6.15811765 8.47058824,6.35294118 L8.47058824,14.4705882 L10.588,14.47 L10.5882353,12.2470588 C10.5882353,11.915688 10.8568644,11.6470588 11.1882353,11.6470588 L14.4705882,11.6470588 Z M12,14.47 L13.4117647,14.4705882 L13.411,13.058 L12,13.058 L12,14.47 Z M23.6470588,8.82352941 L20.1176471,8.82352941 C19.9228235,8.82352941 19.7647059,8.98164706 19.7647059,9.17647059 L19.7647059,9.88235294 C19.7647059,10.0771765 19.9228235,10.2352941 20.1176471,10.2352941 L23.6470588,10.2352941 C23.8418824,10.2352941 24,10.0771765 24,9.88235294 L24,9.17647059 C24,8.98164706 23.8418824,8.82352941 23.6470588,8.82352941 M3.41176471,8.82352941 L2.23529412,8.82352941 C2.17035294,8.82352941 2.11764706,8.98164706 2.11764706,9.17647059 L2.11764706,9.88235294 C2.11764706,10.0771765 2.17035294,10.2352941 2.23529412,10.2352941 L3.41176471,10.2352941 C3.47670588,10.2352941 3.52941176,10.0771765 3.52941176,9.88235294 L3.52941176,9.17647059 C3.52941176,8.98164706 3.47670588,8.82352941 3.41176471,8.82352941\" id=\"path-5\"></path>%0D%0A    </defs>%0D%0A    <g id=\"App-Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">%0D%0A        <g id=\"toman\">%0D%0A            <g id=\"Bounds\">%0D%0A                <mask id=\"mask-2\" fill=\"white\">%0D%0A                    <use xlink:href=\"%23path-1\"></use>%0D%0A                </mask>%0D%0A                <g id=\"Mask\"></g>%0D%0A                <mask id=\"mask-4\" fill=\"white\">%0D%0A                    <use xlink:href=\"%23path-3\"></use>%0D%0A                </mask>%0D%0A                <g id=\"Border\"></g>%0D%0A            </g>%0D%0A            <mask id=\"mask-6\" fill=\"white\">%0D%0A                <use xlink:href=\"%23path-5\"></use>%0D%0A            </mask>%0D%0A            <use id=\"Mask\" fill=\"%23000\" xlink:href=\"%23path-5\"></use>%0D%0A            <g id=\"\\1f3a8-Color\" mask=\"url(%23mask-6)\" fill=\"%23000\">%0D%0A                <g transform=\"translate(0.000000, -1.000000)\" id=\"Surface\">%0D%0A                    <rect x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect>%0D%0A                </g>%0D%0A            </g>%0D%0A        </g>%0D%0A    </g>%0D%0A</svg>%0D%0A')}.dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:rtl;text-align:right}.dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:ltr;text-align:left}.dg-amount-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:ltr;text-align:left}.dg-amount-input-wrapper.dg-not-empty[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#fff}.dg-amount-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#000;background-color:#fff}.dg-amount-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]{padding-left:36px}.dg-amount-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:block}.dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]{border-color:#1159fc;background-color:#deedff}.dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#74777c;background-color:#deedff}.dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{opacity:1}.dg-amount-input-wrapper.dg-error[_ngcontent-%COMP%]{border-color:#f9441f;background-color:#fff}.dg-amount-input-wrapper.dg-error[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{background-color:#fff}.dg-amount-input-wrapper.dg-readonly[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#f2f3f6}.dg-amount-input-wrapper.dg-readonly[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#b4b7bd;background-color:#f2f3f6}"]
      });
    }
  }
  return DgAmountComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgIbanComponent = /*#__PURE__*/(() => {
  class DgIbanComponent extends BaseFieldType {
    constructor() {
      super();
      this.virtualValue = '';
      this.id = 'dg-iban-' + Math.floor(Math.random() * 10000);
      effect(() => {
        if (this.autoFocus()) {
          this.focusButton.nativeElement.click();
        }
      });
    }
    ngOnInit() {
      this.virtualValue = this.form?.controls[this.formControlName].value ? this.formatIban(this.form?.controls[this.formControlName].value) : '';
      this.form?.controls[this.formControlName].valueChanges.subscribe(value => {
        this.virtualValue = this.formatIban(value);
        if (this.input && this.input.nativeElement) {
          this.input.nativeElement.value = this.virtualValue;
        }
      });
    }
    onFocusClicked() {
      this.input?.nativeElement.focus();
    }
    clean($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.stopImmediatePropagation();
      if (this.form) {
        this.form.controls[this.formControlName].setValue(null);
        this.virtualValue = '';
      }
    }
    inputChangeHandler(val) {
      if (!this.form) {
        return;
      }
      val = convertNonEnglishDigits(val);
      val = removeAllNonNumericCharacters(val);
      this.form.controls[this.formControlName].setValue('IR' + val, {
        emitEvent: true
      });
      this.form.controls[this.formControlName].markAsTouched();
    }
    formatIban(val) {
      val = convertNonEnglishDigits(val);
      // remove white spaces
      // remove all non-numeric characters
      val = removeAllNonNumericCharacters(val);
      // add whitespaces (format) if
      // the length was more than 4 characters
      return splitString(val, [2, 2, 20]).join(' ');
    }
    onFocusIn() {
      this.isFocused = true;
      if (!this.form) {
        return;
      }
      const val = this.form.controls[this.formControlName].value;
      if (!val) {
        this.form.controls[this.formControlName].setValue('IR');
      }
    }
    onFocusOut() {
      this.isFocused = false;
      if (!this.form) {
        return;
      }
      const val = this.form.controls[this.formControlName].value;
      if (val === 'IR') {
        this.form.controls[this.formControlName].setValue('');
        this.virtualValue = '';
      }
    }
    static {
      this.ɵfac = function DgIbanComponent_Factory(t) {
        return new (t || DgIbanComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgIbanComponent,
        selectors: [["app-dg-iban"]],
        viewQuery: function DgIbanComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusButton = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 1,
        consts: [["focusButton", ""], ["input", ""], [4, "ngIf"], [2, "display", "none", 3, "click"], [1, "dg-amount-input-wrapper", 3, "ngClass"], [3, "htmlFor", 4, "ngIf"], [3, "formGroup"], ["pattern", "[0-9]*", 3, "ngModelChange", "focusin", "focusout", "id", "placeholder", "maxLength", "ngModel", "ngModelOptions", "readonly"], [1, "static-ir"], [1, "dg-ir-icon"], ["class", "dg-hint-message", 4, "ngIf"], ["class", "dg-error-message", 4, "ngIf"], [3, "htmlFor"], ["class", "dg-required-star", 4, "ngIf"], [1, "dg-required-star"], [1, "dg-hint-message"], [1, "dg-error-message"]],
        template: function DgIbanComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, DgIbanComponent_ng_container_0_Template, 11, 21, "ng-container", 2);
            i0.ɵɵelementStart(1, "button", 3, 0);
            i0.ɵɵlistener("click", function DgIbanComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusClicked());
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.PatternValidator, i2.FormGroupDirective, i2.NgModel],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dg-amount-input-wrapper[_ngcontent-%COMP%]{width:100%;border:1px solid #C9CBCF;background-color:#fff;border-radius:12px;position:relative;overflow:hidden;transition:all .3s}.dg-amount-input-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:absolute;color:#000;margin:0;background-color:#fff;top:22px;right:10px;font-size:14px;line-height:1;transition:all .3s;z-index:1}.dg-amount-input-wrapper[_ngcontent-%COMP%]   label.float-top[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{top:11px;right:10px;font-size:10px;line-height:1}.dg-amount-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{display:block;width:100%;background-color:transparent;border:1px solid transparent;padding:18px 8px 8px;font-size:14px;line-height:20px;direction:ltr;text-align:left}.dg-amount-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:rtl;text-align:right;transition:all .3s;opacity:0;font-size:14px;line-height:20px}.dg-amount-input-wrapper[_ngcontent-%COMP%]   .static-ir[_ngcontent-%COMP%]{position:absolute;left:11px;top:50%;transform:translateY(-50%);width:32px;height:32px;border-radius:8px;background-color:#f2f5f8;display:grid;place-content:center}.dg-amount-input-wrapper[_ngcontent-%COMP%]   .static-ir[_ngcontent-%COMP%]   .dg-ir-icon[_ngcontent-%COMP%]{width:12px;height:12px;margin:0;padding:0;background-image:url('data:image/svg+xml,<svg width=\"13\" height=\"11\" viewBox=\"0 0 13 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<g id=\"IR\">%0D%0A<path id=\"Letter\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.08968 6.82107H8.63499L10.4001 10.76H12.4821V10.6565L10.4454 6.25942C10.704 6.1264 10.9368 5.96875 11.1437 5.78646C11.3506 5.60417 11.5273 5.39109 11.6739 5.14721C11.8204 4.90334 11.9325 4.62498 12.0101 4.31213C12.0877 3.99928 12.1265 3.64579 12.1265 3.25165C12.1265 2.71956 12.0467 2.25152 11.8873 1.84753C11.7278 1.44353 11.4993 1.10482 11.2019 0.831387C10.9045 0.557952 10.5402 0.351031 10.1092 0.210618C9.67813 0.0702053 9.19105 0 8.64793 0H5.14996V10.76H7.08968V6.82107ZM8.65445 5.02528H7.08974V1.79581H8.64798C9.16955 1.79581 9.55642 1.94114 9.80858 2.23182C10.0607 2.5225 10.1868 2.92156 10.1868 3.42902C10.1868 3.67043 10.1545 3.88844 10.0898 4.08305C10.0252 4.27765 9.92927 4.44516 9.80211 4.58557C9.67495 4.72599 9.51547 4.83437 9.32365 4.91074C9.13183 4.9871 8.90877 5.02528 8.65445 5.02528Z\" fill=\"%23424C5C\"/>%0D%0A<path id=\"Letter_2\" d=\"M2.95038 10.76H0.750732V0H2.95038V10.76Z\" fill=\"%23424C5C\"/>%0D%0A</g>%0D%0A</svg>%0D%0A');background-size:100% 100%;background-repeat:no-repeat}.dg-amount-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{resize:none}.dg-amount-input-wrapper[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:none;width:20px;height:20px;margin:0;padding:0;position:absolute;left:8px;top:18px;background-image:url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path d=\"M8 8L16 16\" stroke=\"%23424C5C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M16 8L8 16\" stroke=\"%23424C5C\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</svg>%0D%0A');background-size:100% 100%;background-repeat:no-repeat;cursor:pointer}.dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:rtl;text-align:right}.dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:ltr;text-align:left}.dg-amount-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-amount-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:ltr;text-align:left}.dg-amount-input-wrapper.dg-not-empty[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#fff}.dg-amount-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#000;background-color:#fff}.dg-amount-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]{padding-left:36px}.dg-amount-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:block}.dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]{border-color:#1159fc;background-color:#deedff}.dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#74777c;background-color:#deedff}.dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-amount-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{opacity:1}.dg-amount-input-wrapper.dg-error[_ngcontent-%COMP%]{border-color:#f9441f;background-color:#fff}.dg-amount-input-wrapper.dg-error[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{background-color:#fff}.dg-amount-input-wrapper.dg-error[_ngcontent-%COMP%]   .static-ir[_ngcontent-%COMP%]{background-color:#ffeef3}.dg-amount-input-wrapper.dg-error[_ngcontent-%COMP%]   .static-ir[_ngcontent-%COMP%]   .dg-ir-icon[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml,<svg width=\"13\" height=\"11\" viewBox=\"0 0 13 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<g id=\"IR\">%0D%0A<path id=\"Letter\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.08968 6.82107H8.63499L10.4001 10.76H12.4821V10.6565L10.4454 6.25942C10.704 6.1264 10.9368 5.96875 11.1437 5.78646C11.3506 5.60417 11.5273 5.39109 11.6739 5.14721C11.8204 4.90334 11.9325 4.62498 12.0101 4.31213C12.0877 3.99928 12.1265 3.64579 12.1265 3.25165C12.1265 2.71956 12.0467 2.25152 11.8873 1.84753C11.7278 1.44353 11.4993 1.10482 11.2019 0.831387C10.9045 0.557952 10.5402 0.351031 10.1092 0.210618C9.67813 0.0702053 9.19105 0 8.64793 0H5.14996V10.76H7.08968V6.82107ZM8.65445 5.02528H7.08974V1.79581H8.64798C9.16955 1.79581 9.55642 1.94114 9.80858 2.23182C10.0607 2.5225 10.1868 2.92156 10.1868 3.42902C10.1868 3.67043 10.1545 3.88844 10.0898 4.08305C10.0252 4.27765 9.92927 4.44516 9.80211 4.58557C9.67495 4.72599 9.51547 4.83437 9.32365 4.91074C9.13183 4.9871 8.90877 5.02528 8.65445 5.02528Z\" fill=\"%23FF2638\"/>%0D%0A<path id=\"Letter_2\" d=\"M2.95038 10.76H0.750732V0H2.95038V10.76Z\" fill=\"%23FF2638\"/>%0D%0A</g>%0D%0A</svg>%0D%0A')}.dg-amount-input-wrapper.dg-readonly[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#f2f3f6}.dg-amount-input-wrapper.dg-readonly[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#b4b7bd;background-color:#f2f3f6}.dg-not-have-label[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-not-have-label[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{padding:13px}"]
      });
    }
  }
  return DgIbanComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgLargeAmountComponent = /*#__PURE__*/(() => {
  class DgLargeAmountComponent extends BaseFieldType {
    constructor() {
      super();
      this.placeholder = '0';
      this.maxSize = 10;
      this.minAmount = 0;
      this.maxAmount = 0;
      this.cdr = inject(ChangeDetectorRef);
      this.virtualValue = '';
      this.id = 'dg-large-amount-' + Math.floor(Math.random() * 10000);
      this.convertorValue = '';
      this.rangeError = false;
      effect(() => {
        if (this.autoFocus()) {
          this.focusButton.nativeElement.click();
        }
      });
    }
    ngOnInit() {
      this.virtualValue = this.form?.controls[this.formControlName].value ? this.formatAmount(this.form?.controls[this.formControlName].value) : '';
      this.form?.controls[this.formControlName].valueChanges.subscribe(value => {
        if (value) {
          this.virtualValue = this.formatAmount(value);
          if (this.input && this.input.nativeElement) {
            this.input.nativeElement.value = this.virtualValue;
          }
          this.setDescriptor(value);
        }
      });
    }
    ngAfterViewInit() {
      setTimeout(() => {
        const amount = +removeAllNonNumericCharacters(this.virtualValue);
        this.setDescriptor(amount);
      }, 0);
    }
    onFocusClicked() {
      this.input?.nativeElement.focus();
    }
    wrapperClick() {
      this.input?.nativeElement.focus();
    }
    formatAmount(val) {
      let temp = convertNonEnglishDigits(val);
      temp = removeAllNonNumericCharacters(temp);
      return priceFormat(temp);
    }
    onInputPaste($event) {
      // @ts-ignore
      const clipboardData = $event.clipboardData || window.clipboardData;
      let pastedText = clipboardData.getData('text');
      pastedText = convertNonEnglishDigits(pastedText);
      pastedText = removeAllNonNumericCharacters(pastedText);
      if (!pastedText ||
      // prevent empty string
      isNaN(+pastedText)) {
        // text is not a number
        $event.preventDefault();
        return;
      }
    }
    onInputKeyDown($event) {
      if ($event.key === '0' && this.virtualValue === '') {
        $event.preventDefault();
      }
      let key = $event.key;
      if (key === 'Backspace' || $event.code === '8') {
        // allow deleting
        return;
      }
      if (['ArrowLeft', 'ArrowRight'].indexOf(key) >= 0) {
        return;
      }
      if (!key) {
        return;
      }
      // first convert the value to support FA digits
      key = convertNonEnglishDigits($event.key);
      if (isNaN(+key)) {
        // entered key is not a number
        $event.preventDefault();
        return;
      }
    }
    onValueChanged($event) {
      if (!this.form) {
        return;
      }
      const value = convertNonEnglishDigits($event);
      this.virtualValue = value;
      const amount = +removeAllNonNumericCharacters(value);
      this.form.controls[this.formControlName].setValue(amount, {
        emitEvent: true
      });
      this.setDescriptor(amount);
      this.cdr.detectChanges();
    }
    setDescriptor(amount) {
      this.convertorValue = '';
      if ((amount < this.minAmount || amount > this.maxAmount) && amount !== 0) {
        this.rangeError = true;
        return;
      }
      this.rangeError = false;
      if (amount && amount >= 10) {
        amount /= 10;
        const main = Math.floor(amount);
        const decimal = Number((amount - main).toFixed(2));
        const rial = decimal.toString().split('.')[1];
        this.convertorValue = numberAmountToWords(main) + ' ' + 'تومان';
        if (rial && rial !== '0') {
          this.convertorValue += ' و ' + rial + ' ریال ';
        }
      }
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function DgLargeAmountComponent_Factory(t) {
        return new (t || DgLargeAmountComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgLargeAmountComponent,
        selectors: [["app-dg-large-amount"]],
        viewQuery: function DgLargeAmountComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusButton = _t.first);
          }
        },
        inputs: {
          placeholder: "placeholder",
          maxSize: "maxSize",
          minAmount: "minAmount",
          maxAmount: "maxAmount"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 1,
        consts: [["focusButton", ""], ["input", ""], ["valuePlaceholder", ""], [4, "ngIf"], [2, "display", "none", 3, "click"], [1, "ui-amount-input", 3, "click", "ngClass"], [1, "unit"], [3, "formGroup"], ["type", "text", "maxlength", "10", "inputMode", "numeric", "pattern", "\\d*", 3, "paste", "keydown", "focusin", "focusout", "ngModelChange", "ngModel", "placeholder", "maxlength", "ngModelOptions", "readonly"], [1, "invisible-value-placeholder"], [1, "invisible-value"], [1, "hint"], ["class", "hint-text", 3, "ngClass", 4, "ngIf"], ["class", "hint-text", 4, "ngIf"], [1, "hint-text", 3, "ngClass"], [1, "hint-text"]],
        template: function DgLargeAmountComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, DgLargeAmountComponent_ng_container_0_Template, 13, 15, "ng-container", 3);
            i0.ɵɵelementStart(1, "button", 4, 0);
            i0.ɵɵlistener("click", function DgLargeAmountComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusClicked());
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.MaxLengthValidator, i2.PatternValidator, i2.FormGroupDirective, i2.NgModel, i3.IranianRialsPipe],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}[_nghost-%COMP%]{display:block}.ui-amount-input[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;direction:ltr;height:56px}.ui-amount-input[_ngcontent-%COMP%]   .unit[_ngcontent-%COMP%]{font-size:18px;font-weight:600;color:#000}.ui-amount-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:100%;border:none;width:auto;padding:0;min-width:50px;font-size:32px;font-weight:400;margin-left:4px;text-align:left;direction:ltr;box-shadow:none}.ui-amount-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{box-shadow:none;outline:none}.hint[_ngcontent-%COMP%]{text-align:center;min-height:40px;font-size:12px;font-weight:450;direction:rtl}.hint[_ngcontent-%COMP%]   .hint-text[_ngcontent-%COMP%]{display:inline-block;border-radius:12px;padding:8px 12px;color:#45474ad9;background:#f2f3f6}.hint[_ngcontent-%COMP%]   .hint-text.has-error[_ngcontent-%COMP%]{color:#f9441f;background:#ffe9e3}.ui-amount-input.dg-readonly[_ngcontent-%COMP%]{opacity:.25;cursor:not-allowed}.invisible-value-placeholder[_ngcontent-%COMP%]{opacity:1;position:absolute;z-index:-1;width:0;height:0;overflow:hidden}.invisible-value-placeholder[_ngcontent-%COMP%]   .invisible-value[_ngcontent-%COMP%]{font-size:32px;font-weight:400}"]
      });
    }
  }
  return DgLargeAmountComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DgCardNumberComponent = /*#__PURE__*/(() => {
  class DgCardNumberComponent extends BaseFieldType {
    constructor() {
      super();
      this.virtualValue = '';
      this.id = 'dg-card-number-' + Math.floor(Math.random() * 10000);
      effect(() => {
        if (this.autoFocus()) {
          this.focusButton.nativeElement.click();
        }
      });
    }
    ngOnInit() {
      this.virtualValue = this.form?.controls[this.formControlName].value ? this.formatCardNumber(this.form?.controls[this.formControlName].value) : '';
      this.form?.controls[this.formControlName].valueChanges.subscribe(value => {
        this.virtualValue = this.formatCardNumber(value);
        if (this.input && this.input.nativeElement) {
          this.input.nativeElement.value = this.virtualValue;
        }
      });
    }
    onFocusClicked() {
      this.input?.nativeElement.focus();
    }
    clean($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.stopImmediatePropagation();
      if (this.form) {
        this.form.controls[this.formControlName].setValue(null);
        this.virtualValue = '';
      }
    }
    inputChangeHandler(val) {
      if (!this.form) {
        return;
      }
      val = convertNonEnglishDigits(val);
      val = removeAllNonNumericCharacters(val);
      this.form.controls[this.formControlName].setValue(val, {
        emitEvent: true
      });
      this.form.controls[this.formControlName].markAsTouched();
    }
    formatCardNumber(val) {
      val = convertNonEnglishDigits(val);
      // remove white spaces
      // remove all non-numeric characters
      val = removeAllNonNumericCharacters(val);
      // add whitespaces (format) if
      // the length was more than 4 characters
      return splitString(val, [4, 4, 4, 4]).join(' ');
    }
    static {
      this.ɵfac = function DgCardNumberComponent_Factory(t) {
        return new (t || DgCardNumberComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DgCardNumberComponent,
        selectors: [["app-dg-card-number"]],
        viewQuery: function DgCardNumberComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusButton = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 1,
        consts: [["focusButton", ""], ["input", ""], [4, "ngIf"], [2, "display", "none", 3, "click"], [1, "dg-card-number-input-wrapper", 3, "ngClass"], [3, "htmlFor", 4, "ngIf"], [3, "formGroup"], ["inputMode", "numeric", "pattern", "\\d*", 3, "ngModelChange", "focusin", "focusout", "id", "placeholder", "maxLength", "ngModel", "ngModelOptions", "readonly"], [1, "dg-clean-icon", 3, "click"], ["class", "dg-hint-message", 4, "ngIf"], ["class", "dg-error-message", 4, "ngIf"], [3, "htmlFor"], ["class", "dg-required-star", 4, "ngIf"], [1, "dg-required-star"], [1, "dg-hint-message"], [1, "dg-error-message"]],
        template: function DgCardNumberComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, DgCardNumberComponent_ng_container_0_Template, 10, 21, "ng-container", 2);
            i0.ɵɵelementStart(1, "button", 3, 0);
            i0.ɵɵlistener("click", function DgCardNumberComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusClicked());
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.PatternValidator, i2.FormGroupDirective, i2.NgModel],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dg-card-number-input-wrapper[_ngcontent-%COMP%]{width:100%;border:1px solid #C9CBCF;background-color:#fff;border-radius:12px;position:relative;overflow:hidden;transition:all .3s}.dg-card-number-input-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{position:absolute;color:#000;margin:0;background-color:#fff;top:22px;right:10px;font-size:14px;line-height:1;transition:all .3s;z-index:1}.dg-card-number-input-wrapper[_ngcontent-%COMP%]   label.float-top[_ngcontent-%COMP%], .dg-card-number-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%], .dg-card-number-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{top:11px;right:10px;font-size:10px;line-height:1}.dg-card-number-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-card-number-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{display:block;width:100%;background-color:transparent;border:1px solid transparent;padding:18px 8px 8px;font-size:14px;line-height:20px;direction:ltr;text-align:right}.dg-card-number-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-card-number-input-wrapper[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-card-number-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-card-number-input-wrapper[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:rtl;text-align:right;transition:all .3s;opacity:0;font-size:14px;line-height:20px}.dg-card-number-input-wrapper[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:none;width:20px;height:20px;margin:0;padding:0;position:absolute;left:8px;top:18px;background-image:url('data:image/svg+xml,<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<g clip-path=\"url(%23clip0_13718_450)\">%0D%0A<mask id=\"mask0_13718_450\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\">%0D%0A<path d=\"M5 5L15 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A<path d=\"M15 5L5 15\" stroke=\"black\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>%0D%0A</mask>%0D%0A<g mask=\"url(%23mask0_13718_450)\">%0D%0A<rect width=\"20\" height=\"20\" fill=\"black\"/>%0D%0A</g>%0D%0A</g>%0D%0A<defs>%0D%0A<clipPath id=\"clip0_13718_450\">%0D%0A<rect width=\"20\" height=\"20\" fill=\"white\"/>%0D%0A</clipPath>%0D%0A</defs>%0D%0A</svg>%0D%0A');background-size:100% 100%;background-repeat:no-repeat;cursor:pointer}.dg-card-number-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-card-number-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:rtl;text-align:right}.dg-card-number-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-card-number-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-card-number-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-card-number-input-wrapper.dg-ltr-placeholder[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{direction:ltr;text-align:left}.dg-card-number-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-card-number-input-wrapper.dg-ltr-input[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{direction:ltr;text-align:left}.dg-card-number-input-wrapper.dg-not-empty[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#fff}.dg-card-number-input-wrapper.dg-not-empty[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#000;background-color:#fff}.dg-card-number-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]{padding-left:36px}.dg-card-number-input-wrapper.dg-not-empty.dg-cleanable[_ngcontent-%COMP%]   .dg-clean-icon[_ngcontent-%COMP%]{display:block}.dg-card-number-input-wrapper.dg-focused[_ngcontent-%COMP%]{border-color:#1159fc;background-color:#deedff}.dg-card-number-input-wrapper.dg-focused[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#74777c;background-color:#deedff}.dg-card-number-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::placeholder, .dg-card-number-input-wrapper.dg-focused[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:placeholder-shown, .dg-card-number-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]::placeholder, .dg-card-number-input-wrapper.dg-focused[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]:placeholder-shown{opacity:1}.dg-card-number-input-wrapper.dg-error[_ngcontent-%COMP%]{border-color:#f9441f;background-color:#fff}.dg-card-number-input-wrapper.dg-error[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{background-color:#fff}.dg-card-number-input-wrapper.dg-readonly[_ngcontent-%COMP%]{border-color:#c9cbcf;background-color:#f2f3f6}.dg-card-number-input-wrapper.dg-readonly[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#b4b7bd;background-color:#f2f3f6}.dg-not-have-label[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .dg-not-have-label[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{padding:13px}"]
      });
    }
  }
  return DgCardNumberComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * FormFieldComponent Component
 * @property {FormFieldType} type Set field type (default: "input")
 * @property {String} label Show top of field
 * @property {String} placeholder Show when field is empty
 * @property {String | Boolean} errorMessage Show bottom of field if has truly value
 * @property {{[key: string]: string}} errorMessageMapper You can change default error messages
 * @property {ValidationErrors} validation errors of the form control
 * @property {Boolean} readonly User can't edit field if be true
 * @property {Boolean} hasCleaner Show cleaner action for reset field value
 * @property {Boolean} ltrInput Change field direction to ltr if true (default: false)
 * @property {Boolean} ltrPlaceholder Change placeholder direction to ltr if true (default: false)
 * @property {Boolean} multiLine Set true if you need textarea (Only for 'input' type)
 * @property {FormFieldInputType} inputType Set type of input field (Only for 'input' type - default: text)
 * @property {DatePickerConfigInterface} datePickerConfig Set date view based on (day, month, years) (Only for 'date category' type)
 * @property {DateRangeType} dateRange Set range of date that client can select (Only for 'date category' type)
 * @property {showError} showError has 3 values: default: auto = show error when we get error, show = always show error, hidden = always hidden error
 * @property {CurrencyUnit} unitCurrency possibility to declare the currency type for the amount field (Only for 'amount' type)
 * @property {Boolean} datePickerMode possibility to define date picker open in bottom sheet or modal
 * @property {Void} cleanEvent When click to clear input (If hasCleaner is true)
 * @property {String} pattern pattern of the input
 * @property {TemplateRef<any>} leadingIcon Leading icon in the right direction of input
 * @property {TemplateRef<any>} trailingIcon Trailing icon in the left direction of input
 *
 * Only For Select Type
 * @property {Boolean} multiSelect 'select' fields can be multi selectable if true
 * @property {{title: string;value?: any;children?: FormFieldOption[];}} options Set 'select' options
 * @property {Boolean} overflowToContainer 'select' fields can be overflow to container (Only for 'select' type)
 * @property {Boolean} searchable possibility of search in select input, and default is true
 * @property {String} notFoundText Display when the 'select' option is empty
 * @property {SelectOpenType} selectOpenType How 'select' open type (BottomSheet or Dropdown) (default: 'dropDown')
 * @property {Boolean} isDividerOptions Divider between options (default: 'false')
 * @property {Boolean} showRadioOptions Has radio checkmark on 'select' (Just don't use it in multiple options) (default: 'false')
 * @property {Boolean} hasSelectAll Has selectAll options on 'select' (Just use it in multiple options) (default: 'false')
 * @property {DropdownPosition} dropdownPosition How to open the dropdown position (default: 'auto')
 * @property {Boolean} selectBreakIfOutOfLine Break line if out of box select options (default: 'true')

 *
 * @example
 *    <ui-form-field
 *      label="Name"
 *      formControlName="name"
 *      [errorMessage]="Name is required"
 *    ></ui-form-field>
 */
let FormFieldComponent = /*#__PURE__*/(() => {
  class FormFieldComponent {
    constructor(formBuilder) {
      this.formBuilder = formBuilder;
      this.type = 'input';
      this.label = '';
      this.hint = '';
      this.hasHintStar = false;
      this.hintStatus = 'warning';
      this.leadingIcon = input();
      this.trailingIcon = input();
      this.hasRialStickyText = input(false);
      this.hasValidationMark = false;
      this.hasButton = false;
      this.placeholder = '';
      this.errorMessageMapper = {};
      this.readonly = false;
      this.lock = false;
      this.hasCleaner = false;
      this.ltrInput = false;
      this.ltrPlaceholder = false;
      this.required = false;
      this.pattern = input();
      // input type
      this.multiLine = false;
      this.maxSize = 99999;
      this.inputType = 'text';
      this.showError = 'auto';
      // patterns
      this.unitCurrency = 'rial';
      // select type
      /**
       * 'select' fields can be multi selectable if true
       */
      this.multiSelect = false;
      /**
       * Set 'select' options
       */
      this.options = [];
      /**
       * possibility of search in select input
       * (default: `true`)
       */
      this.searchable = true;
      /**
       * Display when the 'select' option is empty
       * (default: `موردی یافت نشد`)
       */
      this.notFoundText = 'موردی یافت نشد';
      /**
       * How 'select' open type (`BottomSheet` or `Dropdown`)
       * (default: `dropDown`)
       */
      this.selectOpenType = input('dropDown');
      /**
       * Divider between options
       * (default: `false`)
       */
      this.isDividerOptions = input(false);
      /**
       * Has radio checkmark on 'select'
       * (Just don't use it in multiple options)
       * (default: `false`)
       */
      this.showRadioOptions = input(false);
      /**
       * Has selectAll options on 'select'
       * (Just use it in multiple options)
       * (default: `false`)
       */
      this.hasSelectAll = input(false);
      /**
       * How to open the dropdown position (default: `auto`)
       */
      this.dropdownPosition = input('auto');
      /**
       * Break line if out of box select options (default: `true`)
       */
      this.selectBreakIfOutOfLine = input(true);
      this.selectBottomSheetCloseBtn = input(false);
      this.selectBottomSheetMaxHeight = input(null);
      this.overflowToContainer = false;
      // date type
      this.dateRange = 'all';
      this.initialCalendarView = 'years';
      this.datePickerMode = 'auto';
      /**
       * Set date view based on (day, month, years)
       * (Only for 'date category' type)
       */
      this.datePickerConfig = input();
      this.searchOptionsSelect = new EventEmitter();
      // large amount type
      this.minAmount = 0;
      this.maxAmount = 0;
      this.autoFocus = input();
      /**
       * When click to clear input
       * (If hasCleaner is `true`)
       */
      this.cleanEvent = output();
      this.defaultErrorMessageMapper = {
        required: 'این فیلد اجباری است',
        pattern: 'عبارت وارد شده نامعتبر است',
        email: 'ورودی باید در قالب ایمیل باشد',
        max: 'عدد ورودی بیشتر از حد مجاز است',
        min: 'عدد ورودی کمتر از حد مجاز است',
        maxlength: 'عبارت وارد شده طولانی است',
        minlength: 'عبارت وارد شده کوتاه است'
      };
      this.allowedKeyDown = input => true;
      this.propagateChange = _ => {};
      this.propagateTouch = () => {};
    }
    ngOnInit() {
      this.form = this.formBuilder.group({
        input: [this.value, [], this.validator.bind(this)]
      });
      const inputFormControl = this.form.get('input');
      if (inputFormControl) {
        inputFormControl.valueChanges.subscribe(value => {
          this.propagateChange(value);
          this.propagateTouch();
        });
      }
    }
    ngOnChanges(changes) {
      if (changes['error'] && JSON.stringify(changes['error'].currentValue) !== JSON.stringify(changes['error'].previousValue) && this.form) {
        this.form.controls['input'].updateValueAndValidity({
          emitEvent: false
        });
      }
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouch = fn;
    }
    writeValue(obj) {
      if (this.form && obj !== undefined) {
        const inputFormControl = this.form.get('input');
        if (inputFormControl) {
          inputFormControl.setValue(obj);
        }
      }
    }
    validator(control) {
      return new Promise(resolve => {
        setTimeout(() => {
          const isError = this.updateErrorMessageAndGetErrorStatus();
          resolve(isError ? {
            error: true
          } : null);
        }, 0);
      });
    }
    updateErrorMessageAndGetErrorStatus() {
      if (this.errorMessage) {
        this.finalErrorMessage = typeof this.errorMessage === 'string' ? this.errorMessage : null;
        return true;
      }
      if (this.error && Object.keys(this.error) && Object.keys(this.error).length) {
        for (const errorKey in this.error) {
          if (this.error.hasOwnProperty(errorKey) && this.error[errorKey]) {
            this.finalErrorMessage = this.errorMessageMapper && this.errorMessageMapper.hasOwnProperty(errorKey) ? this.errorMessageMapper[errorKey] : this.defaultErrorMessageMapper[errorKey];
            return true;
          }
        }
      }
      this.finalErrorMessage = null;
      return false;
    }
    emitSearch(event) {
      this.searchOptionsSelect.emit(event);
    }
    clearEvent() {
      this.cleanEvent.emit();
    }
    static {
      this.ɵfac = function FormFieldComponent_Factory(t) {
        return new (t || FormFieldComponent)(i0.ɵɵdirectiveInject(i2.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormFieldComponent,
        selectors: [["ui-form-field"]],
        inputs: {
          type: "type",
          label: "label",
          hint: "hint",
          hasHintStar: "hasHintStar",
          hintStatus: "hintStatus",
          leadingIcon: [i0.ɵɵInputFlags.SignalBased, "leadingIcon"],
          trailingIcon: [i0.ɵɵInputFlags.SignalBased, "trailingIcon"],
          hasRialStickyText: [i0.ɵɵInputFlags.SignalBased, "hasRialStickyText"],
          hasValidationMark: "hasValidationMark",
          hasButton: "hasButton",
          placeholder: "placeholder",
          errorMessage: "errorMessage",
          errorMessageMapper: "errorMessageMapper",
          error: "error",
          readonly: "readonly",
          lock: "lock",
          hasCleaner: "hasCleaner",
          ltrInput: "ltrInput",
          ltrPlaceholder: "ltrPlaceholder",
          required: "required",
          pattern: [i0.ɵɵInputFlags.SignalBased, "pattern"],
          multiLine: "multiLine",
          maxSize: "maxSize",
          inputType: "inputType",
          autoComplete: "autoComplete",
          isNumericKeyboard: "isNumericKeyboard",
          convertNonEnglishDigits: "convertNonEnglishDigits",
          showError: "showError",
          unitCurrency: "unitCurrency",
          multiSelect: "multiSelect",
          options: "options",
          searchable: "searchable",
          notFoundText: "notFoundText",
          selectOpenType: [i0.ɵɵInputFlags.SignalBased, "selectOpenType"],
          isDividerOptions: [i0.ɵɵInputFlags.SignalBased, "isDividerOptions"],
          showRadioOptions: [i0.ɵɵInputFlags.SignalBased, "showRadioOptions"],
          hasSelectAll: [i0.ɵɵInputFlags.SignalBased, "hasSelectAll"],
          dropdownPosition: [i0.ɵɵInputFlags.SignalBased, "dropdownPosition"],
          selectBreakIfOutOfLine: [i0.ɵɵInputFlags.SignalBased, "selectBreakIfOutOfLine"],
          selectBottomSheetCloseBtn: [i0.ɵɵInputFlags.SignalBased, "selectBottomSheetCloseBtn"],
          selectBottomSheetMaxHeight: [i0.ɵɵInputFlags.SignalBased, "selectBottomSheetMaxHeight"],
          overflowToContainer: "overflowToContainer",
          dateRange: "dateRange",
          customDateRange: "customDateRange",
          initialCalendarView: "initialCalendarView",
          datePickerMode: "datePickerMode",
          datePickerConfig: [i0.ɵɵInputFlags.SignalBased, "datePickerConfig"],
          minAmount: "minAmount",
          maxAmount: "maxAmount",
          autoFocus: [i0.ɵɵInputFlags.SignalBased, "autoFocus"],
          allowedKeyDown: "allowedKeyDown"
        },
        outputs: {
          searchOptionsSelect: "searchOptionsSelect",
          cleanEvent: "cleanEvent"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => FormFieldComponent),
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c3,
        decls: 10,
        vars: 9,
        consts: [[1, "dg-form-field"], [4, "ngIf"], [3, "cleanEvent", "form", "label", "hint", "hasHintStar", "hintStatus", "hasValidationMark", "hasButton", "placeholder", "errorMessage", "lock", "leadingIcon", "trailingIcon", "readonly", "multiLine", "inputType", "hasCleaner", "ltrInput", "ltrPlaceholder", "maxSize", "autoComplete", "isNumericKeyboard", "required", "convertNonEnglishDigits", "showError", "allowedKeyDown", "autoFocus", "pattern"], [3, "form", "label", "hint", "placeholder", "errorMessage", "readonly", "hasCleaner", "ltrInput", "ltrPlaceholder", "maxSize", "required", "showError", "autoFocus", "currencyUnit", "hasRialStickyText"], [3, "form", "minAmount", "maxAmount", "maxSize", "readonly", "showError", "autoFocus"], [3, "form", "label", "hint", "placeholder", "errorMessage", "readonly", "hasCleaner", "ltrInput", "ltrPlaceholder", "required", "showError", "autoFocus"], [3, "searchOptionsSelect", "cleanEvent", "form", "label", "hint", "placeholder", "errorMessage", "readonly", "multiSelect", "options", "hasCleaner", "ltrInput", "ltrPlaceholder", "required", "searchable", "showError", "notFoundText", "selectOpenType", "isDivider", "showRadio", "dropdownPosition", "hasSelectAll", "bottomSheetCloseBtn", "bottomSheetMaxHeight", "overflowToContainer", "autoFocus", "breakIfOutOfLine"], [3, "form", "label", "hint", "placeholder", "errorMessage", "readonly", "options", "hasCleaner", "ltrInput", "ltrPlaceholder", "required", "showError"], [3, "form", "label", "hint", "required", "showError"], [3, "form", "label", "hint", "placeholder", "errorMessage", "readonly", "hasCleaner", "ltrInput", "ltrPlaceholder", "showTime", "endPicker", "datePickerMode", "dateRange", "customDateRange", "required", "showError", "autoFocus", "initialCalendarView", "datePickerConfig"]],
        template: function FormFieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FormFieldComponent_ng_container_1_Template, 3, 27, "ng-container", 1)(2, FormFieldComponent_ng_container_2_Template, 2, 15, "ng-container", 1)(3, FormFieldComponent_ng_container_3_Template, 2, 7, "ng-container", 1)(4, FormFieldComponent_ng_container_4_Template, 2, 12, "ng-container", 1)(5, FormFieldComponent_ng_container_5_Template, 2, 12, "ng-container", 1)(6, FormFieldComponent_ng_container_6_Template, 2, 25, "ng-container", 1)(7, FormFieldComponent_ng_container_7_Template, 2, 12, "ng-container", 1)(8, FormFieldComponent_ng_container_8_Template, 2, 5, "ng-container", 1)(9, FormFieldComponent_ng_container_9_Template, 2, 19, "ng-container", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "input");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "amount");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "large-amount");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "iban");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "card-number");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "select");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "wheel-select");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "slide-toggle");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "date" || ctx.type === "date-time" || ctx.type === "date-end");
          }
        },
        dependencies: [i1.NgIf, DgInputComponent, DgSelectComponent, DgSlideToggleComponent, DgDateComponent, DgWheelSelectComponent, DgAmountComponent, DgIbanComponent, DgLargeAmountComponent, DgCardNumberComponent],
        styles: [":root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:root .inverted{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark .inverted{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.dg-form-field{font-size:14px;line-height:1.6;direction:rtl}.dg-form-field *:focus-visible{outline:none}.dg-form-field *{box-sizing:border-box}.dg-form-field .full-width{width:100%}.dg-form-field .dg-hint-message{margin-right:10px;margin-top:4px;margin-left:0;font-size:10px;line-height:20px;min-height:20px;color:#45474ad9}.dg-form-field .dg-info-message{margin-right:10px;margin-top:4px;margin-left:0;font-size:10px;line-height:20px;min-height:20px;color:#1159fc}.dg-form-field .dg-error-message{margin-right:10px;margin-top:4px;margin-left:0;font-size:10px;line-height:20px;min-height:20px;color:#f9441f}.dg-form-field .dg-hint-star-message{margin-right:10px;margin-top:4px;margin-left:0;font-size:10px;line-height:20px;min-height:20px;color:#45474ad9;background-image:url('data:image/svg+xml,<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path id=\"Color\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 0C5.39449 0 5.71429 0.319797 5.71429 0.714286V3.275L7.52538 1.46447C7.80433 1.18552 8.25659 1.18552 8.53553 1.46447C8.81448 1.74341 8.81448 2.19567 8.53553 2.47462L6.72429 4.285L9.28571 4.28571C9.6802 4.28571 10 4.60551 10 5C10 5.39449 9.6802 5.71429 9.28571 5.71429L6.72357 5.71357L8.53553 7.52538C8.81448 7.80433 8.81448 8.25659 8.53553 8.53553C8.25659 8.81448 7.80433 8.81448 7.52538 8.53553L5.71429 6.72429V9.28571C5.71429 9.6802 5.39449 10 5 10C4.60551 10 4.28571 9.6802 4.28571 9.28571V6.72357L2.47462 8.53553C2.36733 8.64282 2.23441 8.70884 2.09557 8.7336L2.01171 8.74351H1.92738C1.75887 8.7336 1.59321 8.66428 1.46447 8.53553C1.18552 8.25659 1.18552 7.80433 1.46447 7.52538L3.27571 5.71357L0.714286 5.71429C0.319797 5.71429 0 5.39449 0 5C0 4.60551 0.319797 4.28571 0.714286 4.28571L3.275 4.285L1.46447 2.47462C1.18552 2.19567 1.18552 1.74341 1.46447 1.46447C1.74341 1.18552 2.19567 1.18552 2.47462 1.46447L4.28571 3.27571V0.714286C4.28571 0.319797 4.60551 0 5 0Z\" fill=\"%23DFAE00\"/>%0D%0A</svg>%0D%0A');background-position:right;padding-right:14px;background-repeat:no-repeat}.dg-form-field .dg-info-star-message{margin-right:10px;margin-top:4px;margin-left:0;font-size:10px;line-height:20px;min-height:20px;color:#1159fc;background-image:url('data:image/svg+xml,<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path id=\"Color\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 0C5.39449 0 5.71429 0.319797 5.71429 0.714286V3.275L7.52538 1.46447C7.80433 1.18552 8.25659 1.18552 8.53553 1.46447C8.81448 1.74341 8.81448 2.19567 8.53553 2.47462L6.72429 4.285L9.28571 4.28571C9.6802 4.28571 10 4.60551 10 5C10 5.39449 9.6802 5.71429 9.28571 5.71429L6.72357 5.71357L8.53553 7.52538C8.81448 7.80433 8.81448 8.25659 8.53553 8.53553C8.25659 8.81448 7.80433 8.81448 7.52538 8.53553L5.71429 6.72429V9.28571C5.71429 9.6802 5.39449 10 5 10C4.60551 10 4.28571 9.6802 4.28571 9.28571V6.72357L2.47462 8.53553C2.36733 8.64282 2.23441 8.70884 2.09557 8.7336L2.01171 8.74351H1.92738C1.75887 8.7336 1.59321 8.66428 1.46447 8.53553C1.18552 8.25659 1.18552 7.80433 1.46447 7.52538L3.27571 5.71357L0.714286 5.71429C0.319797 5.71429 0 5.39449 0 5C0 4.60551 0.319797 4.28571 0.714286 4.28571L3.275 4.285L1.46447 2.47462C1.18552 2.19567 1.18552 1.74341 1.46447 1.46447C1.74341 1.18552 2.19567 1.18552 2.47462 1.46447L4.28571 3.27571V0.714286C4.28571 0.319797 4.60551 0 5 0Z\" fill=\"%231159FC\"/>%0D%0A</svg>%0D%0A');background-position:right;padding-right:14px;background-repeat:no-repeat}.dg-form-field .dg-error-star-message{margin-right:10px;margin-top:4px;margin-left:0;font-size:10px;line-height:20px;min-height:20px;color:#f9441f;background-image:url('data:image/svg+xml,<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0D%0A<path id=\"Color\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 0C5.39449 0 5.71429 0.319797 5.71429 0.714286V3.275L7.52538 1.46447C7.80433 1.18552 8.25659 1.18552 8.53553 1.46447C8.81448 1.74341 8.81448 2.19567 8.53553 2.47462L6.72429 4.285L9.28571 4.28571C9.6802 4.28571 10 4.60551 10 5C10 5.39449 9.6802 5.71429 9.28571 5.71429L6.72357 5.71357L8.53553 7.52538C8.81448 7.80433 8.81448 8.25659 8.53553 8.53553C8.25659 8.81448 7.80433 8.81448 7.52538 8.53553L5.71429 6.72429V9.28571C5.71429 9.6802 5.39449 10 5 10C4.60551 10 4.28571 9.6802 4.28571 9.28571V6.72357L2.47462 8.53553C2.36733 8.64282 2.23441 8.70884 2.09556 8.7336L2.01171 8.74351H1.92738C1.75887 8.7336 1.59321 8.66428 1.46447 8.53553C1.18552 8.25659 1.18552 7.80433 1.46447 7.52538L3.27571 5.71357L0.714286 5.71429C0.319797 5.71429 0 5.39449 0 5C0 4.60551 0.319797 4.28571 0.714286 4.28571L3.275 4.285L1.46447 2.47462C1.18552 2.19567 1.18552 1.74341 1.46447 1.46447C1.74341 1.18552 2.19567 1.18552 2.47462 1.46447L4.28571 3.27571V0.714286C4.28571 0.319797 4.60551 0 5 0Z\" fill=\"%23F9441F\"/>%0D%0A</svg>%0D%0A');background-position:right;padding-right:14px;background-repeat:no-repeat}.dg-form-field .dg-required-star{color:#d82137}.dg-form-field input,.dg-form-field select,.dg-form-field option,.dg-form-field textarea{font-family:inherit}.dg-form-field .dg-field-warning{animation-name:dgFieldShakeX;animation-duration:.3s;animation-iteration-count:1;animation-timing-function:ease-in-out}@keyframes dgFieldShakeX{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-2px,0,0)}20%,40%,60%,80%{transform:translate3d(2px,0,0)}}\n"],
        encapsulation: 2
      });
    }
  }
  return FormFieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UiFormFieldBuilderModule = /*#__PURE__*/(() => {
  class UiFormFieldBuilderModule {
    static {
      this.ɵfac = function UiFormFieldBuilderModule_Factory(t) {
        return new (t || UiFormFieldBuilderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UiFormFieldBuilderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, NgSelectModule, FormsModule, NgxIcon, NgxButtonComponent, PipesModule]
      });
    }
  }
  return UiFormFieldBuilderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ui-form-field-builder
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FormFieldComponent, UiFormFieldBuilderModule };
